/* slick slider */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

/* api.jquery.js */
function floatToString(t,r){var e=t.toFixed(r).toString();return e.match(/^\.\d+/)?"0"+e:e}function attributeToString(t){return"string"!=typeof t&&"undefined"===(t+="")&&(t=""),jQuery.trim(t)}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.money_format="${{amount}}",Shopify.onError=function(t,r){var e=eval("("+t.responseText+")");e.message?alert(e.message+"("+e.status+"): "+e.description):alert("Error : "+Shopify.fullMessagesFromErrors(e).join("; ")+".")},Shopify.fullMessagesFromErrors=function(t){var o=[];return jQuery.each(t,function(e,t){jQuery.each(t,function(t,r){o.push(e+" "+r)})}),o},Shopify.onCartUpdate=function(t){alert("There are now "+t.item_count+" items in the cart.")},Shopify.onCartShippingRatesUpdate=function(t,r){var e="";r.zip&&(e+=r.zip+", "),r.province&&(e+=r.province+", "),e+=r.country,alert("There are "+t.length+" shipping rates available for "+e+", starting at "+Shopify.formatMoney(t[0].price)+".")},Shopify.onItemAdded=function(t){alert(t.title+" was added to your shopping cart.")},Shopify.onProduct=function(t){alert("Received everything we ever wanted to know about "+t.title)},Shopify.formatMoney=function(t,r){function n(t,r){return void 0===t?r:t}function e(t,r,e,o){if(r=n(r,2),e=n(e,","),o=n(o,"."),isNaN(t)||null==t)return 0;var a=(t=(t/100).toFixed(r)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?o+a[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",a=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(a)[1]){case"amount":o=e(t,2);break;case"amount_no_decimals":o=e(t,0);break;case"amount_with_comma_separator":o=e(t,2,".",",");break;case"amount_with_space_separator":o=e(t,2," ",",");break;case"amount_with_period_and_space_separator":o=e(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=e(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=e(t,0,".","");break;case"amount_with_space_separator":o=e(t,2,",","");break;case"amount_with_apostrophe_separator":o=e(t,2,"'",".")}return i.replace(a,o)},Shopify.resizeImage=function(t,r){try{if("original"==r)return t;var e=t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);return e[1]+"_"+r+"."+e[2]}catch(o){return t}},Shopify.addItem=function(t,r,e){var o={type:"POST",url:"/cart/add.js",data:"quantity="+(r=r||1)+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.addItemFromForm=function(t,r){var e={type:"POST",url:"/cart/add.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.getCart=function(r){jQuery.getJSON("/cart.js",function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)})},Shopify.pollForCartShippingRatesForDestination=function(o,a,t){t=t||Shopify.onError;var n=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(t,r,e){200===e.status?"function"==typeof a?a(t.shipping_rates,o):Shopify.onCartShippingRatesUpdate(t.shipping_rates,o):setTimeout(n,500)},error:t})};return n},Shopify.getCartShippingRatesForDestination=function(t,r,e){e=e||Shopify.onError;var o={type:"POST",url:"/cart/prepare_shipping_rates",data:Shopify.param({shipping_address:t}),success:Shopify.pollForCartShippingRatesForDestination(t,r,e),error:e};jQuery.ajax(o)},Shopify.getProduct=function(t,r){jQuery.getJSON("/products/"+t+".js",function(t){"function"==typeof r?r(t):Shopify.onProduct(t)})},Shopify.changeItem=function(t,r,e){var o={type:"POST",url:"/cart/change.js",data:"quantity="+r+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.removeItem=function(t,r){var e={type:"POST",url:"/cart/change.js",data:"quantity=0&id="+t,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.clear=function(r){var t={type:"POST",url:"/cart/clear.js",data:"",dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(t)},Shopify.updateCartFromForm=function(t,r){var e={type:"POST",url:"/cart/update.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartAttributes=function(t,r){var o="";jQuery.isArray(t)?jQuery.each(t,function(t,r){var e=attributeToString(r.key);""!==e&&(o+="attributes["+e+"]="+attributeToString(r.value)+"&")}):"object"==typeof t&&null!==t&&jQuery.each(t,function(t,r){o+="attributes["+attributeToString(t)+"]="+attributeToString(r)+"&"});var e={type:"POST",url:"/cart/update.js",data:o,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartNote=function(t,r){var e={type:"POST",url:"/cart/update.js",data:"note="+attributeToString(t),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},"1.4"<=jQuery.fn.jquery?Shopify.param=jQuery.param:(Shopify.param=function(t){var e=[],r=function(t,r){r=jQuery.isFunction(r)?r():r,e[e.length]=encodeURIComponent(t)+"="+encodeURIComponent(r)};if(jQuery.isArray(t)||t.jquery)jQuery.each(t,function(){r(this.name,this.value)});else for(var o in t)Shopify.buildParams(o,t[o],r);return e.join("&").replace(/%20/g,"+")},Shopify.buildParams=function(e,t,o){jQuery.isArray(t)&&t.length?jQuery.each(t,function(t,r){rbracket.test(e)?o(e,r):Shopify.buildParams(e+"["+("object"==typeof r||jQuery.isArray(r)?t:"")+"]",r,o)}):null!=t&&"object"==typeof t?Shopify.isEmptyObject(t)?o(e,""):jQuery.each(t,function(t,r){Shopify.buildParams(e+"["+t+"]",r,o)}):o(e,t)},Shopify.isEmptyObject=function(t){for(var r in t)return!1;return!0});


window.theme = window.theme || {};
window.slate = window.slate || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function(container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * Slate utilities
 */
slate.utils={getParameterByName:function(e,t){t||(t=window.location.href),e=e.replace(/[[\]]/g,"\\$&");var n=new RegExp("[?&]"+e+"(=([^&#]*)|&|#|$)").exec(t);return n?n[2]?decodeURIComponent(n[2].replace(/\+/g," ")):"":null},resizeSelects:function(e){e.forEach(function(e){var t=document.createElement("span");t.innerHTML=e.selectedOptions[0].label,document.querySelector(".site-footer").appendChild(t);var n=t.offsetWidth+55;t.remove(),e.style.width=n+"px"})},keyboardKeys:{TAB:9,ENTER:13,ESCAPE:27,LEFTARROW:37,RIGHTARROW:39}};

/**
 * iFrames
 */
slate.rte={wrapTable:function(e){e.tables.forEach(function(a){var r=document.createElement("div");r.classList.add(e.tableWrapperClass),a.parentNode.insertBefore(r,a),r.appendChild(a)})},wrapIframe:function(e){e.iframes.forEach(function(a){var r=document.createElement("div");r.classList.add(e.iframeWrapperClass),a.parentNode.insertBefore(r,a),r.appendChild(a),a.src=a.src})}};

/**
 * A11y Helpers
 */
slate.a11y={state:{firstFocusable:null,lastFocusable:null},pageLinkFocus:function(e){if(e){var t="js-focus-hidden";e.setAttribute("tabIndex","-1"),e.focus(),e.classList.add(t),e.addEventListener("blur",function(){e.classList.remove(t),e.removeAttribute("tabindex")},{once:!0})}},trapFocus:function(e){var t=Array.from(e.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function(e){var t=e.offsetWidth,n=e.offsetHeight;return 0!==t&&0!==n&&"none"!==getComputedStyle(e).getPropertyValue("display")});this.state.firstFocusable=t[0],this.state.lastFocusable=t[t.length-1],e.elementToFocus||(e.elementToFocus=e.container),e.container.setAttribute("tabindex","-1"),e.elementToFocus.focus(),this._setupHandlers(),document.addEventListener("focusin",this._onFocusInHandler),document.addEventListener("focusout",this._onFocusOutHandler)},_setupHandlers:function(){this._onFocusInHandler||(this._onFocusInHandler=this._onFocusIn.bind(this)),this._onFocusOutHandler||(this._onFocusOutHandler=this._onFocusIn.bind(this)),this._manageFocusHandler||(this._manageFocusHandler=this._manageFocus.bind(this))},_onFocusOut:function(){document.removeEventListener("keydown",this._manageFocusHandler)},_onFocusIn:function(e){e.target!==this.state.lastFocusable&&e.target!==this.state.firstFocusable||document.addEventListener("keydown",this._manageFocusHandler)},_manageFocus:function(e){e.keyCode===slate.utils.keyboardKeys.TAB&&(e.target!==this.state.lastFocusable||e.shiftKey||(e.preventDefault(),this.state.firstFocusable.focus()),e.target===this.state.firstFocusable&&e.shiftKey&&(e.preventDefault(),this.state.lastFocusable.focus()))},removeTrapFocus:function(e){e.container&&e.container.removeAttribute("tabindex"),document.removeEventListener("focusin",this._onFocusInHandler)},accessibleLinks:function(e){var t=document.querySelector("body"),n={newWindow:"a11y-new-window-message",external:"a11y-external-message",newWindowExternal:"a11y-new-window-external-message"};void 0!==e.links&&e.links.length||(e.links=document.querySelectorAll("a[href]:not([aria-describedby])")),e.links.forEach(function(e){var t=e.getAttribute("target"),s=e.getAttribute("rel"),a=function(e){var t=window.location.hostname;return e.hostname!==t}(e),i="_blank"===t;if(a&&e.setAttribute("aria-describedby",n.external),i){if(!s||-1===s.indexOf("noopener")){var o=void 0===s?"":s+" ";o+="noopener",e.setAttribute("rel",o)}e.setAttribute("aria-describedby",n.newWindow)}a&&i&&e.setAttribute("aria-describedby",n.newWindowExternal)}),function(e){"object"!=typeof e&&(e={});var s=Object.assign({newWindow:"Opens in a new window.",external:"Opens external website.",newWindowExternal:"Opens external website in a new window."},e),a=document.createElement("ul"),i="";for(var o in s)i+="<li id="+n[o]+">"+s[o]+"</li>";a.setAttribute("hidden",!0),a.innerHTML=i,t.appendChild(a)}(e.messages)}};
    
/**
 * Image Helper Functions
 *
 */
theme.Images=function(){return{preload:function(e,t){"string"==typeof e&&(e=[e]);for(var r=0;r<e.length;r++){var i=e[r];this.loadImage(this.getSizedImageUrl(i,t))}},loadImage:function(e){(new Image).src=e},switchImage:function(e,t,r){var i=this.imageSize(t.src),n=this.getSizedImageUrl(e.src,i);r?r(n,e,t):t.src=n},imageSize:function(e){var t=e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);return null!==t?void 0!==t[2]?t[1]+t[2]:t[1]:null},getSizedImageUrl:function(e,t){if(null===t)return e;if("master"===t)return this.removeProtocol(e);var r=e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!==r){var i=e.split(r[0]),n=r[0];return this.removeProtocol(i[0]+"_"+t+n)}return null},removeProtocol:function(e){return e.replace(/http(s)?:/,"")}}}();
    
/**
 * Currency Helpers
 *
 */
theme.Currency=function(){var a="${{amount}}";return{formatMoney:function(e,r){"string"==typeof e&&(e=e.replace(".",""));var t="",o=/\{\{\s*(\w+)\s*\}\}/,n=r||a;function c(a,e,r,t){if(r=r||",",t=t||".",isNaN(a)||null===a)return 0;var o=(a=(a/100).toFixed(e)).split(".");return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+r)+(o[1]?t+o[1]:"")}switch(n.match(o)[1]){case"amount":t=c(e,2);break;case"amount_no_decimals":t=c(e,0);break;case"amount_with_comma_separator":t=c(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":t=c(e,0,".",",");break;case"amount_no_decimals_with_space_separator":t=c(e,0," ");break;case"amount_with_apostrophe_separator":t=c(e,2,"'")}return n.replace(o,t)}}}();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.container = options.container;
    this.product = options.product;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.singleOptions = this.container.querySelectorAll(
      options.singleOptionSelector
    );
    this.currentVariant = this._getVariantFromOptions();

    this.singleOptions.forEach(
      function(option) {
        option.addEventListener('change', this._onSelectChange.bind(this));
      }.bind(this)
    );
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var result = [];

      this.singleOptions.forEach(function(option) {
        var type = option.getAttribute('type');
        var isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

        if (!isRadioOrCheckbox || option.checked) {
          result.push({
            value: option.value,
            index: option.getAttribute('data-index')
          });
        }
      });

      return result;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = variants.find(function(variant) {
        return selectedValues.every(function(values) {
          return variant[values.index] === values.value;
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.container.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      var masterSelect = this.container.querySelector(this.originalSelectorId);

      if (!masterSelect) return;
      masterSelect.value = variant.id;
    }
  });

  return Variants;
})();


window.theme = window.theme || {};

theme.TouchEvents = function TouchEvents(element, options) {
  this.axis;
  this.checkEvents = [];
  this.eventHandlers = {};
  this.eventModel = {};
  this.events = [
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
    ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'],
    ['mousedown', 'mousemove', 'mouseup']
  ];
  this.eventType;
  this.difference = {};
  this.direction;
  this.start = {};

  this.element = element;
  this.options = Object.assign(
    {},
    {
      dragThreshold: 10,
      start: function() {}, // eslint-disable-line
      move: function() {}, // eslint-disable-line
      end: function() {} // eslint-disable-line
    },
    options
  );

  this.checkEvents = this._getCheckEvents();
  this.eventModel = this._getEventModel();

  this._setupEventHandlers();
};

theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
  destroy: function() {
    this.element.removeEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    this.element.removeEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    if (!this.eventModel) {
      this.element.removeEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    this.element.removeEventListener('click', this.eventHandlers.preventClick);
  },

  _setupEventHandlers: function() {
    this.eventHandlers.preventDefault = this._preventDefault.bind(this);
    this.eventHandlers.preventClick = this._preventClick.bind(this);
    this.eventHandlers.touchStart = this._touchStart.bind(this);
    this.eventHandlers.touchMove = this._touchMove.bind(this);
    this.eventHandlers.touchEnd = this._touchEnd.bind(this);

    // Prevent element from dragging when using mouse
    this.element.addEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    // Bind the touchstart/pointerdown event
    this.element.addEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    // Bind mousedown if necessary
    if (!this.eventModel) {
      this.element.addEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    // No clicking during touch
    this.element.addEventListener('click', this.eventHandlers.preventClick);
  },

  _touchStart: function(event) {
    this.eventType = this.eventModel;

    if (event.type === 'mousedown' && !this.eventModel) {
      this.eventType = 2;
    }

    if (this.checkEvents[this.eventType](event)) return;
    if (this.eventType) this._preventDefault(event);

    document.addEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.addEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.addEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    this.start = {
      xPosition: this.eventType ? event.clientX : event.touches[0].clientX,
      yPosition: this.eventType ? event.clientY : event.touches[0].clientY,
      time: new Date().getTime()
    };

    // Ensure we empty out the this.difference object
    Object.keys(this.difference).forEach(
      function(key) {
        delete this.difference[key];
      }.bind(this)
    );

    this.options.start(event);
  },

  _touchMove: function(event) {
    this.difference = this._getDifference(event);

    // Prevent document from scrolling during swipe gesture
    document['on' + this.events[this.eventType][1]] = function(event) {
      this._preventDefault(event);
    }.bind(this);

    // Get the direction user is dragging
    if (!this.axis) {
      if (this.options.dragThreshold < Math.abs(this.difference.xPosition)) {
        this.axis = 'xPosition';
      } else if (
        this.options.dragThreshold < Math.abs(this.difference.yPosition)
      ) {
        this.axis = 'yPosition';
      } else {
        this.axis = false;
      }
    } else if (this.axis === 'xPosition') {
      this.direction = this.difference.xPosition < 0 ? 'left' : 'right';
    } else if (this.axis === 'yPosition') {
      this.direction = this.difference.yPosition < 0 ? 'up' : 'down';
    }

    this.options.move(event, this.direction, this.difference);
  },

  _touchEnd: function(event) {
    document.removeEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.removeEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.removeEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    // Re-enable document scrolling
    document['on' + this.events[this.eventType][1]] = function() {
      return true;
    };

    this.options.end(event, this.direction, this.difference);
    this.axis = false;
  },

  _getDifference: function(event) {
    return {
      xPosition:
        (this.eventType ? event.clientX : event.touches[0].clientX) -
        this.start.xPosition,
      yPosition:
        (this.eventType ? event.clientY : event.touches[0].clientY) -
        this.start.yPosition,
      time: new Date().getTime() - this.start.time
    };
  },

  _getCheckEvents: function() {
    return [
      // Touch events
      function(event) {
        // Skip the event if it's a multi-touch or pinch move
        return (
          (event.touches && event.touches.length > 1) ||
          (event.scale && event.scale !== 1)
        );
      },
      // Pointer events
      function(event) {
        // Skip it, if:
        // 1. The event is not primary (other pointers during multi-touch),
        // 2. Left mouse button is not pressed,
        // 3. Event is not a touch event
        return (
          !event.isPrimary ||
          (event.buttons && event.buttons !== 1) ||
          (event.pointerType !== 'touch' && event.pointerType !== 'pen')
        );
      },
      // Mouse events
      function(event) {
        // Skip the event if left mouse button is not pressed
        return event.buttons && event.buttons !== 1;
      }
    ];
  },

  _getEventModel: function() {
    return window.navigator.pointerEnabled ? 1 : 0;
  },

  _preventDefault: function(event) {
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
  },

  _preventClick: function(event) {
    if (Math.abs(this.difference.xPosition) > this.options.dragThreshold) {
      this._preventDefault(event);
    }
  }
});


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var DEFAULT_OPEN_CLASS = 'js-drawer-open';
    var DEFAULT_CLOSE_CLASS = 'js-drawer-close';

    var defaults = {
      selectors: {
        openVariant: '.' + DEFAULT_OPEN_CLASS + '-' + position,
        close: '.' + DEFAULT_CLOSE_CLASS
      },
      classes: {
        open: DEFAULT_OPEN_CLASS,
        openVariant: DEFAULT_OPEN_CLASS + '-' + position
      },
      withPredictiveSearch: false
    };

    this.nodes = {
      parents: [document.documentElement, document.body],
      page: document.getElementById('PageContainer')
    };

    this.eventHandlers = {};

    this.config = Object.assign({}, defaults, options);
    this.position = position;
    this.drawer = document.getElementById(id);

    if (!this.drawer) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    document
      .querySelector(this.config.selectors.openVariant)
      .addEventListener('click', this.open.bind(this));
    this.drawer
      .querySelector(this.config.selectors.close)
      .addEventListener('click', this.close.bind(this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget;
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function(parent) {
        parent.classList.add(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    this.drawerIsOpen = true;

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'true');
    }

    // Set focus on drawer
    var trapFocusConfig = {
      container: this.drawer
    };

    if (this.config.elementToFocusOnOpen) {
      trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
    }

    slate.a11y.trapFocus(trapFocusConfig);

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    document.activeElement.dispatchEvent(
      new CustomEvent('blur', { bubbles: true, cancelable: true })
    );

    // Ensure closing transition is applied to moved elements, like the nav
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function(parent) {
        parent.classList.remove(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      container: this.drawer
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.eventHandlers.drawerKeyupHandler = function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }.bind(this);

    this.eventHandlers.drawerTouchmoveHandler = function() {
      return false;
    };

    this.eventHandlers.drawerClickHandler = function() {
      this.close();
      return false;
    }.bind(this);

    // Add event listener to document body
    document.body.addEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );

    // Lock scrolling on mobile
    this.nodes.page.addEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );

    this.nodes.page.addEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.page.removeEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );
    this.nodes.page.removeEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
    document.body.removeEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );
  };

  return Drawer;
})();

theme.Helpers = (function() {
  var touchDevice = false;

  var classes = {
    preventScrolling: 'prevent-scrolling'
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function() {
      var context = this,
        args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      var prior = beforeEl || document.getElementsByTagName('script')[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      'transitionend',
      function(event) {
        event.currentTarget.classList.remove('is-transitioning');
      },
      { once: true }
    );

    var properties = [
      'transition-duration',
      '-moz-transition-duration',
      '-webkit-transition-duration',
      '-o-transition-duration'
    ];

    var duration = 0;

    properties.forEach(function(property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, '');
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === 'undefined') {
      this.stylesheetPromise = new Promise(function(resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener('load', function() {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet
  };
})();

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();

    cache.parents.forEach(function(element) {
      element.addEventListener('click', submenuParentClickHandler);
    });

    // check when we're leaving a dropdown and close the active dropdown
    cache.siteNavChildLink.forEach(function(element) {
      element.addEventListener('focusout', submenuFocusoutHandler);
    });

    cache.topLevel.forEach(function(element) {
      element.addEventListener('focus', hideDropdown);
    });

    cache.subMenuLinks.forEach(function(element) {
      element.addEventListener('click', stopImmediatePropagation);
    });

    window.addEventListener('resize', resizeHandler);
  }

  function stopImmediatePropagation(event) {
    event.stopImmediatePropagation();
  }

  function cacheSelectors() {
    var navigation = document.querySelector(selectors.navigation);

    cache = {
      nav: navigation,
      topLevel: document.querySelectorAll(selectors.siteNavLinkMain),
      parents: navigation.querySelectorAll(selectors.siteNavHasDropdown),
      subMenuLinks: document.querySelectorAll(selectors.siteNavChildLinks),
      activeDropdown: document.querySelector(selectors.siteNavActiveDropdown),
      siteHeader: document.querySelector(selectors.siteHeader),
      siteNavChildLink: document.querySelectorAll(selectors.siteNavChildLink)
    };
  }

  function showDropdown(element) {
    element.classList.add(config.activeClass);

    if (cache.activeDropdown) hideDropdown();

    cache.activeDropdown = element;

    element
      .querySelector(selectors.siteNavLinkMain)
      .setAttribute('aria-expanded', 'true');

    setTimeout(function() {
      window.addEventListener('keyup', keyUpHandler);
      document.body.addEventListener('click', hideDropdown);
    }, 250);
  }

  function hideDropdown() {
    if (!cache.activeDropdown) return;

    cache.activeDropdown
      .querySelector(selectors.siteNavLinkMain)
      .setAttribute('aria-expanded', 'false');
    cache.activeDropdown.classList.remove(config.activeClass);

    cache.activeDropdown = document.querySelector(
      selectors.siteNavActiveDropdown
    );

    window.removeEventListener('keyup', keyUpHandler);
    document.body.removeEventListener('click', hideDropdown);
  }

  function styleDropdowns(dropdownListItems) {
    dropdownListItems.forEach(function(item) {
      var dropdownLi = item.querySelector(selectors.siteNavDropdown);

      if (!dropdownLi) return;

      if (isRightOfLogo(item)) {
        dropdownLi.classList.remove(config.leftDropdownClass);
        dropdownLi.classList.add(config.rightDropdownClass);
      } else {
        dropdownLi.classList.remove(config.rightDropdownClass);
        dropdownLi.classList.add(config.leftDropdownClass);
      }
    });
  }

  function isRightOfLogo(item) {
    var rect = item.getBoundingClientRect();
    var win = item.ownerDocument.defaultView;
    var leftOffset = rect.left + win.pageXOffset;

    var headerWidth = Math.floor(cache.siteHeader.offsetWidth) / 2;
    return leftOffset > headerWidth;
  }

  function positionFullWidthDropdowns() {
    document
      .querySelectorAll(selectors.siteNavHasCenteredDropdown)
      .forEach(function(el) {
        var fullWidthDropdown = el.querySelector(
          selectors.siteNavCenteredDropdown
        );

        var fullWidthDropdownOffset = el.offsetTop + 41;
        fullWidthDropdown.style.top = fullWidthDropdownOffset + 'px';
      });
  }

  function keyUpHandler(event) {
    if (event.keyCode === 27) hideDropdown();
  }

  function resizeHandler() {
    adjustStyleAndPosition();
  }

  function submenuParentClickHandler(event) {
    var element = event.currentTarget;

    element.classList.contains(config.activeClass)
      ? hideDropdown()
      : showDropdown(element);
  }

  function submenuFocusoutHandler() {
    setTimeout(function() {
      if (
        document.activeElement.classList.contains(config.childLinkClass) ||
        !cache.activeDropdown
      ) {
        return;
      }

      hideDropdown();
    });
  }

  var adjustStyleAndPosition = theme.Helpers.debounce(function() {
    styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();
  }, 50);

  function unload() {
    cache.topLevel.forEach(function(element) {
      element.removeEventListener('focus', hideDropdown);
    });

    cache.subMenuLinks.forEach(function(element) {
      element.removeEventListener('click', stopImmediatePropagation);
    });

    cache.parents.forEach(function(element) {
      element.removeEventListener('click', submenuParentClickHandler);
    });

    cache.siteNavChildLink.forEach(function(element) {
      element.removeEventListener('focusout', submenuFocusoutHandler);
    });

    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('keyup', keyUpHandler);
    document.body.removeEventListener('click', hideDropdown);
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };

  var cache = {};
  var isTransitioning;
  var activeSubNav;
  var activeTrigger;
  var menuLevel = 1;
  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';
  var mql = window.matchMedia(mediumUpQuery);

  function init() {
    cacheSelectors();

    if (cache.mobileNavToggle) {
      cache.mobileNavToggle.addEventListener('click', toggleMobileNav);
    }

    cache.subNavToggleBtns.forEach(function(element) {
      element.addEventListener('click', toggleSubNav);
    });

    mql.addListener(initBreakpoints);
  }

  function initBreakpoints() {
    if (
      mql.matches &&
      cache.mobileNavContainer.classList.contains(classes.navOpen)
    ) {
      closeMobileNav();
    }
  }

  function toggleMobileNav() {
    var mobileNavIsOpen = cache.mobileNavToggle.classList.contains(
      classes.mobileNavCloseIcon
    );

    if (mobileNavIsOpen) {
      closeMobileNav();
      document.body.classList.remove('mobileNavOpened');
    } else {
      openMobileNav();
      document.body.classList.add('mobileNavOpened');
    }
  }

  function cacheSelectors() {
    cache = {
      pageContainer: document.querySelector('#PageContainer'),
      siteHeader: document.querySelector('.site-header'),
      mobileNavToggle: document.querySelector('.js-mobile-nav-toggle'),
      mobileNavContainer: document.querySelector('.mobile-nav-wrapper'),
      mobileNav: document.querySelector('#MobileNav'),
      sectionHeader: document.querySelector('#shopify-section-header'),
      subNavToggleBtns: document.querySelectorAll('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.siteHeader.offsetHeight;

    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.add(classes.navOpen);
    // document.querySelector('#pop-club-quick-buy3').style.display = 'none';

    cache.mobileNavContainer.style.transform =
      'translate(0, ' + translateHeaderHeight + 'px)';

    //cache.pageContainer.style.transform =
      //'translate3d(0, ' + cache.mobileNavContainer.scrollHeight + 'px, 0)';

    slate.a11y.trapFocus({
      container: cache.sectionHeader,
      elementToFocus: cache.mobileNavToggle
    });

    cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.setAttribute('aria-expanded', true);

    window.addEventListener('keyup', keyUpHandler);
  }

  function keyUpHandler(event) {
    if (event.which === 27) {
      closeMobileNav();
    }
  }

  function closeMobileNav() {
    var translateHeaderHeight = cache.siteHeader.offsetHeight;
    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.remove(classes.navOpen);
    // document.querySelector('#pop-club-quick-buy3').style.display = 'block';
    cache.mobileNavContainer.style.transform = 'translate(-100%, ' + translateHeaderHeight + 'px)';
    cache.pageContainer.setAttribute('style', '');

    slate.a11y.trapFocus({
      container: document.querySelector('html'),
      elementToFocus: document.body
    });

    cache.mobileNavContainer.addEventListener(
      'transitionend',
      mobileNavRemoveTrapFocus,
      { once: true }
    );

    cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.setAttribute('aria-expanded', false);
    cache.mobileNavToggle.focus();

    window.removeEventListener('keyup', keyUpHandler);
    window.scrollTo(0, 0);
  }

  function mobileNavRemoveTrapFocus() {
    slate.a11y.removeTrapFocus({
      container: cache.mobileNav
    });
  }

  function toggleSubNav(event) {
    if (isTransitioning) return;

    var toggleBtn = event.currentTarget;
    var isReturn = toggleBtn.classList.contains(classes.return);

    isTransitioning = true;

    if (isReturn) {
      var subNavToggleBtn = document.querySelectorAll(
        '.' + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']"
      );

      subNavToggleBtn.forEach(function(element) {
        element.classList.remove(classes.subNavActive);
      });

      if (activeTrigger) {
        activeTrigger.classList.remove(classes.subNavActive);
      }
    } else {
      toggleBtn.classList.add(classes.subNavActive);
    }

    activeTrigger = toggleBtn;

    goToSubnav(toggleBtn.getAttribute('data-target'));
  }

  function goToSubnav(target) {
    var targetMenu = target
      ? document.querySelector(
          '.mobile-nav__dropdown[data-parent="' + target + '"]'
        )
      : cache.mobileNav;

    menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1;

    if (activeSubNav) {
      theme.Helpers.prepareTransition(activeSubNav);
      activeSubNav.classList.add(classes.subNavClosing);
    }

    activeSubNav = targetMenu;

    var translateMenuHeight = targetMenu.offsetHeight;

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.mobileNavContainer.style.height = translateMenuHeight + 'px';
    cache.mobileNavContainer.classList.remove(classes.thirdNavShowing);
    cache.mobileNavContainer.classList.add(openNavClass);

    if (!target) {
      cache.mobileNavContainer.classList.remove(
        classes.thirdNavShowing,
        classes.subNavShowing
      );
    }

    /* if going back to first subnav, focus is on whole header */
    var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;

    cache.mobileNavContainer.addEventListener(
      'transitionend',
      trapMobileNavFocus,
      { once: true }
    );

    function trapMobileNavFocus() {
      slate.a11y.trapFocus({
        container: container
      });

      cache.mobileNavContainer.removeEventListener(
        'transitionend',
        trapMobileNavFocus
      );

      isTransitioning = false;
    }

    // Match height of subnav
    cache.pageContainer.style.transform =
      'translateY(' + translateMenuHeight + 'px)';

    activeSubNav.classList.remove(classes.subNavClosing);
  }

  function unload() {
    mql.removeListener(initBreakpoints);
  }

  return {
    init: init,
    unload: unload,
    closeMobileNav: closeMobileNav
  };
})();

window.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closeModalOnClick: false
    };

    this.modal = document.getElementById(id);

    if (!this.modal) return false;

    this.nodes = {
      parents: [document.querySelector('html'), document.body]
    };

    this.config = Object.assign(defaults, options);

    this.modalIsOpen = false;

    this.focusOnOpen = this.config.focusOnOpen
      ? document.getElementById(this.config.focusOnOpen)
      : this.modal;

    this.openElement = document.querySelector(this.config.open);
    this.init();
  }

  Modal.prototype.init = function() {
    this.openElement.addEventListener('click', this.open.bind(this));

    this.modal
      .querySelector(this.config.close)
      .addEventListener('click', this.closeModal.bind(this));
  };

  Modal.prototype.open = function(evt) {
    var self = this;
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    if (this.modalIsOpen) return;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    if (this.modalIsOpen && !externalCall) {
      this.closeModal();
    }

    this.modal.classList.add(this.config.openClass);

    this.nodes.parents.forEach(function(node) {
      node.classList.add(self.config.openClass);
    });

    this.modalIsOpen = true;

    slate.a11y.trapFocus({
      container: this.modal,
      elementToFocus: this.focusOnOpen
    });

    this.bindEvents();
  };

  Modal.prototype.closeModal = function() {
    if (!this.modalIsOpen) return;

    document.activeElement.blur();

    this.modal.classList.remove(this.config.openClass);

    var self = this;

    this.nodes.parents.forEach(function(node) {
      node.classList.remove(self.config.openClass);
    });

    this.modalIsOpen = false;

    slate.a11y.removeTrapFocus({
      container: this.modal
    });

    this.openElement.focus();

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    this.keyupHandler = this.keyupHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    document.body.addEventListener('keyup', this.keyupHandler);
    document.body.addEventListener('click', this.clickHandler);
  };

  Modal.prototype.unbindEvents = function() {
    document.body.removeEventListener('keyup', this.keyupHandler);
    document.body.removeEventListener('click', this.clickHandler);
  };

  Modal.prototype.keyupHandler = function(event) {
    if (event.keyCode === 27) {
      this.closeModal();
    }
  };

  Modal.prototype.clickHandler = function(event) {
    if (this.config.closeModalOnClick && !this.modal.contains(event.target)) {
      this.closeModal();
    }
  };

  return Modal;
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var backButton = document.querySelector(selectors.backButton);

  if (!document.referrer || !backButton || !window.history.length) {
    return;
  }

  backButton.addEventListener(
    'click',
    function(evt) {
      evt.preventDefault();

      var referrerDomain = urlDomain(document.referrer);
      var shopDomain = urlDomain(window.location.href);

      if (shopDomain === referrerDomain) {
        history.back();
      }

      return false;
    },
    { once: true }
  );

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();


window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    var statusMessages = document.querySelectorAll(selectors.statusMessage);

    statusMessages.forEach(function(statusMessage) {
      statusMessage.setAttribute('tabindex', -1);
      statusMessage.focus();

      statusMessage.addEventListener(
        'blur',
        function(evt) {
          evt.target.removeAttribute('tabindex');
        },
        { once: true }
      );
    });
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.SearchDrawer = (function() {
  var selectors = {
    headerSection: '[data-header-section]',
    drawer: '[data-predictive-search-drawer]',
    drawerOpenButton: '[data-predictive-search-open-drawer]',
    headerSearchInput: '[data-predictive-search-drawer-input]',
    predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]'
  };

  var drawerInstance;

  function init() {
    setAccessibilityProps();

    drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: function() {
        setHeight();
        theme.MobileNav.closeMobileNav();
        lockBodyScroll();
      },
      onDrawerClose: function() {
        theme.SearchHeader.clearAndClose();
        var drawerOpenButton = document.querySelector(
          selectors.drawerOpenButton
        );

        if (drawerOpenButton) drawerOpenButton.focus();

        unlockBodyScroll();
      },
      withPredictiveSearch: true,
      elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput)
    });
  }

  function setAccessibilityProps() {
    var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

    if (drawerOpenButton) {
      drawerOpenButton.setAttribute('aria-controls', 'SearchDrawer');
      drawerOpenButton.setAttribute('aria-expanded', 'false');
      drawerOpenButton.setAttribute('aria-controls', 'dialog');
    }
  }

  function setHeight() {
    var searchDrawer = document.querySelector(selectors.drawer);
    var headerHeight = document.querySelector(selectors.headerSection)
      .offsetHeight;

    searchDrawer.style.height = headerHeight + 'px';
  }

  function close() {
    drawerInstance.close();
  }

  function lockBodyScroll() {
    theme.Helpers.enableScrollLock();
  }

  function unlockBodyScroll() {
    theme.Helpers.disableScrollLock();
  }

  return {
    init: init,
    close: close
  };
})();

theme.customerTemplates = (function() {
  var selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  };

  function initEventListeners() {
    this.recoverHeading = document.querySelector(selectors.RecoverHeading);
    this.recoverEmail = document.querySelector(selectors.RecoverEmail);
    this.loginHeading = document.querySelector(selectors.LoginHeading);
    var recoverPassword = document.getElementById('RecoverPassword');
    var hideRecoverPasswordLink = document.getElementById(
      'HideRecoverPasswordLink'
    );

    // Show reset password form
    if (recoverPassword) {
      recoverPassword.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();
          showRecoverPasswordForm();
          this.recoverHeading.setAttribute('tabindex', '-1');
          this.recoverHeading.focus();
        }.bind(this)
      );
    }

    // Hide reset password form
    if (hideRecoverPasswordLink) {
      hideRecoverPasswordLink.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();
          hideRecoverPasswordForm();
          this.loginHeading.setAttribute('tabindex', '-1');
          this.loginHeading.focus();
        }.bind(this)
      );
    }

    if (this.recoverHeading) {
      this.recoverHeading.addEventListener('blur', function(evt) {
        evt.target.removeAttribute('tabindex');
      });
    }

    if (this.loginHeading) {
      this.loginHeading.addEventListener('blur', function(evt) {
        evt.target.removeAttribute('tabindex');
      });
    }
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').classList.remove('hide');
    document.getElementById('CustomerLoginForm').classList.add('hide');

    if (this.recoverEmail.getAttribute('aria-invalid') === 'true') {
      this.recoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').classList.add('hide');
    document.getElementById('CustomerLoginForm').classList.remove('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var formState = document.querySelector('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!formState) {
      return;
    }

    // show success message
    var resetSuccess = document.getElementById('ResetSuccess');
    resetSuccess.classList.remove('hide');
    resetSuccess.focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var newAddressForm = document.getElementById('AddressNewForm');
    var newAddressFormButton = document.getElementById('AddressNewButton');

    if (!newAddressForm) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    document
      .querySelectorAll('.address-country-option')
      .forEach(function(option) {
        var formId = option.dataset.formId;
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });

    // Toggle new/edit address forms
    document.querySelectorAll('.address-new-toggle').forEach(function(button) {
      button.addEventListener('click', function() {
        var isExpanded =
          newAddressFormButton.getAttribute('aria-expanded') === 'true';

        newAddressForm.classList.toggle('hide');
        newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
        newAddressFormButton.focus();
      });
    });

    document.querySelectorAll('.address-edit-toggle').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        var formId = evt.target.dataset.formId;
        var editButton = document.getElementById('EditFormButton_' + formId);
        var editAddress = document.getElementById('EditAddress_' + formId);
        var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

        editAddress.classList.toggle('hide');
        editButton.setAttribute('aria-expanded', !isExpanded);
        editButton.focus();
      });
    });

    document.querySelectorAll('.address-delete').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        var target = evt.target.dataset.target;
        var confirmMessage = evt.target.dataset.confirmMessage;

        // eslint-disable-next-line no-alert
        if (
          confirm(
            confirmMessage || 'Are you sure you wish to delete this address?'
          )
        ) {
          Shopify.postLink(target, {
            parameters: { _method: 'delete' }
          });
        }
      });
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.SearchDrawer.init();
  }

  Header.prototype = Object.assign({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
      theme.MobileNav.unload();
    }
  });

  return Header;
})();

window.theme = window.theme || {};

var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};

/*=================================================================================================
									:: MARMETO DEV ::
=================================================================================================*/

/*
 * Global slick initializer
 */
theme.InitSlickSlider = (function () {
  function InitSlickSlider(element) {
    this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.slider = $('.js-slider-' + this.sectionId);
    this.options = this.element.data('slider-options');
    if (!this.slider.length) return;
    if (!this.slider.hasClass('slick-initialized')) {
      this.slider.slick(this.options);
    }
  }
  return InitSlickSlider;
})();

theme.InitThumbnailsSlickSlider = (function () {
  function InitSlickSlider(element) {
    this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.slider = $('.js-slider-thumbnails-' + this.sectionId);
    this.options = this.element.data('slider-options');
    if(!this.slider.length) return;
    
    if (!this.slider.hasClass('slick-initialized')) {
      this.slider.slick(this.options);
    }
  }
  return InitSlickSlider;
})();


/*
 * Global product card generator
 */
function renderProductCard(product) {
  var productHtml = '';
  
  if(product.featured_image) {
    let om = product.featured_image,
        pi = om.split(".");
    pi[pi.length-2] = pi[pi.length-2] + "_400x";
    var product_image = pi.join('.');
  } else {
    var product_image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_180x.gif';
  }

  var product_title = product.title,
      product_title_2 = '';

  if(product.title.indexOf('-') > 0){
    var lastIndex = product.title.lastIndexOf("-");
    product_title = product.title.substring(0, lastIndex).trim();
    product_title_2 = product.title.substring(lastIndex + 1).trim();
  }

  var labelTag = '';
  for(var i=0; i<product.tags.length; i++){
    var tagList = product.tags[i];
    if(tagList.indexOf('badge--')>-1){
      labelTag = '<span class="label-list">'+tagList.split('badge--')[1]+'</span>'
      break;
    }
  }
  var Saletag = '';
  for(var i=0; i<product.tags.length; i++){
    var tagList = product.tags[i];
    if(tagList.indexOf('badge___')>-1){
      Saletag = tagList.split('badge___')[1]
      break;
    }
  } 
  
  if(product.type != "Free Product"){
    productHtml += '<div class="grid__item small--one-whole medium-up--one-third grid-view-item">';
    productHtml += '<div class="product-card">';
    productHtml += '<div class="product-top">';

    productHtml += '<div class="product-card__image-with-placeholder-wrapper '+ Saletag +'">';
    if(Saletag == 'Sale'){
      productHtml += '<a href="/products/' + product.handle + '" class="no-opac"><?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="top-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{opacity:0.5;fill:#CDCDCD;}.st6{fill:#FFFFFF;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="836.1284" y1="-31.6388" x2="-118.9136" y2="702.7809"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.2702" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M-0.41,856.88V541.63c0,0,0-77.82,52.8-131.03L407.2,54.79c0,0,51.33-54.79,127.15-54.79h290.19h35.91c0,0-80.81-3.07-131.69,56.79L52.38,732.18C52.38,732.18-0.41,776.07-0.41,856.88z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="26.9359" y1="979.4771" x2="26.9359" y2="730.6643"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M54.31,730.66v248.81c0,0-54.72-44.89-54.72-124.7C-0.41,854.77-3.4,782.39,54.31,730.66z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="981.5855" y1="27.1905" x2="730.8472" y2="27.1905"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M981.59,54.31H730.85c0,0,46.23-54.18,126.04-54.18C856.88,0.13,925.83-3.77,981.59,54.31z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="-36.5281" y1="649.5118" x2="92.5108" y2="615.4924"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M34.61,432.02C-0.41,482.45-0.41,541.63-0.41,541.63v315.25c0-80.81,54.72-124.7,54.72-124.7l0.04-18.51l-0.04-304.99c0,0-4.08,4.2-8.2,8.64C41.99,421.75,34.61,432.02,34.61,432.02z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="680.4171" y1="-68.5959" x2="588.5" y2="122.5338"><stop offset="0.0307" style="stop-color:#FFFFFF;stop-opacity:0.2"/><stop offset="0.8105" style="stop-color:#FEB0B1"/></linearGradient><path class="st4" d="M408.95,52.92C434.22,27.86,480.78,0,534.36,0h290.19h35.91c0,0-73.74-4.73-128.28,52.92H418.26H408.95z"/></g><polygon class="st5" points="52.26,732.18 52.26,767.76 766.59,52.92 732.59,52.92 "/></g><g><g><path class="st6" d="M192.8,470.38c0,0,21.92-0.99,34.65-13.72c5.09-5.09,8.63-12.59,2.55-18.67c-12.02-12.02-57.13,33.94-88.25,2.83c-18.67-18.67-15.27-46.67,4.81-66.75c21.78-21.78,43.98-21.07,43.98-21.07l9.76,30.69c0,0-19.09,1.27-31.25,13.44c-5.09,5.09-8.48,13.01-2.83,18.67c12.73,12.73,56-35.07,87.96-3.11c16.83,16.83,18.53,44.26-4.24,67.03c-23.76,23.76-51.34,22.49-51.34,22.49L192.8,470.38z"/><path class="st6" d="M330.26,353.57l-31.54,31.54l15.13,27.29l-25.46,25.46l-66.75-135.48l26.02-26.02l135.48,66.75l-25.46,25.46L330.26,353.57z M257.57,312.56c0,0,8.77,13.29,13.29,21.5l13.86,25.46l19.94-19.94l-25.31-14c-8.2-4.53-21.5-13.29-21.5-13.29L257.57,312.56z"/><path class="st6" d="M293.35,230.68l24.75-24.75l79.9,79.9l41.29-41.29l21.21,21.21l-66.04,66.04L293.35,230.68z"/><path class="st6" d="M372.97,151.06l63.36-63.36l21.21,21.21l-38.61,38.61l18.38,18.38l30.83-30.83l21.21,21.21l-30.83,30.83l19.09,19.09l40.59-40.59l21.21,21.21l-65.34,65.34L372.97,151.06z"/></g></g></svg></a>'
    }
    productHtml += '<div class="grid-view-item__image-wrapper product-card__image-wrapper">';
    productHtml += labelTag;
    productHtml += '<a href="/products/' + product.handle + '" class="no-opac">';
    productHtml += '<img class="lazyload" data-auth="mds" data-src="'+ product_image +'" alt="'+ product.title +'" />';
    productHtml += '</a>';          
          
    productHtml += '</div>';

    if(product.compare_at_price > product.price) {
      var discountPrice = product.compare_at_price - product.price;
      var discountPercentage = (discountPrice / product.compare_at_price) * 100;
      discountPercentage = Math.round(discountPercentage);

      if(Saletag == 'Sale'){
        if(discountPercentage >= 30){
          productHtml += '<span class="bottom-badge-container">';
          productHtml += '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="bottom-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{fill:url(#SVGID_6_);}.st6{opacity:0.5;fill:#CDCDCD;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-1796.2583" y1="1677.0334" x2="-935.3876" y2="1677.0334" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.0921" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M2047.34,1190.49v315.25c0,0,0,77.82-52.8,131.03l-354.82,355.81c0,0-51.33,54.79-127.15,54.79h-290.19h-35.91c0,0,80.81,3.07,131.69-56.79l676.39-675.39C1994.54,1315.19,2047.34,1271.3,2047.34,1190.49z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="-1769.923" y1="2230.1897" x2="-1769.923" y2="1980.7839" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M1994.54,1315.19v-249.41c0,0,52.8,44.89,52.8,124.7C2047.34,1190.49,2052.62,1259.43,1994.54,1315.19z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="-814.2605" y1="1275.0674" x2="-1063.6663" y2="1275.0674" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M1065.34,1994.45h249.41c0,0-44.89,52.8-124.7,52.8C1190.04,2047.24,1121.09,2052.53,1065.34,1994.45z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="2061.3176" y1="1400.7207" x2="1803.2661" y2="1483.1906"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="1405.452" y1="2138.2439" x2="1413.4331" y2="1999.9065"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st4" d="M1637.98,1994.45c-25.27,25.07-71.83,52.92-125.41,52.92h-290.19h-35.91c0,0,73.74,4.73,128.28-52.92h313.92H1637.98z"/><linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="2135.5977" y1="1357.4199" x2="1864.2437" y2="1490.4365"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st5" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/></g><polygon class="st6" points="1637.98,1994.45 1994.54,1636.76 1994.54,1668.95 1672.94,1994.45 "/></g></svg>'
          productHtml += '<span class="bottom-discount">'+ discountPercentage +'%Off</span>';
          productHtml += '</span>';
        }
      } else {
        if(discountPercentage >= 15){
          productHtml += '<span class="discount_badge test-dm">';
          productHtml += '<svg xmlns="http://www.w3.org/2000/svg" id="Group_12" data-name="Group 12" width="55.043" height="50.614" viewBox="0 0 55.043 50.614"><g id="Group_11" data-name="Group 11" transform="translate(0 0)"><path id="Path_6" data-name="Path 6" d="M825.927,58.6h5.979c.012-2.663-1.339-4.8-2.99-4.8S825.927,55.945,825.927,58.6Z" transform="translate(-825.927 -53.794)" fill="#890303"/><path id="Path_7" data-name="Path 7" d="M1103.367,58.6h5.98c.012-2.663-1.339-4.8-2.99-4.8S1103.367,55.945,1103.367,58.6Z" transform="translate(-1054.303 -53.794)" fill="#890303"/><path id="Path_8" data-name="Path 8" d="M891.895,53.794H842.831c1.651,0,3,2.141,2.99,4.8h0V90.611a3.215,3.215,0,0,0,1.608,2.785l18.327,10.581a3.215,3.215,0,0,0,3.215,0L887.3,93.4a3.216,3.216,0,0,0,1.608-2.785V58.6C888.905,55.945,890.244,53.794,891.895,53.794Z" transform="translate(-839.841 -53.794)" fill="#dd3838"/></g></svg>';
          productHtml += '<span>'+ discountPercentage +'%<br>Off</span>'
          productHtml += '</span>'; 
        }
      }
    }

    productHtml += '</div>';

    productHtml += '<div class="product-card__detail">';     
    productHtml += '<div class="h4 grid-view-item__title product-card__title">';          
    productHtml += '<a href="/products/'+ product.handle +'" class="no-opac product-title">';          
    productHtml += '<span class="product-title--p1">'+ product_title +'</span>';

    if(product_title_2 != '') {
      productHtml += '<span class="product-title--p2">'+ product_title_2 +'</span>';
    }

    productHtml += '</a>';
    productHtml += '</div>';

    productHtml += '<div class="price--button-wrapper">';
    let popPrice = product.price;
    let priceLength = popPrice.toString().length;
    let poplistingPrice = popPrice.toString().slice(0,priceLength-2);
    
    if(product.compare_at_price > product.price) {
      var discountPrice = product.compare_at_price - product.price;

      productHtml += '<dl class="price price--listing price--on-sale sale-pop3">';            
      productHtml += '<div class="price__sale">';
      productHtml += '<dd>';            
      productHtml += '<span class="price-item price-item--sale">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
      productHtml += '</dd>';

      productHtml += '<div class="price__compare">';
      productHtml += '<dd>';
      productHtml += '<s class="price-item price-item--regular">' + Shopify.formatMoney(product.compare_at_price, theme.moneyFormat) + '</s>';
      productHtml += '</dd>';
      productHtml += '</div>';
      productHtml += '</div>';

      productHtml += '<span class="price__badge price__badge--sale">';
      productHtml += '<span>' + Shopify.formatMoney(discountPrice, theme.moneyFormat) + ' off</span>'
      productHtml += '</span>';            
      productHtml += '</dl>';
    } else {
      productHtml += '<div class="price__regular">';
      productHtml += '<dd>';
      productHtml += '<span class="price-item price-item--regular">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
      productHtml += '</dd>';
      productHtml += '</div>';
    }

    productHtml += '<div class="button-wrapper">';

    productHtml += '<form method="post" action="/cart/add" class="shopify-product-form" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';
    productHtml += '<input type="hidden" name="form_type" value="product">';
    productHtml += '<input type="hidden" name="utf8" value="✓">';
    productHtml += '<input type="hidden" name="quantity" value="1">';
    productHtml += '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
    if(theme.templateName == 'product'){
      productHtml += '<input type="hidden" name="properties[Recommendation Item]" value="true">';
    }

    if(product.available) {
      productHtml += '<button type="submit" class="mm_addToCart btn mm-ajax-add" data-price="'+ product.price +'">ADD</button>';
    } else {
      if(product.vendor == 'Delhigheespreads' || product.vendor == 'Mumbaigheespreads' || product.vendor == 'Bangaloregheespreads'){
        productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
      }else{
        productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
      }
    }

    productHtml += '</form>';
    productHtml += '</div>'; 
    productHtml += '</div>';
    productHtml += '<div class="pop-club-listing" price="'+ poplistingPrice +'"></div>';
    productHtml += '</div>';
    productHtml += '</div>';
    productHtml += '</div>';
    productHtml += '</div>';
  }
  return productHtml;
}

/*
 * Milkshake Multipack Product Button
 */
theme.MilkshakeMultipackButton = (function () {
  function MilkshakeMultipackButton(element) {

    this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.productHandles =  this.element.data('product-handle');

    if(!this.element.length) { return; }

    var buttonElement = $('.js-milkshake-multipack-' + this.sectionId);

    if(this.productHandles != '') {
      var depotCode = sessionStorage.getItem('DepotCode');  
      //var handleArray = this.productHandles.split(',');
      var asyncRequest = [];


        var productHandle = this.productHandles;
      console.log(productHandle);
            
        if(depotCode) {
          depotCode = depotCode.toLowerCase();
          productHandle = productHandle.replace(new RegExp('epigamia' + '$'), depotCode);
        }

        var productUrl = '/products/' + productHandle + '.js';

        asyncRequest.push(
          $.getJSON(productUrl, function(response) {
            var productHtml = '';
            var product = response; 

            productHtml += '<div class="button-wrapper">';
          
              productHtml += '<form method="post" action="/cart/add" class="shopify-product-form" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';
              productHtml += '<input type="hidden" name="form_type" value="product">';
              productHtml += '<input type="hidden" name="utf8" value="✓">';
              //productHtml += '<input type="hidden" name="quantity" value="1">';
              productHtml += '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

              productHtml+= '<div class="milkshake-page-quantity">';
              productHtml+= '<div class="quantity-box flexbox">';
              productHtml+= '<span class="minus-icon quantity-icon" data-symbol="-">';
              productHtml+= '<svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.55309 3.23798C1.83259 3.23798 1.28601 3.13209 0.913341 2.92031C0.565515 2.70854 0.391602 2.41531 0.391602 2.04063C0.391602 1.66595 0.565515 1.37272 0.913341 1.16095C1.28601 0.93288 1.83259 0.818848 2.55309 0.818848H10.2301C10.9506 0.818848 11.4848 0.93288 11.8326 1.16095C12.2053 1.37272 12.3916 1.66595 12.3916 2.04063C12.3916 2.41531 12.2053 2.70854 11.8326 2.92031C11.4848 3.13209 10.9506 3.23798 10.2301 3.23798H2.55309Z" fill="#ffffff"></path></svg>';
              productHtml+= '</span>';
              productHtml+= '<input type="number" class="product-form__input" name="quantity" value="1" min="1">';
              productHtml+= '<span class="plus-icon quantity-icon" data-symbol="+">';
              productHtml+= '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2772 5.71961C11.5886 5.71961 11.8427 5.82786 12.0395 6.04438C12.2526 6.24423 12.3591 6.50238 12.3591 6.81883C12.3591 7.13527 12.2526 7.40175 12.0395 7.61826C11.8427 7.81812 11.5886 7.91805 11.2772 7.91805H7.4411V11.7903C7.4411 12.1067 7.33454 12.3732 7.12143 12.5897C6.9247 12.8063 6.67061 12.9145 6.35913 12.9145C6.04766 12.9145 5.78536 12.8063 5.57225 12.5897C5.37552 12.3732 5.27716 12.1067 5.27716 11.7903V7.91805H1.4411C1.12962 7.91805 0.867328 7.81812 0.654213 7.61826C0.457492 7.40175 0.359131 7.13527 0.359131 6.81883C0.359131 6.50238 0.457492 6.24423 0.654213 6.04438C0.867328 5.82786 1.12962 5.71961 1.4411 5.71961H5.27716V1.82237C5.27716 1.50592 5.37552 1.24777 5.57225 1.04791C5.78536 0.831401 6.04766 0.723145 6.35913 0.723145C6.67061 0.723145 6.9247 0.831401 7.12143 1.04791C7.33454 1.24777 7.4411 1.50592 7.4411 1.82237V5.71961H11.2772Z" fill="#ffffff"></path></svg>';
              productHtml+= '</span>';
              productHtml+= '</div>';
              
              if(product.available) {
                productHtml += '<button type="submit" class="mm_addToCart btn mm-text-black mm-ajax-buy">Buy & Try Now • <span class="mm-text-black">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span></button>';
              } else {
                if(product.vendor == 'Delhigheespreads' || product.vendor == 'Mumbaigheespreads' || product.vendor == 'Bangaloregheespreads'){
                  productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
                }else{
                  productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
                }
              }
              productHtml += '</div>';
              productHtml += '</form>';
          
              productHtml += '</div>';
            buttonElement.html(' ');
            buttonElement.append(productHtml);
          })
        );    
    }
  }

  return MilkshakeMultipackButton;
})();


/*
 * Milkshake page product slider
 */
theme.MilkshakeProductSlider = (function () {
  function MilkshakeProductSlider(element) {

    this.element = $(element);
    this.sectionId = this.element.data('section-id');
    //this.productHandles =  this.element.data('product-handles');
    this.productDetails =  this.element.data('product-details');

    if(!this.element.length) { return; }

    var sliderElement = $('.js-slider-' + this.sectionId);
    var sliderOptions = this.element.data('slider-options');

      var depotCode = sessionStorage.getItem('DepotCode');  
      var parseObject = JSON.parse(this.productDetails);
      var collection = parseObject.milkshakeProducts;
      //var handleArray = this.productHandles.split(',');

    if(collection.length) {
      var asyncRequest = [];

      if(sliderElement.hasClass('slick-initialized')) {
        sliderElement.slick('unslick');
        sliderElement.html('');
      }

      for(var i=0; i<collection.length; i++) { 
        let grid_item = collection[i];         
        let grid_item_image = grid_item.image;  
        let grid_item_handle = grid_item.handle;
        let grid_item_bg_color = grid_item.buttonBgColor;
        let grid_item_text_color = grid_item.buttonTextColor;
        
        //var productHandle = handleArray[i];
            
        if(depotCode) {
          depotCode = depotCode.toLowerCase();
          grid_item_handle = grid_item_handle.replace(new RegExp('epigamia' + '$'), depotCode);
        }

        var productUrl = '/products/' + grid_item_handle + '.js';

        $.ajax({
          url: productUrl,
          type: 'GET',
          async: false,
          processData : false,
          contentType: false,
          dataType:'JSON',
          success: function(response) {
         
            var productHtml = '';
            var product = response;                       

            if(grid_item_image) {
              let om = grid_item_image,
                  pi = om.split(".");
              pi[pi.length-2] = pi[pi.length-2] + "_400x";
              var product_image = pi.join('.');
            } else {
              var product_image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_180x.gif';
            }

            var product_title = product.title,
                product_title_2 = '';
          
            if(product.title.indexOf('-') > 0){
              var lastIndex = product.title.lastIndexOf("-");
              product_title = product.title.substring(0, lastIndex).trim();
              product_title_2 = product.title.substring(lastIndex + 1).trim();
            }
          
            var labelTag = '';
            for(var i=0; i<product.tags.length; i++){
              var tagList = product.tags[i];
              if(tagList.indexOf('badge--')>-1){
                labelTag = '<span class="label-list">'+tagList.split('badge--')[1]+'</span>'
                break;
              }
            }
            var Saletag = '';
            for(var i=0; i<product.tags.length; i++){
            	var tagList = product.tags[i];
              if(tagList.indexOf('badge___')>-1){
                Saletag = tagList.split('badge___')[1]
                break;
              }
            } 
            if(product.type != "Free Product"){
              productHtml += '<div class="grid__item small--one-whole medium-up--one-third grid-view-item ">';
              productHtml += '<div class="product-card">';
              productHtml += '<div class="product-top">';
          
              productHtml += '<div class="product-card__image-with-placeholder-wrapper '+ Saletag +'">';
              if(Saletag == 'Sale'){
                productHtml += '<a href="/products/' + product.handle + '" class="no-opac"><?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="top-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{opacity:0.5;fill:#CDCDCD;}.st6{fill:#FFFFFF;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="836.1284" y1="-31.6388" x2="-118.9136" y2="702.7809"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.2702" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M-0.41,856.88V541.63c0,0,0-77.82,52.8-131.03L407.2,54.79c0,0,51.33-54.79,127.15-54.79h290.19h35.91c0,0-80.81-3.07-131.69,56.79L52.38,732.18C52.38,732.18-0.41,776.07-0.41,856.88z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="26.9359" y1="979.4771" x2="26.9359" y2="730.6643"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M54.31,730.66v248.81c0,0-54.72-44.89-54.72-124.7C-0.41,854.77-3.4,782.39,54.31,730.66z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="981.5855" y1="27.1905" x2="730.8472" y2="27.1905"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M981.59,54.31H730.85c0,0,46.23-54.18,126.04-54.18C856.88,0.13,925.83-3.77,981.59,54.31z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="-36.5281" y1="649.5118" x2="92.5108" y2="615.4924"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M34.61,432.02C-0.41,482.45-0.41,541.63-0.41,541.63v315.25c0-80.81,54.72-124.7,54.72-124.7l0.04-18.51l-0.04-304.99c0,0-4.08,4.2-8.2,8.64C41.99,421.75,34.61,432.02,34.61,432.02z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="680.4171" y1="-68.5959" x2="588.5" y2="122.5338"><stop offset="0.0307" style="stop-color:#FFFFFF;stop-opacity:0.2"/><stop offset="0.8105" style="stop-color:#FEB0B1"/></linearGradient><path class="st4" d="M408.95,52.92C434.22,27.86,480.78,0,534.36,0h290.19h35.91c0,0-73.74-4.73-128.28,52.92H418.26H408.95z"/></g><polygon class="st5" points="52.26,732.18 52.26,767.76 766.59,52.92 732.59,52.92 "/></g><g><g><path class="st6" d="M192.8,470.38c0,0,21.92-0.99,34.65-13.72c5.09-5.09,8.63-12.59,2.55-18.67c-12.02-12.02-57.13,33.94-88.25,2.83c-18.67-18.67-15.27-46.67,4.81-66.75c21.78-21.78,43.98-21.07,43.98-21.07l9.76,30.69c0,0-19.09,1.27-31.25,13.44c-5.09,5.09-8.48,13.01-2.83,18.67c12.73,12.73,56-35.07,87.96-3.11c16.83,16.83,18.53,44.26-4.24,67.03c-23.76,23.76-51.34,22.49-51.34,22.49L192.8,470.38z"/><path class="st6" d="M330.26,353.57l-31.54,31.54l15.13,27.29l-25.46,25.46l-66.75-135.48l26.02-26.02l135.48,66.75l-25.46,25.46L330.26,353.57z M257.57,312.56c0,0,8.77,13.29,13.29,21.5l13.86,25.46l19.94-19.94l-25.31-14c-8.2-4.53-21.5-13.29-21.5-13.29L257.57,312.56z"/><path class="st6" d="M293.35,230.68l24.75-24.75l79.9,79.9l41.29-41.29l21.21,21.21l-66.04,66.04L293.35,230.68z"/><path class="st6" d="M372.97,151.06l63.36-63.36l21.21,21.21l-38.61,38.61l18.38,18.38l30.83-30.83l21.21,21.21l-30.83,30.83l19.09,19.09l40.59-40.59l21.21,21.21l-65.34,65.34L372.97,151.06z"/></g></g></svg></a>'
              }
              productHtml += '<div class="grid-view-item__image-wrapper product-card__image-wrapper">';
              productHtml += labelTag;
              productHtml += '<a href="/products/' + product.handle + '" class="no-opac">';
              productHtml += '<img class="lazyload" data-src="'+ product_image +'" alt="'+ product.title +'" />';
              productHtml += '</a>';          
              productHtml += '</div>';
          
              if(product.compare_at_price > product.price) {
                var discountPrice = product.compare_at_price - product.price;
                var discountPercentage = (discountPrice / product.compare_at_price) * 100;
                discountPercentage = Math.round(discountPercentage);

                if(Saletag == 'Sale'){
                  if(discountPercentage >= 30){
                    productHtml += '<span class="bottom-badge-container">';
                    productHtml += '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="bottom-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{fill:url(#SVGID_6_);}.st6{opacity:0.5;fill:#CDCDCD;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-1796.2583" y1="1677.0334" x2="-935.3876" y2="1677.0334" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.0921" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M2047.34,1190.49v315.25c0,0,0,77.82-52.8,131.03l-354.82,355.81c0,0-51.33,54.79-127.15,54.79h-290.19h-35.91c0,0,80.81,3.07,131.69-56.79l676.39-675.39C1994.54,1315.19,2047.34,1271.3,2047.34,1190.49z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="-1769.923" y1="2230.1897" x2="-1769.923" y2="1980.7839" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M1994.54,1315.19v-249.41c0,0,52.8,44.89,52.8,124.7C2047.34,1190.49,2052.62,1259.43,1994.54,1315.19z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="-814.2605" y1="1275.0674" x2="-1063.6663" y2="1275.0674" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M1065.34,1994.45h249.41c0,0-44.89,52.8-124.7,52.8C1190.04,2047.24,1121.09,2052.53,1065.34,1994.45z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="2061.3176" y1="1400.7207" x2="1803.2661" y2="1483.1906"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="1405.452" y1="2138.2439" x2="1413.4331" y2="1999.9065"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st4" d="M1637.98,1994.45c-25.27,25.07-71.83,52.92-125.41,52.92h-290.19h-35.91c0,0,73.74,4.73,128.28-52.92h313.92H1637.98z"/><linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="2135.5977" y1="1357.4199" x2="1864.2437" y2="1490.4365"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st5" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/></g><polygon class="st6" points="1637.98,1994.45 1994.54,1636.76 1994.54,1668.95 1672.94,1994.45 "/></g></svg>'
                    productHtml += '<span class="bottom-discount">'+ discountPercentage +'%Off</span>';
                    productHtml += '</span>';
                  }
                } else {
                  if(discountPercentage >= 15){
                    productHtml += '<span class="discount_badge">';
                    productHtml += '<svg xmlns="http://www.w3.org/2000/svg" id="Group_12" data-name="Group 12" width="55.043" height="50.614" viewBox="0 0 55.043 50.614"><g id="Group_11" data-name="Group 11" transform="translate(0 0)"><path id="Path_6" data-name="Path 6" d="M825.927,58.6h5.979c.012-2.663-1.339-4.8-2.99-4.8S825.927,55.945,825.927,58.6Z" transform="translate(-825.927 -53.794)" fill="#890303"/><path id="Path_7" data-name="Path 7" d="M1103.367,58.6h5.98c.012-2.663-1.339-4.8-2.99-4.8S1103.367,55.945,1103.367,58.6Z" transform="translate(-1054.303 -53.794)" fill="#890303"/><path id="Path_8" data-name="Path 8" d="M891.895,53.794H842.831c1.651,0,3,2.141,2.99,4.8h0V90.611a3.215,3.215,0,0,0,1.608,2.785l18.327,10.581a3.215,3.215,0,0,0,3.215,0L887.3,93.4a3.216,3.216,0,0,0,1.608-2.785V58.6C888.905,55.945,890.244,53.794,891.895,53.794Z" transform="translate(-839.841 -53.794)" fill="#dd3838"/></g></svg>';
                    productHtml += '<span>'+ discountPercentage +'%<br>Off</span>'
                    productHtml += '</span>'; 
                  }
                }
              }
          
              productHtml += '</div>';
          
              productHtml += '<div class="product-card__detail" data-id="'+ product.variants[0].id +'">';     
              productHtml += '<div class="h4 grid-view-item__title product-card__title">';          
              productHtml += '<a href="/products/'+ product.handle +'" class="no-opac product-title">';          
              productHtml += '<span class="product-title--p1">'+ product_title +'</span>';
          
              if(product_title_2 != '') {
                productHtml += '<span class="product-title--p2">'+ product_title_2 +'</span>';
              }
          
              productHtml += '</a>';
              productHtml += '</div>';
              productHtml += '<div class="price--button-wrapper">';
          
              if(product.compare_at_price > product.price) {
                var discountPrice = product.compare_at_price - product.price;
          
                productHtml += '<dl class="price price--listing price--on-sale ">';            
                productHtml += '<div class="price__sale">';
                productHtml += '<dd>';            
                productHtml += '<span class="price-item price-item--sale">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
                productHtml += '</dd>';
          
                productHtml += '<div class="price__compare">';
                productHtml += '<dd>';
                productHtml += '<s class="price-item price-item--regular">' + Shopify.formatMoney(product.compare_at_price, theme.moneyFormat) + '</s>';
                productHtml += '</dd>';
                productHtml += '</div>';
                productHtml += '</div>';
          
                productHtml += '<span class="price__badge price__badge--sale">';
                productHtml += '<span>' + Shopify.formatMoney(discountPrice, theme.moneyFormat) + ' off</span>'
                productHtml += '</span>';            
                productHtml += '</dl>';
              } else {
                productHtml += '<div class="price__regular">';
                productHtml += '<dd>';
                productHtml += '<span class="price-item price-item--regular">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
                productHtml += '</dd>';
                productHtml += '</div>';
              }
                       
              productHtml += '</div>';

              productHtml += '<div class="button-wrapper">';
          
              productHtml += '<form method="post" action="/cart/add" class="shopify-product-form" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';
              productHtml += '<input type="hidden" name="form_type" value="product">';
              productHtml += '<input type="hidden" name="utf8" value="✓">';
              //productHtml += '<input type="hidden" name="quantity" value="1">';
              productHtml += '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
              
              // Quantity limit message start
                var taglist = product.tags;
                var tag = '';
                var limits = 0;
                taglist.forEach((element) => {
                  if (element.includes('quantity_limit--')){ 
                    tag = element ,
                    limits = tag.split('quantity_limit--').pop();
                  }
                });
              productHtml+= '<div class="milkshake-page-quantity quantity-wrapper">';
              productHtml+= '<div class="quantity-box flexbox">';
              productHtml+= '<span class="minus-icon quantity-icon" data-symbol="-">';
              productHtml+= '<svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.55309 3.23798C1.83259 3.23798 1.28601 3.13209 0.913341 2.92031C0.565515 2.70854 0.391602 2.41531 0.391602 2.04063C0.391602 1.66595 0.565515 1.37272 0.913341 1.16095C1.28601 0.93288 1.83259 0.818848 2.55309 0.818848H10.2301C10.9506 0.818848 11.4848 0.93288 11.8326 1.16095C12.2053 1.37272 12.3916 1.66595 12.3916 2.04063C12.3916 2.41531 12.2053 2.70854 11.8326 2.92031C11.4848 3.13209 10.9506 3.23798 10.2301 3.23798H2.55309Z" fill="#ffffff"></path></svg>';
              productHtml+= '</span>';
              productHtml+= '<input type="number" class="product-form__input" name="quantity" value="1" min="1">';
              productHtml+= '<span class="plus-icon quantity-icon" data-symbol="+" data-quantity-limit='+ limits +'>';
              productHtml+= '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2772 5.71961C11.5886 5.71961 11.8427 5.82786 12.0395 6.04438C12.2526 6.24423 12.3591 6.50238 12.3591 6.81883C12.3591 7.13527 12.2526 7.40175 12.0395 7.61826C11.8427 7.81812 11.5886 7.91805 11.2772 7.91805H7.4411V11.7903C7.4411 12.1067 7.33454 12.3732 7.12143 12.5897C6.9247 12.8063 6.67061 12.9145 6.35913 12.9145C6.04766 12.9145 5.78536 12.8063 5.57225 12.5897C5.37552 12.3732 5.27716 12.1067 5.27716 11.7903V7.91805H1.4411C1.12962 7.91805 0.867328 7.81812 0.654213 7.61826C0.457492 7.40175 0.359131 7.13527 0.359131 6.81883C0.359131 6.50238 0.457492 6.24423 0.654213 6.04438C0.867328 5.82786 1.12962 5.71961 1.4411 5.71961H5.27716V1.82237C5.27716 1.50592 5.37552 1.24777 5.57225 1.04791C5.78536 0.831401 6.04766 0.723145 6.35913 0.723145C6.67061 0.723145 6.9247 0.831401 7.12143 1.04791C7.33454 1.24777 7.4411 1.50592 7.4411 1.82237V5.71961H11.2772Z" fill="#ffffff"></path></svg>';
              productHtml+= '</span>';
              productHtml+= '</div>';
              
              if(product.available) {
                productHtml += '<button type="submit" class="mm_addToCart btn mm-ajax-add" data-price="'+ product.price +'" style="background-color:'+ grid_item_bg_color +'; color:'+ grid_item_text_color +'">ADD To Cart</button>';
              } else {
                if(product.vendor == 'Delhigheespreads' || product.vendor == 'Mumbaigheespreads' || product.vendor == 'Bangaloregheespreads'){
                  productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
                }else{
                  productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
                }
              }
              productHtml += '</div>';
              productHtml += '</form>';
              productHtml += '<div class="more-value-message">';
              productHtml += '</div>';
              productHtml += '</div>';
               
              productHtml += '</div>';
              
            var taglist = product.tags;
            var tag = '';
            var limits = 0;
            taglist.forEach((element) => {
              if (element.includes('quantity_limit--')){ 
                tag = element ,
                limits = tag.split('quantity_limit--').pop();
                
                var quan = message.replace("[quantity]",limits);
                productHtml += '<div class="quantity-limit-message" style="display:none;">';
                productHtml += quan + bulkLink;
                productHtml += '</div>';
              }
            });
              productHtml += '</div>';
              productHtml += '</div>';
              productHtml += '</div>';
            }
          
            sliderElement.append(productHtml);
          }
        });    
      }

      //God damn. This waits untils $.get requests to finish working
      $.when.apply(null, asyncRequest).done( function() {
        if (!sliderElement.length) return;
        if (!sliderElement.hasClass('slick-initialized')) {
          sliderElement.slick(sliderOptions);
        }
      });    
    }
  }

  return MilkshakeProductSlider;
})();

/*
 * Search Page 
 */
theme.SearchpageProduct = (function () {
  function SearchpageProduct(element) {

    this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.productHandles =  this.element.data('product-handles');

    if(!this.element.length) { return; }

    var sliderElement = $('.js-section-' + this.sectionId);
    //var sliderOptions = this.element.data('slider-options');

    if(this.productHandles != '') {
      var depotCode = sessionStorage.getItem('DepotCode');  
      var handleArray = this.productHandles.split(',');
      var asyncRequest = [];

      for(var i=0; i<handleArray.length; i++) { 
        var productHandle = handleArray[i];
            
        if(depotCode) {
          depotCode = depotCode.toLowerCase();
          productHandle = productHandle.replace(new RegExp('epigamia' + '$'), depotCode);
        }

        var productUrl = '/products/' + productHandle + '.js';

        asyncRequest.push(
          $.getJSON(productUrl, function(response) {
            var html = '';
            var product = response;                       
            
            sliderElement.append(
              renderProductCard(product)
            );
          })
        );
      }   
    }
  }

  return SearchpageProduct;
})();



/*
 * Homepage product slider
 */
theme.HomepageProductSlider = (function () { 
  function HomepageProductSlider(element) {
    
    this.element = $(element);
    
    this.sectionId = this.element.data('section-id');
    this.productHandles =  this.element.data('product-handles');

    if(!this.element.length) { return; }

    var sliderElement = $('.js-slider-' + this.sectionId);
    var sliderOptions = this.element.data('slider-options');

    if(this.productHandles != '') {
      var depotCode = sessionStorage.getItem('DepotCode');  
      var handleArray = this.productHandles.split(',');
      var asyncRequest = [];

      if(sliderElement.hasClass('slick-initialized')) {
        sliderElement.slick('unslick');
        sliderElement.html('');
      }

      for(var i=0; i<handleArray.length; i++) { 
        var productHandle = handleArray[i];
        if(productHandle != ""){
          if(depotCode) {
            depotCode = depotCode.toLowerCase();
            productHandle = productHandle.replace(new RegExp('epigamia' + '$'), depotCode);
          }
  
          var productUrl = '/products/' + productHandle + '.js';
  
          asyncRequest.push(
            $.getJSON(productUrl, function(response) {
              var html = '';
              var product = response;                       
              
              sliderElement.append(
                renderProductCard(product)
              );
            })
          );
          console.log(asyncRequest);
        }
      }
      //God damn. This waits untils $.get requests to finish working
      console.log(asyncRequest)
      $.when.apply(null,asyncRequest).then( function() {
        
        if (!sliderElement.length) return;
        if (!sliderElement.hasClass('slick-initialized')) {
          sliderElement.slick(sliderOptions);
        }
      });    
    }
  }
  return HomepageProductSlider;
})();

/* Product recommendation | Upsell */
theme.productRecommendation = (function () { 
  function productRecommendation(element) {
    this.element = $(element);
    
    this.sectionId = this.element.data('section-id');
    this.productHandles =  this.element.data('product-handles');

    if(!this.element.length) { return; }

    var sliderElement = $('.js-slider-' + this.sectionId);
    var sliderOptions = this.element.data('slider-options');

    if(this.productHandles != '') {
      var depotCode = sessionStorage.getItem('DepotCode');  
      var handleArray = this.productHandles.split(',');
      var asyncRequest = [];

      if(sliderElement.hasClass('slick-initialized')) {
        sliderElement.slick('unslick');
        sliderElement.html('');
      }

      for(var i=0; i<handleArray.length; i++) { 
        var productHandle = handleArray[i];
        if(productHandle != ""){
          if(depotCode) {
            depotCode = depotCode.toLowerCase();
            productHandle = productHandle.replace(new RegExp('epigamia' + '$'), depotCode);
          }
  
          var productUrl = '/products/' + productHandle + '.js';
  
          asyncRequest.push(
            $.getJSON(productUrl, function(response) {
              var html = '';
              var product = response;                       
              
              sliderElement.append(
                renderProductCard(product)
              );
            })
          );
          console.log(asyncRequest)
        }
      }
      //God damn. This waits untils $.get requests to finish working
      console.log(asyncRequest)
      Promise.allSettled(asyncRequest).then(() => {
         if (sliderElement.length && !sliderElement.hasClass('slick-initialized')) {
            sliderElement.slick(sliderOptions);
          }
      });
         
    }
  }

  return productRecommendation;
})();

/*
 * Hocky pocky products list
 */
theme.hkpkProductGrids = (function () {
  function hkpkProductGrids(element) {
  	this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.productDetails =  this.element.data('product-details');

    if(!this.element.length) { return; }
    var containerEl = $('.js-slider-' + this.sectionId);
    var sliderOptions = this.element.data('slider-options');
    
    var depotCode = sessionStorage.getItem('DepotCode');  
    var parseObject = JSON.parse(this.productDetails);
    var collection = parseObject.hkpkCollection;

    if(collection.length) {
      var asyncRequest = [];
      
      if(containerEl.hasClass('slick-initialized')) {
        containerEl.slick('unslick');
        containerEl.html('');
      } else {
        containerEl.html('');
      }
     
      for(var i=0; i<collection.length; i++) { 
        let grid_item = collection[i];         
        let grid_item_image = grid_item.image;   
        let grid_item_price = grid_item.price;
        let grid_item_title = grid_item.title;
        let grid_item_handle = grid_item.handle;
        let grid_item_subtitle = grid_item.subtitle;
        let grid_item_description = grid_item.description;
        
        if(grid_item_image) {
          let om = grid_item_image,
              pi = om.split(".");
          pi[pi.length-2] = pi[pi.length-2] + "_400x";
          grid_item_image = pi.join('.');
        }

        //If depo code exists replace the last occurance of epigamia
        if(depotCode) {
          depotCode = depotCode.toLowerCase();
          grid_item_handle = grid_item_handle.replace(new RegExp('epigamia' + '$'), depotCode);
        }

        var productUrl = '/products/' + grid_item_handle + '.js';
        
        $.ajax({
          url: productUrl,
          type: 'GET',
          async: false,
          processData : false,
          contentType: false,
          dataType:'JSON',
          success: function(response) {                        
            var html = '';                               
            var product = response;

            html+= '<div class="grid__item medium-up--one-third">';
        	html+= '<div class="product-card">';
          	
            html+= '<div class="product-image">';
            html+= '<a href="' + product.url + '">';
            html+= '<img class="lazyload" data-src="' + grid_item_image + '" alt="' + grid_item_title + '">';
            html+= '</a>';
          	html+= '</div>';
            
          	html+= '<div class="product-details">';
            html+= '<h3 class="product-title">';
            html+= '<a href="' + product.url + '">' + product.title + '</a>';
            html+= '</h3>';
            html+= '<span class="product-subtitle">' + grid_item_subtitle + '</span>';
            html+= '<p class="product-desc">' + grid_item_description + '</p>';
            
            html+= '<form method="post" action="/cart/add" id="product_form_' + product.id + '" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';
            html+= '<input type="hidden" name="form_type" value="product">';
            html+= '<input type="hidden" name="utf8" value="✓">';
            html+= '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
            html+= '<div class="product-quantity-price flexbox">';
            html+= '<div class="quantity-box flexbox">';
            html+= '<span class="minus-icon quantity-icon" data-symbol="-"><svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.55309 3.23798C1.83259 3.23798 1.28601 3.13209 0.913341 2.92031C0.565515 2.70854 0.391602 2.41531 0.391602 2.04063C0.391602 1.66595 0.565515 1.37272 0.913341 1.16095C1.28601 0.93288 1.83259 0.818848 2.55309 0.818848H10.2301C10.9506 0.818848 11.4848 0.93288 11.8326 1.16095C12.2053 1.37272 12.3916 1.66595 12.3916 2.04063C12.3916 2.41531 12.2053 2.70854 11.8326 2.92031C11.4848 3.13209 10.9506 3.23798 10.2301 3.23798H2.55309Z" fill="#CA7077"></path></svg></span>';
            html+= '<input type="number" class="product-form__input" name="quantity" value="1" min="1">';
            html+= '<span class="plus-icon quantity-icon" data-symbol="+"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2772 5.71961C11.5886 5.71961 11.8427 5.82786 12.0395 6.04438C12.2526 6.24423 12.3591 6.50238 12.3591 6.81883C12.3591 7.13527 12.2526 7.40175 12.0395 7.61826C11.8427 7.81812 11.5886 7.91805 11.2772 7.91805H7.4411V11.7903C7.4411 12.1067 7.33454 12.3732 7.12143 12.5897C6.9247 12.8063 6.67061 12.9145 6.35913 12.9145C6.04766 12.9145 5.78536 12.8063 5.57225 12.5897C5.37552 12.3732 5.27716 12.1067 5.27716 11.7903V7.91805H1.4411C1.12962 7.91805 0.867328 7.81812 0.654213 7.61826C0.457492 7.40175 0.359131 7.13527 0.359131 6.81883C0.359131 6.50238 0.457492 6.24423 0.654213 6.04438C0.867328 5.82786 1.12962 5.71961 1.4411 5.71961H5.27716V1.82237C5.27716 1.50592 5.37552 1.24777 5.57225 1.04791C5.78536 0.831401 6.04766 0.723145 6.35913 0.723145C6.67061 0.723145 6.9247 0.831401 7.12143 1.04791C7.33454 1.24777 7.4411 1.50592 7.4411 1.82237V5.71961H11.2772Z" fill="#CA7077"></path></svg></span>';
            html+= '</div>';
            
            if(product.available) {
              html+= '<button type="submit" class="mm_addToCart btn mm-text-black mm-ajax-add" data-price="' + product.price + '"><strong>Add To Cart • </strong>'+ grid_item_price +'</button>';
            } else {
              if(product.vendor == 'Delhigheespreads' || product.vendor == 'Mumbaigheespreads' || product.vendor == 'Bangaloregheespreads'){
                html += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
              }else{
                html += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
              }
            }
            
            html+= '</div>';
            html+= '</form>';
          	html+= '</div>';
              
        	html+= '</div>';
      		html+= '</div>';
            
            containerEl.append(html);
          }
        });
      }
      
      $.when.apply(null, asyncRequest).done(function() {
        if (!containerEl.length) return;
        if (!containerEl.hasClass('slick-initialized')) {
          containerEl.slick(sliderOptions);
        }
      });
    }
  }
  
  return hkpkProductGrids;
})();

    
/*
 * Homepage Featured Products
 */
theme.FeaturedProductGrids = (function () {
  function FeaturedProductGrids(element) {
  	this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.productDetails =  this.element.data('product-details');

    if(!this.element.length) { return; }
    
    var depotCode = sessionStorage.getItem('DepotCode');  
    var containerEl = $('.js-container-' + this.sectionId);
    var parseObject = JSON.parse(this.productDetails);
    var collection = parseObject.featuredCollection;
    
    if(collection.length) {
      var asyncRequest = [];
      
      if(containerEl.hasClass('slick-initialized')) {
        containerEl.slick('unslick');
        containerEl.html('');
      }
      
      for(var i=0; i<collection.length; i++) { 
        let grid_item = collection[i];         
        let grid_item_image = grid_item.image;   
        let grid_item_price = grid_item.price;
        let grid_item_title = grid_item.title;
        let grid_item_handle = grid_item.handle;
        let grid_item_flavour = grid_item.flavour;
        let grid_item_bg_color1 = grid_item.bgColor1;
        let grid_item_bg_color2 = grid_item.bgColor2;
        let grid_item_buttonType = grid_item.buttonType;

        //If depo code exists replace the last occurance of epigamia
        if(depotCode) {
          depotCode = depotCode.toLowerCase();
          grid_item_handle = grid_item_handle.replace(new RegExp('epigamia' + '$'), depotCode);
        }

        var productUrl = '/products/' + grid_item_handle + '.js';
        
        asyncRequest.push(
          $.getJSON(productUrl, function(response) {                        
            var html = '';                               
            var product = response;
            
            var labelTag = '';
            for(var i=0; i<product.tags.length; i++){
              var tagList = product.tags[i];
              if(tagList.indexOf('badge--')>-1){
                labelTag = '<span class="mm-text-black product-badge">'+tagList.split('badge--')[1]+'</span>'
                break;
              }
            }

            html+= '<div class="section__details-wrap" data-color="radial-gradient(23.93% 47.15% at 68.49% 58.49%,' + grid_item_bg_color1 + ' 0%, ' +  grid_item_bg_color2 + ' 100%)">';
            html+= '<form method="post" action="/cart/add" class="shopify-product-form" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';
            html+= '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

            html+= '<div class="featured-product-detail">';
            
            html+= '<a class="block-product-image-wrap mm-mobile-hide" href="/products/' + product.handle + '">';
            html+= '<span class="visually-hidden">' + grid_item_title + '-image</span>';
            html+= '<div class="featured-product-img mm-mobile-hide">';
            html+= '<img class="lazyload" src="' + grid_item_image + '" alt="' + grid_item_title + '">';
            html+= '</div>';
            html+= '</a>';

            html+= '<div class="block-product-title-wrap">';
            html+= labelTag;
            html+= '<h3 class="mm-text-black product-flavour">' + grid_item_flavour + '</h3>';
            html+= '<a href="/products/' + product.handle + '">';
            html+= '<h3 class="mm-text-black">' + grid_item_title + '</h3>';
            html+= '</a>';

            for(var i=0; i<product.tags.length; i++){
              var tagList = product.tags[i];
              if(tagList.indexOf('feature--')>-1){
                html+= '<p class="mm-text-black">'+tagList.split('feature-')[1]+'</p>';
              }
            }

            html+= '<div class="mm-mobile-hide block-product-price-wrap">';
            
            html+= '<div class="quantity-box flexbox">';
            html+= '<span class="minus-icon quantity-icon" data-symbol="-">';
            html+= '<svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.55309 3.23798C1.83259 3.23798 1.28601 3.13209 0.913341 2.92031C0.565515 2.70854 0.391602 2.41531 0.391602 2.04063C0.391602 1.66595 0.565515 1.37272 0.913341 1.16095C1.28601 0.93288 1.83259 0.818848 2.55309 0.818848H10.2301C10.9506 0.818848 11.4848 0.93288 11.8326 1.16095C12.2053 1.37272 12.3916 1.66595 12.3916 2.04063C12.3916 2.41531 12.2053 2.70854 11.8326 2.92031C11.4848 3.13209 10.9506 3.23798 10.2301 3.23798H2.55309Z" fill="#ffffff"></path></svg>';
            html+= '</span>';
            html+= '<input type="number" class="product-form__input" name="quantity" value="1" min="1">';
            html+= '<span class="plus-icon quantity-icon" data-symbol="+">';
            html+= '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2772 5.71961C11.5886 5.71961 11.8427 5.82786 12.0395 6.04438C12.2526 6.24423 12.3591 6.50238 12.3591 6.81883C12.3591 7.13527 12.2526 7.40175 12.0395 7.61826C11.8427 7.81812 11.5886 7.91805 11.2772 7.91805H7.4411V11.7903C7.4411 12.1067 7.33454 12.3732 7.12143 12.5897C6.9247 12.8063 6.67061 12.9145 6.35913 12.9145C6.04766 12.9145 5.78536 12.8063 5.57225 12.5897C5.37552 12.3732 5.27716 12.1067 5.27716 11.7903V7.91805H1.4411C1.12962 7.91805 0.867328 7.81812 0.654213 7.61826C0.457492 7.40175 0.359131 7.13527 0.359131 6.81883C0.359131 6.50238 0.457492 6.24423 0.654213 6.04438C0.867328 5.82786 1.12962 5.71961 1.4411 5.71961H5.27716V1.82237C5.27716 1.50592 5.37552 1.24777 5.57225 1.04791C5.78536 0.831401 6.04766 0.723145 6.35913 0.723145C6.67061 0.723145 6.9247 0.831401 7.12143 1.04791C7.33454 1.24777 7.4411 1.50592 7.4411 1.82237V5.71961H11.2772Z" fill="#ffffff"></path></svg>';
            html+= '</span>';
            html+= '</div>';

            if(product.available) {
              if( grid_item_buttonType == 'addtocart'){
                html+= '<button type="submit" class="mm_addToCart btn mm-text-black mm-ajax-add" data-price="' + product.price + '">Add To Bag • <span class="mm-text-black">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span></button>';
              } else {
                html+= '<button type="submit" class="mm_addToCart btn mm-text-black mm-ajax-buy">Buy & Try Now • <span class="mm-text-black">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span></button>';
              }
            } else {
              if(product.vendor == 'Delhigheespreads' || product.vendor == 'Mumbaigheespreads' || product.vendor == 'Bangaloregheespreads'){
                html += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
              }else{
                html += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
              }
            }

            html+= '</div>';
            html+= '</div>';

            html+= '<div class="featured-product-img mm-desktop-hide mm-tablet-hide">';
            html+= '<img class="lazyload" data-src="' + grid_item_image + '" alt="' + grid_item_title + '">';
            html+= '</div>';

            html+= '</div>';

            html+= '<div class="mm-desktop-hide mm-tablet-hide block-product-price-wrap">';
            html+= '<div class="quantity-box flexbox">';
            html+= '<span class="minus-icon quantity-icon" data-symbol="-">';
            html+= '<svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.55309 3.23798C1.83259 3.23798 1.28601 3.13209 0.913341 2.92031C0.565515 2.70854 0.391602 2.41531 0.391602 2.04063C0.391602 1.66595 0.565515 1.37272 0.913341 1.16095C1.28601 0.93288 1.83259 0.818848 2.55309 0.818848H10.2301C10.9506 0.818848 11.4848 0.93288 11.8326 1.16095C12.2053 1.37272 12.3916 1.66595 12.3916 2.04063C12.3916 2.41531 12.2053 2.70854 11.8326 2.92031C11.4848 3.13209 10.9506 3.23798 10.2301 3.23798H2.55309Z" fill="#ffffff"></path></svg>';
            html+= '</span>';
            html+= '<input type="number" class="product-form__input" name="quantity" value="1" min="1">';
            html+= '<span class="plus-icon quantity-icon" data-symbol="+">';
            html+= '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2772 5.71961C11.5886 5.71961 11.8427 5.82786 12.0395 6.04438C12.2526 6.24423 12.3591 6.50238 12.3591 6.81883C12.3591 7.13527 12.2526 7.40175 12.0395 7.61826C11.8427 7.81812 11.5886 7.91805 11.2772 7.91805H7.4411V11.7903C7.4411 12.1067 7.33454 12.3732 7.12143 12.5897C6.9247 12.8063 6.67061 12.9145 6.35913 12.9145C6.04766 12.9145 5.78536 12.8063 5.57225 12.5897C5.37552 12.3732 5.27716 12.1067 5.27716 11.7903V7.91805H1.4411C1.12962 7.91805 0.867328 7.81812 0.654213 7.61826C0.457492 7.40175 0.359131 7.13527 0.359131 6.81883C0.359131 6.50238 0.457492 6.24423 0.654213 6.04438C0.867328 5.82786 1.12962 5.71961 1.4411 5.71961H5.27716V1.82237C5.27716 1.50592 5.37552 1.24777 5.57225 1.04791C5.78536 0.831401 6.04766 0.723145 6.35913 0.723145C6.67061 0.723145 6.9247 0.831401 7.12143 1.04791C7.33454 1.24777 7.4411 1.50592 7.4411 1.82237V5.71961H11.2772Z" fill="#ffffff"></path></svg>';
            html+= '</span>';
            html+= '</div>';
            
            if(product.available) {
              if( grid_item_buttonType == 'addtocart'){
                html+= '<button type="submit" class="mm_addToCart btn mm-text-black mm-ajax-add" data-price="' + product.price + '">Add To Bag • <span class="mm-text-black">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span></button>';
              } else {
                html+= '<button type="submit" class="mm_addToCart btn mm-text-black mm-ajax-buy">Buy & Try Now • <span class="mm-text-black">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span></button>';
              }
            } else {
              if(product.vendor == 'Delhigheespreads' || product.vendor == 'Mumbaigheespreads' || product.vendor == 'Bangaloregheespreads'){
                html += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
              }else{
                html += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
              }
            }
            
            html+= '</div>';
            html+= '</form>';
            html+= '</div>';
            
            containerEl.append(html);
          })
        );
      }
      
      $.when.apply(null, asyncRequest).done(function() {    
        const setColor = function(ele) {
          if (ele.data("color")) {
            ele.closest(".mm__hp-featured-product").css("background", ele.data("color"));
          }
        };

        var sliderOptions = containerEl.data('slider-options');

        containerEl.on("init", function(slick) {
          setColor($(slick.target).find(".slick-active"));
        })
        
        if(!containerEl.hasClass('slick-initialized')) {
          containerEl.slick(sliderOptions);
        }    

        containerEl.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
          setColor(slick.$slider.find('[data-slick-index="' + nextSlide + '"]'));
        });        
      });
    }
  }
  
  return FeaturedProductGrids;
})();

    
/*
 * Spreads landing page
 */    
theme.SpreadsProduct = (function() {  
  function SpreadsProduct(element) {
  	this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.productDetails =  this.element.data('product-details');

    if(!this.element.length) { return; }
    
    var depotCode = sessionStorage.getItem('DepotCode');  
    var containerEl = $('.js-container-' + this.sectionId);
    var collection = this.productDetails.spreadsProduct;
    
    if(collection.length) {
      var asyncRequest = [];
      containerEl.html('');
      
      for(var i=0; i<collection.length; i++) { 
        let grid_item = collection[i];         
        let grid_item_handle = grid_item.handle;
        let grid_item_weight = grid_item.weight;
        let grid_item_description = grid_item.description;
        let grid_item_buybutton = grid_item.showbuynow;

        //If depo code exists replace the last occurance of epigamia
        if(depotCode) {
          depotCode = depotCode.toLowerCase();
          grid_item_handle = grid_item_handle.replace(new RegExp('epigamia' + '$'), depotCode);
        }
        
        var quantityVal = containerEl.find('[name="quantity"]').val() || 1;
        quantityVal = parseInt(quantityVal);

        var productUrl = '/products/' + grid_item_handle + '.js';
       
        $.ajax({
          url: productUrl,
          type: 'GET',
          async: false,
          processData : false,
          contentType: false,
          dataType:'JSON',
          success: function(response) {
            var productHtml = '';                               
            var product = response;

            var product_title = product.title,
                product_title_2 = '';

            if(product.title.indexOf('-') > 0){
              var lastIndex = product.title.lastIndexOf("-");
              product_title = product.title.substring(0, lastIndex).trim();
              product_title_2 = product.title.substring(lastIndex + 1).trim();
            }

            var labelTag = '';
            for(var i=0; i<product.tags.length; i++){
              var tagList = product.tags[i];
              if(tagList.indexOf('badge--')>-1){
                labelTag = '<span class="label-list mm-text-bold">'+tagList.split('badge--')[1]+'</span>'
                break;
              }
            }

            var Saletag = '';
            for(var i=0; i<product.tags.length; i++){
            	var tagList = product.tags[i];
              if(tagList.indexOf('badge___')>-1){
                Saletag = tagList.split('badge___')[1]
                break;
              }
            } 
            
            productHtml += '<div class="grid__item small--one-whole medium--one-whole medium-up--one-third grid-view-item">';
            productHtml += '<div class="product-card product-card-overlay">';     
            productHtml += '<div class="product-top">';

            var sliderClass = 'slider-container';
            if(product.images.length > 1) {
              sliderClass = 'js-image-slider';
            }

            productHtml += '<div class="' + sliderClass + '">';
            for(var m=0; m<product.images.length; m++) {
              var product_image = product.images[m];
              
              if(product_image) {
                let om = product_image,
                    pi = om.split(".");
                pi[pi.length-2] = pi[pi.length-2] + "_400x";
                product_image = pi.join('.');
              }

              productHtml += '<div class="product-card__image-with-placeholder-wrapper '+ Saletag +'">';
              if(Saletag == 'Sale'){
                productHtml += '<a href="/products/' + product.handle + '" class="no-opac"><?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="top-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{opacity:0.5;fill:#CDCDCD;}.st6{fill:#FFFFFF;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="836.1284" y1="-31.6388" x2="-118.9136" y2="702.7809"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.2702" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M-0.41,856.88V541.63c0,0,0-77.82,52.8-131.03L407.2,54.79c0,0,51.33-54.79,127.15-54.79h290.19h35.91c0,0-80.81-3.07-131.69,56.79L52.38,732.18C52.38,732.18-0.41,776.07-0.41,856.88z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="26.9359" y1="979.4771" x2="26.9359" y2="730.6643"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M54.31,730.66v248.81c0,0-54.72-44.89-54.72-124.7C-0.41,854.77-3.4,782.39,54.31,730.66z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="981.5855" y1="27.1905" x2="730.8472" y2="27.1905"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M981.59,54.31H730.85c0,0,46.23-54.18,126.04-54.18C856.88,0.13,925.83-3.77,981.59,54.31z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="-36.5281" y1="649.5118" x2="92.5108" y2="615.4924"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M34.61,432.02C-0.41,482.45-0.41,541.63-0.41,541.63v315.25c0-80.81,54.72-124.7,54.72-124.7l0.04-18.51l-0.04-304.99c0,0-4.08,4.2-8.2,8.64C41.99,421.75,34.61,432.02,34.61,432.02z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="680.4171" y1="-68.5959" x2="588.5" y2="122.5338"><stop offset="0.0307" style="stop-color:#FFFFFF;stop-opacity:0.2"/><stop offset="0.8105" style="stop-color:#FEB0B1"/></linearGradient><path class="st4" d="M408.95,52.92C434.22,27.86,480.78,0,534.36,0h290.19h35.91c0,0-73.74-4.73-128.28,52.92H418.26H408.95z"/></g><polygon class="st5" points="52.26,732.18 52.26,767.76 766.59,52.92 732.59,52.92 "/></g><g><g><path class="st6" d="M192.8,470.38c0,0,21.92-0.99,34.65-13.72c5.09-5.09,8.63-12.59,2.55-18.67c-12.02-12.02-57.13,33.94-88.25,2.83c-18.67-18.67-15.27-46.67,4.81-66.75c21.78-21.78,43.98-21.07,43.98-21.07l9.76,30.69c0,0-19.09,1.27-31.25,13.44c-5.09,5.09-8.48,13.01-2.83,18.67c12.73,12.73,56-35.07,87.96-3.11c16.83,16.83,18.53,44.26-4.24,67.03c-23.76,23.76-51.34,22.49-51.34,22.49L192.8,470.38z"/><path class="st6" d="M330.26,353.57l-31.54,31.54l15.13,27.29l-25.46,25.46l-66.75-135.48l26.02-26.02l135.48,66.75l-25.46,25.46L330.26,353.57z M257.57,312.56c0,0,8.77,13.29,13.29,21.5l13.86,25.46l19.94-19.94l-25.31-14c-8.2-4.53-21.5-13.29-21.5-13.29L257.57,312.56z"/><path class="st6" d="M293.35,230.68l24.75-24.75l79.9,79.9l41.29-41.29l21.21,21.21l-66.04,66.04L293.35,230.68z"/><path class="st6" d="M372.97,151.06l63.36-63.36l21.21,21.21l-38.61,38.61l18.38,18.38l30.83-30.83l21.21,21.21l-30.83,30.83l19.09,19.09l40.59-40.59l21.21,21.21l-65.34,65.34L372.97,151.06z"/></g></g></svg></a>'
              }
              productHtml += '<div class="grid-view-item__image-wrapper product-card__image-wrapper">';
              productHtml += labelTag;
              productHtml += '<a class="no-opac">';
              productHtml += '<img class="lazyload" data-src="'+  product_image +'" alt="'+ product.title +'" />';
              productHtml += '</a>';          
              productHtml += '</div>';
              
              if(product.compare_at_price > product.price) {
                var discountPrice = product.compare_at_price - product.price;
                var discountPercentage = (discountPrice / product.compare_at_price) * 100;
                discountPercentage = Math.round(discountPercentage);

                if(Saletag == 'Sale'){
                  if(discountPercentage >= 30){
                    productHtml += '<span class="bottom-badge-container">';
                    productHtml += '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="bottom-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{fill:url(#SVGID_6_);}.st6{opacity:0.5;fill:#CDCDCD;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-1796.2583" y1="1677.0334" x2="-935.3876" y2="1677.0334" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.0921" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M2047.34,1190.49v315.25c0,0,0,77.82-52.8,131.03l-354.82,355.81c0,0-51.33,54.79-127.15,54.79h-290.19h-35.91c0,0,80.81,3.07,131.69-56.79l676.39-675.39C1994.54,1315.19,2047.34,1271.3,2047.34,1190.49z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="-1769.923" y1="2230.1897" x2="-1769.923" y2="1980.7839" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M1994.54,1315.19v-249.41c0,0,52.8,44.89,52.8,124.7C2047.34,1190.49,2052.62,1259.43,1994.54,1315.19z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="-814.2605" y1="1275.0674" x2="-1063.6663" y2="1275.0674" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M1065.34,1994.45h249.41c0,0-44.89,52.8-124.7,52.8C1190.04,2047.24,1121.09,2052.53,1065.34,1994.45z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="2061.3176" y1="1400.7207" x2="1803.2661" y2="1483.1906"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="1405.452" y1="2138.2439" x2="1413.4331" y2="1999.9065"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st4" d="M1637.98,1994.45c-25.27,25.07-71.83,52.92-125.41,52.92h-290.19h-35.91c0,0,73.74,4.73,128.28-52.92h313.92H1637.98z"/><linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="2135.5977" y1="1357.4199" x2="1864.2437" y2="1490.4365"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st5" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/></g><polygon class="st6" points="1637.98,1994.45 1994.54,1636.76 1994.54,1668.95 1672.94,1994.45 "/></g></svg>'
                    productHtml += '<span class="bottom-discount">'+ discountPercentage +'%Off</span>';
                    productHtml += '</span>';
                  }
                } else {
                  if(discountPercentage >= 15){
                    productHtml += '<span class="discount_badge">';
                    productHtml += '<svg xmlns="http://www.w3.org/2000/svg" id="Group_12" data-name="Group 12" width="55.043" height="50.614" viewBox="0 0 55.043 50.614"><g id="Group_11" data-name="Group 11" transform="translate(0 0)"><path id="Path_6" data-name="Path 6" d="M825.927,58.6h5.979c.012-2.663-1.339-4.8-2.99-4.8S825.927,55.945,825.927,58.6Z" transform="translate(-825.927 -53.794)" fill="#890303"/><path id="Path_7" data-name="Path 7" d="M1103.367,58.6h5.98c.012-2.663-1.339-4.8-2.99-4.8S1103.367,55.945,1103.367,58.6Z" transform="translate(-1054.303 -53.794)" fill="#890303"/><path id="Path_8" data-name="Path 8" d="M891.895,53.794H842.831c1.651,0,3,2.141,2.99,4.8h0V90.611a3.215,3.215,0,0,0,1.608,2.785l18.327,10.581a3.215,3.215,0,0,0,3.215,0L887.3,93.4a3.216,3.216,0,0,0,1.608-2.785V58.6C888.905,55.945,890.244,53.794,891.895,53.794Z" transform="translate(-839.841 -53.794)" fill="#dd3838"/></g></svg>';
                    productHtml += '<span>'+ discountPercentage +'%<br>Off</span>'
                    productHtml += '</span>'; 
                  }
                }
              }
              
              productHtml += '</div>';
            }
            productHtml += '</div>';

            productHtml += '<div class="product-card__detail">';  
            productHtml += '<div class="h4 grid-view-item__title product-card__title">';          
            productHtml += '<a class="no-opac product-title">';          
            productHtml += '<span class="product-title--p1 mm-text-black">'+  product_title +'</span>';
            productHtml += '</a>';
            productHtml += '</div>';
            productHtml += '<p class="product-weight mm-text-bold">'+ grid_item_weight +'</p>';
            
            productHtml += '<p class="product-description mm-text-bold">'+ grid_item_description +'</p>';

            productHtml += '<div class="price--button-wrapper">';

            if(product.compare_at_price > product.price) {
              var discountPrice = product.compare_at_price - product.price;

              productHtml += '<dl class="price price--listing price--on-sale ">'; 

              productHtml += '<div class="price__sale">';

              productHtml += '<div class="price__compare">';
              productHtml += '<dd>';
              productHtml += '<s class="price-item price-item--regular mm-text-bold">' + Shopify.formatMoney(product.compare_at_price, theme.moneyFormat) + '</s>';
              productHtml += '</dd>';
              productHtml += '</div>';

              productHtml += '<dd>';            
              productHtml += '<span class="price-item price-item--sale mm-text-bold">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
              productHtml += '</dd>';

              productHtml += '</div>';

              productHtml += '<span class="price__badge price__badge--sale">';
              productHtml += '<span class="mm-text-bold">' + Shopify.formatMoney(discountPrice, theme.moneyFormat) + ' off</span>'
              productHtml += '</span>';            
              productHtml += '</dl>';
            } else {
              productHtml += '<div class="price__regular">';
              productHtml += '<dd>';
              productHtml += '<span class="price-item price-item--regular mm-text-bold">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
              productHtml += '</dd>';
              productHtml += '</div>';
            }

            productHtml += '</div>';

            productHtml += '<div class="quantity-button-wrapper">';

            productHtml += '<form method="post" action="/cart/add" class="shopify-product-form" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';

            productHtml += '<input type="hidden" name="form_type" value="product">';
            productHtml += '<input type="hidden" name="utf8" value="✓">';
            productHtml += '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

            productHtml += '<div class="buttons-wrapper">';
            productHtml += '<div class="quantity-box flexbox">';
            productHtml += '<span class="minus-icon quantity-icon" data-symbol="-">';
            productHtml += '<svg width="9" height="18" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.55309 3.23798C1.83259 3.23798 1.28601 3.13209 0.913341 2.92031C0.565515 2.70854 0.391602 2.41531 0.391602 2.04063C0.391602 1.66595 0.565515 1.37272 0.913341 1.16095C1.28601 0.93288 1.83259 0.818848 2.55309 0.818848H10.2301C10.9506 0.818848 11.4848 0.93288 11.8326 1.16095C12.2053 1.37272 12.3916 1.66595 12.3916 2.04063C12.3916 2.41531 12.2053 2.70854 11.8326 2.92031C11.4848 3.13209 10.9506 3.23798 10.2301 3.23798H2.55309Z" fill="#ffffff"></path></svg>';
            productHtml += '</span>';
            productHtml += '<input type="number" class="product-form__input" name="quantity" value="1" min="1">';
            productHtml += '<span class="plus-icon quantity-icon" data-symbol="+">';
            productHtml += '<svg width="9" height="18" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2772 5.71961C11.5886 5.71961 11.8427 5.82786 12.0395 6.04438C12.2526 6.24423 12.3591 6.50238 12.3591 6.81883C12.3591 7.13527 12.2526 7.40175 12.0395 7.61826C11.8427 7.81812 11.5886 7.91805 11.2772 7.91805H7.4411V11.7903C7.4411 12.1067 7.33454 12.3732 7.12143 12.5897C6.9247 12.8063 6.67061 12.9145 6.35913 12.9145C6.04766 12.9145 5.78536 12.8063 5.57225 12.5897C5.37552 12.3732 5.27716 12.1067 5.27716 11.7903V7.91805H1.4411C1.12962 7.91805 0.867328 7.81812 0.654213 7.61826C0.457492 7.40175 0.359131 7.13527 0.359131 6.81883C0.359131 6.50238 0.457492 6.24423 0.654213 6.04438C0.867328 5.82786 1.12962 5.71961 1.4411 5.71961H5.27716V1.82237C5.27716 1.50592 5.37552 1.24777 5.57225 1.04791C5.78536 0.831401 6.04766 0.723145 6.35913 0.723145C6.67061 0.723145 6.9247 0.831401 7.12143 1.04791C7.33454 1.24777 7.4411 1.50592 7.4411 1.82237V5.71961H11.2772Z" fill="#ffffff"></path></svg>';
            productHtml += '</span>';
            productHtml += '</div>';

            productHtml += '<div class="button-wrapper">';

            if(product.available) {
              productHtml += '<button type="submit" class="mm_addToCart btn mm-ajax-add overlay-atc" data-price="'+ product.price +'">ADD TO CART</button>';
            } else {
              productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
            }

            if(grid_item_buybutton == true){
              productHtml += '</div>';
              if(product.available) {
                productHtml += '<div class="buy-button-wrapper">';
                productHtml += '<button type="submit" class="mm_addToCart btn mm-ajax-buy" data-price="'+ product.price +'">BUY NOW</button>';
                productHtml += '</div>';
              }
              productHtml += '</div>';
            }

            productHtml += '</form>';
            productHtml += '</div>';
            productHtml += '</div>';
            productHtml += '</div>';
            productHtml += '</div>';
            productHtml += '</div>';

            containerEl.append(productHtml);


          }
        });          
      }
      $('.js-image-slider').each(function() {
        $(this).slick({
          dots: true,
          arrows: true 
        });
      })
      
      dataLayer.push({ 
        'event': 'Category View',
        'category id': "",
        'category': "Crafted By Deepika Ghee Spreads",
        'item_count': collection.length,
      });
    }
  }
  
  return SpreadsProduct;
})();
    
   

/*
 * Article template product
 */ 
theme.ArticleTemplateProduct = (function () {
  function ArticleTemplateProduct(element) {

    this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.productHandle =  this.element.data('product-handle');

    if(!this.element.length) { return; }

    var containerElement = $('.js-container-' + this.sectionId);
    
    if(this.productHandle) {
      var depotCode = sessionStorage.getItem('DepotCode');  
      var productHandle = this.productHandle;
      
      if(depotCode) {
        depotCode = depotCode.toLowerCase();
        productHandle = productHandle.replace(new RegExp('epigamia' + '$'), depotCode);
      }
      
      var productUrl = '/products/' + productHandle + '.js';
      
      $.getJSON(productUrl, function(response) {
        var productHtml = '';
        var product = response;
        
        if(product.featured_image) {
          let om = product.featured_image,
              pi = om.split(".");
          pi[pi.length-2] = pi[pi.length-2] + "_400x";
          var product_image = pi.join('.');
        } else {
          var product_image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_180x.gif';
        }

        var product_title = product.title,
            product_title_2 = '';

        if(product.title.indexOf('-') > 0){
          var lastIndex = product.title.lastIndexOf("-");
          product_title = product.title.substring(0, lastIndex).trim();
          product_title_2 = product.title.substring(lastIndex + 1).trim();
        }

        var labelTag = '';
        for(var i=0; i<product.tags.length; i++){
          var tagList = product.tags[i];
          if(tagList.indexOf('badge--')>-1){
            labelTag = '<span class="label-list">'+tagList.split('badge--')[1]+'</span>'
            break;
          }
        }
        var Saletag = '';
        for(var i=0; i<product.tags.length; i++){
          var tagList = product.tags[i];
          if(tagList.indexOf('badge___')>-1){
            Saletag = tagList.split('badge___')[1]
            break;
          }
        } 
        productHtml += '<div class="product-card">';
        productHtml += '<div class="product-top">';

        productHtml += '<div class="product-card__image-with-placeholder-wrapper '+ Saletag +'">';
        if(Saletag == 'Sale'){
          productHtml += '<a href="/products/' + product.handle + '" class="no-opac"><?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="top-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{opacity:0.5;fill:#CDCDCD;}.st6{fill:#FFFFFF;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="836.1284" y1="-31.6388" x2="-118.9136" y2="702.7809"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.2702" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M-0.41,856.88V541.63c0,0,0-77.82,52.8-131.03L407.2,54.79c0,0,51.33-54.79,127.15-54.79h290.19h35.91c0,0-80.81-3.07-131.69,56.79L52.38,732.18C52.38,732.18-0.41,776.07-0.41,856.88z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="26.9359" y1="979.4771" x2="26.9359" y2="730.6643"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M54.31,730.66v248.81c0,0-54.72-44.89-54.72-124.7C-0.41,854.77-3.4,782.39,54.31,730.66z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="981.5855" y1="27.1905" x2="730.8472" y2="27.1905"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M981.59,54.31H730.85c0,0,46.23-54.18,126.04-54.18C856.88,0.13,925.83-3.77,981.59,54.31z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="-36.5281" y1="649.5118" x2="92.5108" y2="615.4924"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M34.61,432.02C-0.41,482.45-0.41,541.63-0.41,541.63v315.25c0-80.81,54.72-124.7,54.72-124.7l0.04-18.51l-0.04-304.99c0,0-4.08,4.2-8.2,8.64C41.99,421.75,34.61,432.02,34.61,432.02z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="680.4171" y1="-68.5959" x2="588.5" y2="122.5338"><stop offset="0.0307" style="stop-color:#FFFFFF;stop-opacity:0.2"/><stop offset="0.8105" style="stop-color:#FEB0B1"/></linearGradient><path class="st4" d="M408.95,52.92C434.22,27.86,480.78,0,534.36,0h290.19h35.91c0,0-73.74-4.73-128.28,52.92H418.26H408.95z"/></g><polygon class="st5" points="52.26,732.18 52.26,767.76 766.59,52.92 732.59,52.92 "/></g><g><g><path class="st6" d="M192.8,470.38c0,0,21.92-0.99,34.65-13.72c5.09-5.09,8.63-12.59,2.55-18.67c-12.02-12.02-57.13,33.94-88.25,2.83c-18.67-18.67-15.27-46.67,4.81-66.75c21.78-21.78,43.98-21.07,43.98-21.07l9.76,30.69c0,0-19.09,1.27-31.25,13.44c-5.09,5.09-8.48,13.01-2.83,18.67c12.73,12.73,56-35.07,87.96-3.11c16.83,16.83,18.53,44.26-4.24,67.03c-23.76,23.76-51.34,22.49-51.34,22.49L192.8,470.38z"/><path class="st6" d="M330.26,353.57l-31.54,31.54l15.13,27.29l-25.46,25.46l-66.75-135.48l26.02-26.02l135.48,66.75l-25.46,25.46L330.26,353.57z M257.57,312.56c0,0,8.77,13.29,13.29,21.5l13.86,25.46l19.94-19.94l-25.31-14c-8.2-4.53-21.5-13.29-21.5-13.29L257.57,312.56z"/><path class="st6" d="M293.35,230.68l24.75-24.75l79.9,79.9l41.29-41.29l21.21,21.21l-66.04,66.04L293.35,230.68z"/><path class="st6" d="M372.97,151.06l63.36-63.36l21.21,21.21l-38.61,38.61l18.38,18.38l30.83-30.83l21.21,21.21l-30.83,30.83l19.09,19.09l40.59-40.59l21.21,21.21l-65.34,65.34L372.97,151.06z"/></g></g></svg></a>'
        }
        productHtml += '<div class="grid-view-item__image-wrapper product-card__image-wrapper">';
        productHtml += labelTag;
        productHtml += '<a href="/products/' + product.handle + '" class="no-opac">';
        productHtml += '<img class="lazyload" data-src="'+ product_image +'" alt="'+ product.title +'" />';
        productHtml += '</a>';          
        productHtml += '</div>';
        
        if(product.compare_at_price > product.price) {
          var discountPrice = product.compare_at_price - product.price;
          var discountPercentage = (discountPrice / product.compare_at_price) * 100;
          discountPercentage = Math.round(discountPercentage);

          if(Saletag == 'Sale'){
            if(discountPercentage >= 30){
              productHtml += '<span class="bottom-badge-container">';
              productHtml += '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="bottom-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{fill:url(#SVGID_6_);}.st6{opacity:0.5;fill:#CDCDCD;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-1796.2583" y1="1677.0334" x2="-935.3876" y2="1677.0334" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.0921" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M2047.34,1190.49v315.25c0,0,0,77.82-52.8,131.03l-354.82,355.81c0,0-51.33,54.79-127.15,54.79h-290.19h-35.91c0,0,80.81,3.07,131.69-56.79l676.39-675.39C1994.54,1315.19,2047.34,1271.3,2047.34,1190.49z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="-1769.923" y1="2230.1897" x2="-1769.923" y2="1980.7839" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M1994.54,1315.19v-249.41c0,0,52.8,44.89,52.8,124.7C2047.34,1190.49,2052.62,1259.43,1994.54,1315.19z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="-814.2605" y1="1275.0674" x2="-1063.6663" y2="1275.0674" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M1065.34,1994.45h249.41c0,0-44.89,52.8-124.7,52.8C1190.04,2047.24,1121.09,2052.53,1065.34,1994.45z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="2061.3176" y1="1400.7207" x2="1803.2661" y2="1483.1906"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="1405.452" y1="2138.2439" x2="1413.4331" y2="1999.9065"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st4" d="M1637.98,1994.45c-25.27,25.07-71.83,52.92-125.41,52.92h-290.19h-35.91c0,0,73.74,4.73,128.28-52.92h313.92H1637.98z"/><linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="2135.5977" y1="1357.4199" x2="1864.2437" y2="1490.4365"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st5" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/></g><polygon class="st6" points="1637.98,1994.45 1994.54,1636.76 1994.54,1668.95 1672.94,1994.45 "/></g></svg>'
              productHtml += '<span class="bottom-discount">'+ discountPercentage +'%Off</span>';
              productHtml += '</span>';
            }
          } else {
            if(discountPercentage >= 15){
              productHtml += '<span class="discount_badge">';
              productHtml += '<svg xmlns="http://www.w3.org/2000/svg" id="Group_12" data-name="Group 12" width="55.043" height="50.614" viewBox="0 0 55.043 50.614"><g id="Group_11" data-name="Group 11" transform="translate(0 0)"><path id="Path_6" data-name="Path 6" d="M825.927,58.6h5.979c.012-2.663-1.339-4.8-2.99-4.8S825.927,55.945,825.927,58.6Z" transform="translate(-825.927 -53.794)" fill="#890303"/><path id="Path_7" data-name="Path 7" d="M1103.367,58.6h5.98c.012-2.663-1.339-4.8-2.99-4.8S1103.367,55.945,1103.367,58.6Z" transform="translate(-1054.303 -53.794)" fill="#890303"/><path id="Path_8" data-name="Path 8" d="M891.895,53.794H842.831c1.651,0,3,2.141,2.99,4.8h0V90.611a3.215,3.215,0,0,0,1.608,2.785l18.327,10.581a3.215,3.215,0,0,0,3.215,0L887.3,93.4a3.216,3.216,0,0,0,1.608-2.785V58.6C888.905,55.945,890.244,53.794,891.895,53.794Z" transform="translate(-839.841 -53.794)" fill="#dd3838"/></g></svg>';
              productHtml += '<span>'+ discountPercentage +'%<br>Off</span>'
              productHtml += '</span>'; 
            }
          }
        }
        
        productHtml += '</div>';

        productHtml += '<div class="product-card__detail">';     
        productHtml += '<div class="h4 grid-view-item__title product-card__title">';          
        productHtml += '<a href="/products/'+ product.handle +'" class="no-opac product-title">';          
        productHtml += '<span class="product-title--p1">'+ product_title +'</span>';

        if(product_title_2 != '') {
          productHtml += '<span class="product-title--p2">'+ product_title_2 +'</span>';
        }

        productHtml += '</a>';
        productHtml += '</div>';

        productHtml += '<div class="price--button-wrapper">';

        if(product.compare_at_price > product.price) {
          var discountPrice = product.compare_at_price - product.price;

          productHtml += '<dl class="price price--listing price--on-sale ">';            
          productHtml += '<div class="price__sale">';
          productHtml += '<dd>';            
          productHtml += '<span class="price-item price-item--sale">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
          productHtml += '</dd>';

          productHtml += '<div class="price__compare">';
          productHtml += '<dd>';
          productHtml += '<s class="price-item price-item--regular">' + Shopify.formatMoney(product.compare_at_price, theme.moneyFormat) + '</s>';
          productHtml += '</dd>';
          productHtml += '</div>';
          productHtml += '</div>';

          productHtml += '<span class="price__badge price__badge--sale">';
          productHtml += '<span>' + Shopify.formatMoney(discountPrice, theme.moneyFormat) + ' off</span>'
          productHtml += '</span>';            
          productHtml += '</dl>';
        } else {
          productHtml += '<div class="price__regular">';
          productHtml += '<dd>';
          productHtml += '<span class="price-item price-item--regular">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
          productHtml += '</dd>';
          productHtml += '</div>';
        }

        productHtml += '<div class="button-wrapper">';

        productHtml += '<form method="post" action="/cart/add" class="shopify-product-form" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';
        productHtml += '<input type="hidden" name="form_type" value="product">';
        productHtml += '<input type="hidden" name="utf8" value="✓">';
        productHtml += '<input type="hidden" name="quantity" value="1">';
        productHtml += '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

        if(product.available) {
          productHtml += '<button type="submit" class="mm_addToCart btn mm-ajax-add" data-price="'+ product.price +'">ADD</button>';
        } else {
          productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
        }

        productHtml += '</form>';

        productHtml += '</div>';
        productHtml += '</div>';
        productHtml += '</div>';
        productHtml += '</div>';
        productHtml += '</div>';
        
        containerElement.html(productHtml);
      });  
    }
  }

  return ArticleTemplateProduct;
})();    


/*
 * Product Recommendations
 */
theme.ProductRecommendations = (function() {
  function ProductRecommendations(element) {
  	this.element = $(element);
    this.sectionId = this.element.data('section-id');
    
    if(!this.element.length) { return; }

    var baseUrl = this.element.data('base-url');
    var productId = this.element.data('product-id');
    var productLimit = this.element.data('product-limit');
    var sliderElement = $('.js-slider-' + this.sectionId);
    var sliderOptions = this.element.data('slider-options');
    
    var dataSectionType = this.element.data('section-type');
    
    //Helper function to hide the section
    function hideRecommendationsSection() {
      $(element).hide();
    }
    
    //Helper function to create html
    function renderProducts(handleArray) {
      var depotCode = sessionStorage.getItem('DepotCode');
      var asyncRequest = [];
      
      if(sliderElement.hasClass('slick-initialized')) {
        sliderElement.slick('unslick');
        sliderElement.html('');
      }
      
      for(var i=0; i<handleArray.length; i++) {
        var productHandle = handleArray[i];
            
        if(depotCode) {
          depotCode = depotCode.toLowerCase();
          productHandle = productHandle.replace(new RegExp('epigamia' + '$'), depotCode);
        }

        var productUrl = '/products/' + productHandle + '.js';
        
        asyncRequest.push(
          $.getJSON(productUrl, function(response) {
            var html = '';
            var product = response;                       

            sliderElement.append(
              renderProductCard(product)
            );
          })
        );
      }
      if (window.location.href.indexOf('/product/') != -1) {
      	getBrandInfo();
      }
      $.when.apply(null, asyncRequest).done( function() {
        
        if (!sliderElement.length) return;
        if (!sliderElement.hasClass('slick-initialized')) {
          sliderElement.slick(sliderOptions);
        }
      });
    }
    

    var request = new XMLHttpRequest();
    request.open('GET', baseUrl + '.json?product_id=' + productId + '&limit=' + productLimit);
    
    request.onload = function() {
      if (request.status === 404 || request.status === 422) {
        return hideRecommendationsSection();
      }

      var handleArray = [];
      var originalRecommendationProducts = JSON.parse(request.response).products;

      if (originalRecommendationProducts.length === 0) {
        return hideRecommendationsSection();
      }
     
      originalRecommendationProducts.map(function(p) {
        handleArray.push(p.handle);
      });
      
      renderProducts(handleArray);
    };
    request.send();
  }
  
  return ProductRecommendations;
})();
    
    
/* Collection Pinning Product */
theme.CollectionFeaturedProduct = (function() {
    function CollectionFeaturedProduct(element) {

        this.element = $(element);
        this.sectionId = this.element.data('section-id');
        this.productHandles = this.element.data('product-handle');
        this.featuredHandle = this.productHandles.split(',');

        this.featuredHandle.forEach((item, index) => {

            let containerElement;
            let sectionId = this.sectionId;


            if (item) {
                var depotCode = sessionStorage.getItem('DepotCode');
                var productHandle = item;

                if (depotCode) {
                    depotCode = depotCode.toLowerCase();
                    productHandle = productHandle.replace(new RegExp('epigamia' + '$'), depotCode);
                }

                var productUrl = '/products/' + productHandle + '.js';

                $.getJSON(productUrl, function(response) {
                    var productHtml = '';
                    var product = response;
                    console.log(product.title)

                    containerElement = $(`.js-container-${sectionId}[data-container-id="${index}"]`);


                    if (product.featured_image) {
                        let om = product.featured_image,
                            pi = om.split(".");
                        pi[pi.length - 2] = pi[pi.length - 2] + "_400x";
                        var product_image = pi.join('.');
                    } else {
                        var product_image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_180x.gif';
                    }

                    var product_title = product.title,
                        product_title_2 = '';

                    if (product.title.indexOf('-') > 0) {
                        var lastIndex = product.title.lastIndexOf("-");
                        product_title = product.title.substring(0, lastIndex).trim();
                        product_title_2 = product.title.substring(lastIndex + 1).trim();
                    }

                    var labelTag = '';
                    for (var i = 0; i < product.tags.length; i++) {
                        var tagList = product.tags[i];
                        if (tagList.indexOf('badge--') > -1) {
                            labelTag = '<span class="label-list">' + tagList.split('badge--')[1] + '</span>'
                            break;
                        }
                    }
                    var Saletag = '';
                    for (var i = 0; i < product.tags.length; i++) {
                        var tagList = product.tags[i];
                        if (tagList.indexOf('badge___') > -1) {
                            Saletag = tagList.split('badge___')[1]
                            break;
                        }
                    }

                    var productPrice = product.price / 100;
                    var productRetailPrice = product.compare_at_price / 100;
                    var discountProductPrice = productRetailPrice - productPrice;

                    productHtml += '<div class="product-card">';
                    productHtml += '<div class="product-top">';

                    productHtml += '<div class="product-card__image-with-placeholder-wrapper ' + Saletag + '">';
                    if (Saletag == 'Sale') {
                        productHtml += '<a href="/products/' + product.handle + '" class="no-opac"><?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="top-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{opacity:0.5;fill:#CDCDCD;}.st6{fill:#FFFFFF;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="836.1284" y1="-31.6388" x2="-118.9136" y2="702.7809"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.2702" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M-0.41,856.88V541.63c0,0,0-77.82,52.8-131.03L407.2,54.79c0,0,51.33-54.79,127.15-54.79h290.19h35.91c0,0-80.81-3.07-131.69,56.79L52.38,732.18C52.38,732.18-0.41,776.07-0.41,856.88z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="26.9359" y1="979.4771" x2="26.9359" y2="730.6643"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M54.31,730.66v248.81c0,0-54.72-44.89-54.72-124.7C-0.41,854.77-3.4,782.39,54.31,730.66z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="981.5855" y1="27.1905" x2="730.8472" y2="27.1905"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M981.59,54.31H730.85c0,0,46.23-54.18,126.04-54.18C856.88,0.13,925.83-3.77,981.59,54.31z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="-36.5281" y1="649.5118" x2="92.5108" y2="615.4924"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M34.61,432.02C-0.41,482.45-0.41,541.63-0.41,541.63v315.25c0-80.81,54.72-124.7,54.72-124.7l0.04-18.51l-0.04-304.99c0,0-4.08,4.2-8.2,8.64C41.99,421.75,34.61,432.02,34.61,432.02z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="680.4171" y1="-68.5959" x2="588.5" y2="122.5338"><stop offset="0.0307" style="stop-color:#FFFFFF;stop-opacity:0.2"/><stop offset="0.8105" style="stop-color:#FEB0B1"/></linearGradient><path class="st4" d="M408.95,52.92C434.22,27.86,480.78,0,534.36,0h290.19h35.91c0,0-73.74-4.73-128.28,52.92H418.26H408.95z"/></g><polygon class="st5" points="52.26,732.18 52.26,767.76 766.59,52.92 732.59,52.92 "/></g><g><g><path class="st6" d="M192.8,470.38c0,0,21.92-0.99,34.65-13.72c5.09-5.09,8.63-12.59,2.55-18.67c-12.02-12.02-57.13,33.94-88.25,2.83c-18.67-18.67-15.27-46.67,4.81-66.75c21.78-21.78,43.98-21.07,43.98-21.07l9.76,30.69c0,0-19.09,1.27-31.25,13.44c-5.09,5.09-8.48,13.01-2.83,18.67c12.73,12.73,56-35.07,87.96-3.11c16.83,16.83,18.53,44.26-4.24,67.03c-23.76,23.76-51.34,22.49-51.34,22.49L192.8,470.38z"/><path class="st6" d="M330.26,353.57l-31.54,31.54l15.13,27.29l-25.46,25.46l-66.75-135.48l26.02-26.02l135.48,66.75l-25.46,25.46L330.26,353.57z M257.57,312.56c0,0,8.77,13.29,13.29,21.5l13.86,25.46l19.94-19.94l-25.31-14c-8.2-4.53-21.5-13.29-21.5-13.29L257.57,312.56z"/><path class="st6" d="M293.35,230.68l24.75-24.75l79.9,79.9l41.29-41.29l21.21,21.21l-66.04,66.04L293.35,230.68z"/><path class="st6" d="M372.97,151.06l63.36-63.36l21.21,21.21l-38.61,38.61l18.38,18.38l30.83-30.83l21.21,21.21l-30.83,30.83l19.09,19.09l40.59-40.59l21.21,21.21l-65.34,65.34L372.97,151.06z"/></g></g></svg></a>'
                    }
                    productHtml += '<div class="grid-view-item__image-wrapper product-card__image-wrapper">';
                    productHtml += labelTag;
                    productHtml += '<a href="/products/' + product.handle + '" class="no-opac">';
                    productHtml += '<img src="' + product_image + '" alt="' + product.title + '" />';
                    productHtml += '</a>';
                    productHtml += '</div>';

                    if (product.compare_at_price > product.price) {
                        var discountPrice = product.compare_at_price - product.price;
                        var discountPercentage = (discountPrice / product.compare_at_price) * 100;
                        discountPercentage = Math.round(discountPercentage);

                        if (Saletag == 'Sale') {
                            if (discountPercentage >= 30) {
                                productHtml += '<span class="bottom-badge-container">';
                                productHtml += '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" class="bottom-sale-badge" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2048 2048" style="enable-background:new 0 0 2048 2048;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:url(#SVGID_2_);}.st2{fill:url(#SVGID_3_);}.st3{fill:url(#SVGID_4_);}.st4{fill:url(#SVGID_5_);}.st5{fill:url(#SVGID_6_);}.st6{opacity:0.5;fill:#CDCDCD;}</style><g><g><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-1796.2583" y1="1677.0334" x2="-935.3876" y2="1677.0334" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#FFBCBA"/><stop offset="0.0921" style="stop-color:#FF5156"/><stop offset="0.465" style="stop-color:#FF0001"/><stop offset="0.8246" style="stop-color:#C20000"/></linearGradient><path class="st0" d="M2047.34,1190.49v315.25c0,0,0,77.82-52.8,131.03l-354.82,355.81c0,0-51.33,54.79-127.15,54.79h-290.19h-35.91c0,0,80.81,3.07,131.69-56.79l676.39-675.39C1994.54,1315.19,2047.34,1271.3,2047.34,1190.49z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="-1769.923" y1="2230.1897" x2="-1769.923" y2="1980.7839" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st1" d="M1994.54,1315.19v-249.41c0,0,52.8,44.89,52.8,124.7C2047.34,1190.49,2052.62,1259.43,1994.54,1315.19z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="-814.2605" y1="1275.0674" x2="-1063.6663" y2="1275.0674" gradientTransform="matrix(-1 0 0 -1 251.0784 3295.9746)"><stop offset="0" style="stop-color:#BA0200"/><stop offset="0.7256" style="stop-color:#8D0203"/><stop offset="0.9985" style="stop-color:#880100"/></linearGradient><path class="st2" d="M1065.34,1994.45h249.41c0,0-44.89,52.8-124.7,52.8C1190.04,2047.24,1121.09,2052.53,1065.34,1994.45z"/><linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="2061.3176" y1="1400.7207" x2="1803.2661" y2="1483.1906"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st3" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/><linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="1405.452" y1="2138.2439" x2="1413.4331" y2="1999.9065"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st4" d="M1637.98,1994.45c-25.27,25.07-71.83,52.92-125.41,52.92h-290.19h-35.91c0,0,73.74,4.73,128.28-52.92h313.92H1637.98z"/><linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="2135.5977" y1="1357.4199" x2="1864.2437" y2="1490.4365"><stop offset="0.0336" style="stop-color:#FFFFFF;stop-opacity:0.5"/><stop offset="1" style="stop-color:#F23938"/></linearGradient><path class="st5" d="M2012.32,1615.35c35.02-50.43,35.02-109.62,35.02-109.62v-315.25c0,80.81-52.8,124.7-52.8,124.7l0,0v321.57L2012.32,1615.35z"/></g><polygon class="st6" points="1637.98,1994.45 1994.54,1636.76 1994.54,1668.95 1672.94,1994.45 "/></g></svg>'
                                productHtml += '<span class="bottom-discount">' + discountPercentage + '%Off</span>';
                                productHtml += '</span>';
                            }
                        } else {
                            if (discountPercentage >= 15) {
                                productHtml += '<span class="discount_badge">';
                                productHtml += '<svg xmlns="http://www.w3.org/2000/svg" id="Group_12" data-name="Group 12" width="45.043" height="40.614" viewBox="0 0 55.043 50.614"><g id="Group_11" data-name="Group 11" transform="translate(0 0)"><path id="Path_6" data-name="Path 6" d="M825.927,58.6h5.979c.012-2.663-1.339-4.8-2.99-4.8S825.927,55.945,825.927,58.6Z" transform="translate(-825.927 -53.794)" fill="#890303"/><path id="Path_7" data-name="Path 7" d="M1103.367,58.6h5.98c.012-2.663-1.339-4.8-2.99-4.8S1103.367,55.945,1103.367,58.6Z" transform="translate(-1054.303 -53.794)" fill="#890303"/><path id="Path_8" data-name="Path 8" d="M891.895,53.794H842.831c1.651,0,3,2.141,2.99,4.8h0V90.611a3.215,3.215,0,0,0,1.608,2.785l18.327,10.581a3.215,3.215,0,0,0,3.215,0L887.3,93.4a3.216,3.216,0,0,0,1.608-2.785V58.6C888.905,55.945,890.244,53.794,891.895,53.794Z" transform="translate(-839.841 -53.794)" fill="#dd3838"/></g></svg>';
                                productHtml += '<span>' + discountPercentage + '%<br>Off</span>'
                                productHtml += '</span>';
                            }
                        }
                    }

                    productHtml += '</div>';

                    productHtml += '<div class="product-card__detail">';
                    productHtml += '<div class="h4 grid-view-item__title product-card__title">';
                    productHtml += '<a href="/products/' + product.handle + '" class="no-opac product-title">';
                    productHtml += '<span class="product-title--p1">' + product_title + '</span>';
                    productHtml += '</a>';
                    if (product_title_2 != '') {
                        productHtml += '<span class="product-title--p2">' + product_title_2 + '</span>';
                    }
                    productHtml += '</div>';

                    productHtml += '<div class="price--button-wrapper">';
                    let popPrice = product.price;
                    let priceLength = popPrice.toString().length;
                    let poplistingPrice = popPrice.toString().slice(0,priceLength-2);
                  
                    if (product.compare_at_price > product.price) {
                        var discountPrice = product.compare_at_price - product.price;

                        productHtml += '<dl class="price price--listing price--on-sale ">';
                        productHtml += '<div class="price__sale">';
                        productHtml += '<dd>';
                        productHtml += '<span class="price-item price-item--sale">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
                        productHtml += '</dd>';

                        productHtml += '<div class="price__compare">';
                        productHtml += '<dd>';
                        productHtml += '<s class="price-item price-item--regular">' + Shopify.formatMoney(product.compare_at_price, theme.moneyFormat) + '</s>';
                        productHtml += '</dd>';
                        productHtml += '</div>';
                        productHtml += '</div>';

                        productHtml += '<span class="price__badge price__badge--sale">';
                        productHtml += '<span>' + Shopify.formatMoney(discountPrice, theme.moneyFormat) + ' off</span>'
                        productHtml += '</span>';
                        productHtml += '</dl>';
                        productHtml += '<div class="pop-club-listing" price="'+ poplistingPrice +'"></div>';
                    } else {
                        productHtml += '<div class="price__regular">';
                        productHtml += '<dd>';
                        productHtml += '<span class="price-item price-item--regular">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
                        productHtml += '</dd>';
                        productHtml += '</div>';
                        productHtml += '<div class="pop-club-listing" price="'+ poplistingPrice +'"></div>';
                    }

                    productHtml += '<div class="button-wrapper">';
                    productHtml += '<span class="hide webenagage" data-title="' + product_title + '" data-size="' + product_title_2 + '"  data-id="' + product.id + '" data-image="' + product_image + '" data-price="' + productPrice + '" data-retail-price="' + productRetailPrice + '" data-discount= "' + discountProductPrice + '"></span>';
                    productHtml += '<form method="post" action="/cart/add" id="product_form_' + product.id + '" class="shopify-product-form" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';
                    productHtml += '<input type="hidden" name="form_type" value="product">';
                    productHtml += '<input type="hidden" name="utf8" value="✓">';
                    productHtml += '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

                    productHtml += '<div class="quantity-wrapper">';
                    productHtml += '<div class="quantity-box flexbox">';
                    productHtml += '<span class="minus-icon quantity-icon" data-symbol="-">';
                    productHtml += '<svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.55309 3.23798C1.83259 3.23798 1.28601 3.13209 0.913341 2.92031C0.565515 2.70854 0.391602 2.41531 0.391602 2.04063C0.391602 1.66595 0.565515 1.37272 0.913341 1.16095C1.28601 0.93288 1.83259 0.818848 2.55309 0.818848H10.2301C10.9506 0.818848 11.4848 0.93288 11.8326 1.16095C12.2053 1.37272 12.3916 1.66595 12.3916 2.04063C12.3916 2.41531 12.2053 2.70854 11.8326 2.92031C11.4848 3.13209 10.9506 3.23798 10.2301 3.23798H2.55309Z" fill="#bc4b54"></path></svg>';
                    productHtml += '</span>';
                    productHtml += '<input type="number" class="product-form__input" name="quantity" value="1" min="1">';
                    productHtml += '<span class="plus-icon quantity-icon" data-symbol="+">';
                    productHtml += '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2772 5.71961C11.5886 5.71961 11.8427 5.82786 12.0395 6.04438C12.2526 6.24423 12.3591 6.50238 12.3591 6.81883C12.3591 7.13527 12.2526 7.40175 12.0395 7.61826C11.8427 7.81812 11.5886 7.91805 11.2772 7.91805H7.4411V11.7903C7.4411 12.1067 7.33454 12.3732 7.12143 12.5897C6.9247 12.8063 6.67061 12.9145 6.35913 12.9145C6.04766 12.9145 5.78536 12.8063 5.57225 12.5897C5.37552 12.3732 5.27716 12.1067 5.27716 11.7903V7.91805H1.4411C1.12962 7.91805 0.867328 7.81812 0.654213 7.61826C0.457492 7.40175 0.359131 7.13527 0.359131 6.81883C0.359131 6.50238 0.457492 6.24423 0.654213 6.04438C0.867328 5.82786 1.12962 5.71961 1.4411 5.71961H5.27716V1.82237C5.27716 1.50592 5.37552 1.24777 5.57225 1.04791C5.78536 0.831401 6.04766 0.723145 6.35913 0.723145C6.67061 0.723145 6.9247 0.831401 7.12143 1.04791C7.33454 1.24777 7.4411 1.50592 7.4411 1.82237V5.71961H11.2772Z" fill="#bc4b54"></path></svg>';
                    productHtml += '</span>';
                    productHtml += '</div>';

                    if (product.available) {
                        productHtml += '<button type="submit" class="mm_addToCart btn mm-ajax-add mm-ajax-add-secondary" data-price="' + product.price + '">ADD</button>';
                    } else {
                        if (product.vendor == 'Delhigheespreads' || product.vendor == 'Mumbaigheespreads' || product.vendor == 'Bangaloregheespreads') {
                            productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
                        } else {
                            productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
                        }
                    }

                    productHtml += '</form>';
                    productHtml += '</div>';

                    productHtml += '</div>';
                    productHtml += '</div>';
                    productHtml += '</div>';
                    productHtml += '</div>';
                    productHtml += '</div>';

                    containerElement.html(productHtml);

                    if (Saletag == 'Sale') {
                        let myele = $('.js-container-collection-template');
                        $('.mm__collection-featured-product').append(myele);
                        console.log(myele + "ELEMENT");
                    }
                });
            }
        })
    }

    return CollectionFeaturedProduct;
})();


/*
 * kids Featured Products
 */

theme.KidsFeaturedProduct = (function () {
  function KidsFeaturedProduct(element) {

    this.element = $(element);
    this.sectionId = this.element.data('section-id');
    this.productHandles =  this.element.data('product-handle');

    if(!this.element.length) { return; }

    var buttonElement = $('.js-milkshake-multipack-' + this.sectionId);

    if(this.productHandles != '') {
      var depotCode = sessionStorage.getItem('DepotCode');  
      //var handleArray = this.productHandles.split(',');
      var asyncRequest = [];


        var productHandle = this.productHandles;
      console.log(productHandle);
            
        if(depotCode) {
          depotCode = depotCode.toLowerCase();
          productHandle = productHandle.replace(new RegExp('epigamia' + '$'), depotCode);
        }

        var productUrl = '/products/' + productHandle + '.js';

        asyncRequest.push(
          $.getJSON(productUrl, function(response) {
            var productHtml = '';
            var product = response; 
            var tagList = product.tags;
            var notAvailableTag = '';
            tagList.forEach((element) => {
              if(element.includes('not-available')){ notAvailableTag = element }
            });
            
            productHtml += '<div class="button-wrapper">';
            
              productHtml += '<form method="post" action="/cart/add" class="shopify-product-form" data-product-handle="' + product.handle + '" data-product-available="' + product.available + '">';
              productHtml += '<input type="hidden" name="form_type" value="product">';
              productHtml += '<input type="hidden" name="utf8" value="✓">';
              //productHtml += '<input type="hidden" name="quantity" value="1">';
              productHtml += '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

              productHtml+= '<div class="milkshake-page-quantity">';

              productHtml += '<div class="price--button-wrapper">';

            if(product.compare_at_price > product.price) {
              var discountPrice = product.compare_at_price - product.price;

              productHtml += '<dl class="price price--listing price--on-sale ">'; 

              productHtml += '<div class="price__sale">';

              productHtml += '<div class="price__compare">';
              productHtml += '<dd>';
              productHtml += '<s class="price-item price-item--regular mm-text-bold">' + Shopify.formatMoney(product.compare_at_price, theme.moneyFormat) + '</s>';
              productHtml += '</dd>';
              productHtml += '</div>';

              productHtml += '<dd>';            
              productHtml += '<span class="price-item price-item--sale mm-text-bold">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
              productHtml += '</dd>';

              productHtml += '</div>';

              productHtml += '<span class="price__badge price__badge--sale">';
              productHtml += '<span class="mm-text-bold">' + Shopify.formatMoney(discountPrice, theme.moneyFormat) + ' off</span>'
              productHtml += '</span>';            
              productHtml += '</dl>';
            } else {
              productHtml += '<div class="price__regular">';
              productHtml += '<dd>';
              productHtml += '<span class="price-item price-item--regular mm-text-bold">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
              productHtml += '</dd>';
              productHtml += '</div>';
            }

            productHtml += '</div>';
            
              productHtml+= '<div class="quantity-box flexbox">';
              productHtml+= '<span class="minus-icon quantity-icon" data-symbol="-">';
              productHtml+= '<svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.55309 3.23798C1.83259 3.23798 1.28601 3.13209 0.913341 2.92031C0.565515 2.70854 0.391602 2.41531 0.391602 2.04063C0.391602 1.66595 0.565515 1.37272 0.913341 1.16095C1.28601 0.93288 1.83259 0.818848 2.55309 0.818848H10.2301C10.9506 0.818848 11.4848 0.93288 11.8326 1.16095C12.2053 1.37272 12.3916 1.66595 12.3916 2.04063C12.3916 2.41531 12.2053 2.70854 11.8326 2.92031C11.4848 3.13209 10.9506 3.23798 10.2301 3.23798H2.55309Z" fill="#ffffff"></path></svg>';
              productHtml+= '</span>';
              productHtml+= '<input type="number" class="product-form__input" name="quantity" value="1" min="1">';
              productHtml+= '<span class="plus-icon quantity-icon" data-symbol="+">';
              productHtml+= '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2772 5.71961C11.5886 5.71961 11.8427 5.82786 12.0395 6.04438C12.2526 6.24423 12.3591 6.50238 12.3591 6.81883C12.3591 7.13527 12.2526 7.40175 12.0395 7.61826C11.8427 7.81812 11.5886 7.91805 11.2772 7.91805H7.4411V11.7903C7.4411 12.1067 7.33454 12.3732 7.12143 12.5897C6.9247 12.8063 6.67061 12.9145 6.35913 12.9145C6.04766 12.9145 5.78536 12.8063 5.57225 12.5897C5.37552 12.3732 5.27716 12.1067 5.27716 11.7903V7.91805H1.4411C1.12962 7.91805 0.867328 7.81812 0.654213 7.61826C0.457492 7.40175 0.359131 7.13527 0.359131 6.81883C0.359131 6.50238 0.457492 6.24423 0.654213 6.04438C0.867328 5.82786 1.12962 5.71961 1.4411 5.71961H5.27716V1.82237C5.27716 1.50592 5.37552 1.24777 5.57225 1.04791C5.78536 0.831401 6.04766 0.723145 6.35913 0.723145C6.67061 0.723145 6.9247 0.831401 7.12143 1.04791C7.33454 1.24777 7.4411 1.50592 7.4411 1.82237V5.71961H11.2772Z" fill="#ffffff"></path></svg>';
              productHtml+= '</span>';
              productHtml+= '</div>';
            
              if(notAvailableTag == 'not-available'){
              productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
              } else {
                if(product.available) {
                  productHtml += '<button type="submit" class="mm_addToCart btn mm-text-black mm-ajax-buy">Buy Now</span></button>';
                } else {
                  if(product.vendor == 'Delhigheespreads' || product.vendor == 'Mumbaigheespreads' || product.vendor == 'Bangaloregheespreads'){
                    productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">Not Available</button>';
                  }else{
                    productHtml += '<button type="button" class="mm_soldOut btn" disable="disabled">SOLD OUT</button>';
                  }
              }}
              productHtml += '</div>';
              productHtml += '</form>';
          
              productHtml += '</div>';
            buttonElement.html(' ');
            buttonElement.append(productHtml);
          })
        );    
    }
  }

  return KidsFeaturedProduct;
})();

function ajaxBuyNow() {
  if(addObjectBuy.url) { 
    var objectUrl = addObjectBuy.url;
    var depoCode = sessionStorage.getItem('DepotCode').toLowerCase();
    var productUrl = objectUrl.replace(new RegExp('epigamia' + '$'), depoCode);

    $.getJSON('/products/' + productUrl ,function(response){
      var variantId = response.product.variants[0].id;
      var quantity = $('[data-product-handle="' + objectUrl + '"] .product-form__input').val(); 

      setTimeout(function() {
        var formData = {
          'id': variantId,
          'quantity': quantity
        }

        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: formData,
          success: function (data) {
            $('.cart-adding-text').text('Adding your item to cart...');

            //Helper trigger to track add to cart dataLayer event
        	$(document).trigger('product:added', data);
            
            setTimeout(function () {
              $('.mm__pincode-content[data-pincode-success]').hide(); 
              $('.mm__pincode-close').click();
              if(theme.autoDiscountEnabled && theme.autoDiscountCode != ''){
				window.location.href = "/checkout?discount="+ theme.autoDiscountCode;
              }else{
                window.location.href = '/checkout';
              }
            }, 500);
          },
          error:function () {
            $('.cart-adding-text').text('Uhoo! This product is not available in your area.').css('color','#CA7077');
            
            setTimeout(function () {
              if(theme.templateName == 'collection'){
                location.reload();
              }
              if(theme.templateName == "product"){
                window.location.replace(productUrl);
              }
            }, 200); 
          }
        });
      }, 1000);
    });
  }
}

function ajaxAddToCart() {
  if(addObjectAddCart.url) { 
    var objectUrl = addObjectAddCart.url;
    var depoCode = sessionStorage.getItem('DepotCode').toLowerCase();
    var productUrl = objectUrl.replace(new RegExp('epigamia' + '$'), depoCode);

    $.getJSON('/products/' + productUrl ,function(response){
      var variantId = response.product.variants[0].id;
      var quantity = $('[data-product-handle="' + objectUrl + '"] .product-form__input').val(); 

      var ajaxProductPrice = parseInt(( ajaxAddPrice / 100 ) * quantity);
      
      setTimeout(function() {       
        var formData = {
          'id': variantId,
          'quantity': quantity
        }        

        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: formData,
          success: function (data) {
            $('.cart-adding-text').text('Adding your item to cart...');

            mmajaxcart.AjaxcartRender();
            
            setTimeout(function () {
              $('.mm__pincode-content[data-pincode-success]').hide(); 
              $('.mm__pincode-close').click();
              // document.querySelector('#pop-club-quick-buy3').style.display = 'block';
              //mmajaxcart.AjaxcartOpen();
            }, 1000);
          
            setTimeout(function () {
              if(theme.templateName == 'collection'){
                window.location.href = window.location.href + ('?return=cart');
              }
              if(theme.templateName == "product"){
                window.location.replace(productUrl);
              }
            }, 500);
            
            //Helper trigger to track add to cart dataLayer event
        	$(document).trigger('product:added', data);
          },
          error:function () {
            $('.cart-adding-text').text('Uhoo! This product is not available in your area.').css('color','#CA7077');
            
            setTimeout(function () {
              if(theme.templateName == 'collection'){
                if(sessionStorage.getItem('DepotCode') == 'Bangaloregheespreads' || 
                   sessionStorage.getItem('DepotCode') == 'Delhigheespreads' ||
                   sessionStorage.getItem('DepotCode') == 'Mumbaigheespreads' ) {
                  window.location.href = "https://epigamiastore.com/collections/pan-india-collection";
                } else{
                  location.reload();
                }
              }
              if(theme.templateName == "product"){
                window.location.replace(productUrl);
              }
            }, 2000); 
          }
        });
      }, 100);
    })
    .fail(function(){
      location.reload();
    });
  }
}
    
function ajaxRepeatAddToCart() {
  if(addObjectRepeatAddCart.url) { 
    var objectUrl = addObjectRepeatAddCart.url;
    var depoCode = sessionStorage.getItem('DepotCode').toLowerCase();
    var productUrl = objectUrl.replace(new RegExp('epigamia' + '$'), depoCode);
         
    $.getJSON('/products/' + productUrl + '.js' ,function(response){
      if(response.available == true){
        if(!sessionStorage.getItem('repeatIteam')) { 
          var inFakeCart = {};
          var inFakeCartDetail = {};
          var productVariantId = response.variants[0].id;
          
          if(repeatConditionValue == true){
            inFakeCart[productUrl] = ajaxRepeatAddPrice;
            sessionStorage.setItem('repeatSetType', 'value');
          }else{
            inFakeCart[productUrl] = 1; 
          }
          
          inFakeCartDetail[productVariantId] = 1;
          
          sessionStorage.setItem('repeatIteam', JSON.stringify(inFakeCart) );
          sessionStorage.setItem('repeatItemDetail', JSON.stringify(inFakeCartDetail) );
          sessionStorage.setItem('repeatIteamFirst', productUrl);
        }

        setTimeout(function () {
          location.reload();
        }, 500); 
      }
      else{
        $('.cart-adding-text').text('Uhoo! This product is not available in your area.').css('color','#CA7077');
        setTimeout(function () {
          location.reload();
        }, 200);   
      }
    });   
  }
}

function ajaxAddToCartTimer() {
  var timeleft = 3;
  var downloadTimer = setInterval(function(){
    if(timeleft <= 0){
      clearInterval(downloadTimer);
      document.getElementById("countdown").innerHTML = "0";
    } else {
      document.getElementById("countdown").innerHTML = timeleft + "...";
    }
    timeleft -= 1;
  }, 500);
}

$(document).on('pincodeChange', function() {
  var sections = new theme.Sections();

  sections.register('milkshake-multipack-product', theme.MilkshakeMultipackButton);
  sections.register('milkshake-products', theme.MilkshakeProductSlider);
  sections.register('homepage--feature-product', theme.FeaturedProductGrids); 
  sections.register('homepage--product-list', theme.HomepageProductSlider);
  sections.register('pdp-product-recommendation', theme.productRecommendation);
  sections.register('productpage--product-list', theme.HomepageProductSlider);
  sections.register('hkpk-products', theme.hkpkProductGrids);
  sections.register('spreads-featured-products', theme.SpreadsProduct);
  sections.register('article-template', theme.ArticleTemplateProduct);
  sections.register('search--product-list', theme.SearchpageProduct);
  sections.register('mm-collection-template', theme.CollectionFeaturedProduct);
  sections.register('productpage-recommendations', theme.ProductRecommendations);
  sections.register('kids-featured-product', theme.KidsFeaturedProduct);

  //Get url from global object to add
  if(addObject.url) {     
    var depoCode = sessionStorage.getItem('DepotCode').toLowerCase();
    var productUrl = addObject.url.replace(new RegExp('epigamia' + '$'), depoCode);

    var ajaxProductPrice = parseInt(( ajaxAddPrice / 100 ) * 1);
    
    setTimeout(function() {
      var formData = $('form[data-product-handle="' + productUrl + '"]').serialize();

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: formData,
        success: function (data) {
          $('.cart-adding-text').text('Adding your item to cart...');

          mmajaxcart.AjaxcartRender();

          setTimeout(function () {
              $('.mm__pincode-content[data-pincode-success]').hide(); 
              $('.mm__pincode-close').click();
              // document.querySelector('#pop-club-quick-buy3').style.display = 'block';
              mmajaxcart.AjaxcartOpen();
            }, 2000);
          
            setTimeout(function () {
              if(theme.templateName == 'collection'){
                if(sessionStorage.getItem('DepotCode') == 'Bangaloregheespreads' || 
                   sessionStorage.getItem('DepotCode') == 'Delhigheespreads' ||
                   sessionStorage.getItem('DepotCode') == 'Mumbaigheespreads' ) {
                  window.location.href = "https://epigamiastore.com/collections/pan-india-collection";
                } else{
                  location.reload();
                }
              }
              if(theme.templateName == "product"){
                var productPageURL = window.location.href;
                productPageURL = productPageURL.replace(new RegExp('epigamia' + '$'), depoCode)
                window.location.replace(productPageURL);
              }
            }, 3000); 

          //Call Cart JSON
          $.getJSON('/cart.js', function(cart) {
            var CartCount = cart.item_count;          
            $('[data-cart-count-ajax]').html(CartCount);
            // getBrandInfo();
          });
          
          //Helper trigger to track add to cart dataLayer event
          $(document).trigger('product:added', data);
        },
        error:function () {
          $('.cart-adding-text').text('Uhoo! This product is not available in your area.').css('color','#CA7077');
          
          setTimeout(function () {
              if(theme.templateName == 'collection'){
                location.reload();
              }
              if(theme.templateName == "product"){
                var productPageURL = window.location.href;
                productPageURL = productPageURL.replace(new RegExp('epigamia' + '$'), depoCode)
                window.location.replace(productPageURL);
              }
            }, 500); 
        }
      });
    }, 1000);  
  }
  
  if(addObjectAddCart.url) { ajaxAddToCart(); }
   
  if(addObjectRepeatAddCart.url) { ajaxRepeatAddToCart(); } 
  
  if(addObjectBuy.url) { ajaxBuyNow(); }  
});


/*=============================================================================
 * THEME SECTIONS REGISTER
 =============================================================================*/
$(document).ready(function() { 
  var sections = new theme.Sections();

  sections.register('homepage--banner-slideshow', theme.InitSlickSlider);
  sections.register('homepage--delivery-details', theme.InitSlickSlider);
  sections.register('homepage--epigamia-blogs', theme.InitSlickSlider);
  sections.register('homepage--epigamia-press', theme.InitSlickSlider);
  sections.register('productpage--recipes', theme.InitSlickSlider);
 
  sections.register('homepage--feature-product', theme.FeaturedProductGrids);
 
  sections.register('homepage--product-list', theme.HomepageProductSlider);
  sections.register('productpage--product-list', theme.HomepageProductSlider);

  sections.register('pdp-product-recommendation', theme.productRecommendation);
  
  sections.register('search--product-list', theme.SearchpageProduct);
  
  sections.register('product-template-main-image-slider', theme.InitSlickSlider);
  sections.register('product-template-thumbnails-slider', theme.InitThumbnailsSlickSlider);

  sections.register('hkpk-products', theme.hkpkProductGrids);
  sections.register('productpage-recommendations', theme.ProductRecommendations);
  sections.register('kids-featured-product', theme.KidsFeaturedProduct);
  sections.register('spreads-featured-products', theme.SpreadsProduct);
  sections.register('milkshake-products', theme.MilkshakeProductSlider);
  sections.register('milkshake-multipack-product', theme.MilkshakeMultipackButton);
  
  sections.register('article-template', theme.ArticleTemplateProduct);
  
  sections.register('mm-collection-template', theme.CollectionFeaturedProduct);
  
  // Theme-specifics
  sections.register('header-section', theme.HeaderSection);
  
  theme.customerTemplates.init();  

  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    iframes: document.querySelectorAll(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus(
    document.getElementById(window.location.hash.substr(1))
  );

  var inPageLink = document.querySelector('.in-page-link');
  if (inPageLink) {
    inPageLink.addEventListener('click', function(evt) {
      slate.a11y.pageLinkFocus(
        document.getElementById(evt.currentTarget.hash.substr(1))
      );
    });
  }

  document.querySelectorAll('a[href="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(evt) {
      evt.preventDefault();
    });
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    links: document.querySelectorAll(
      'a[href]:not([aria-describedby]), .product-single__thumbnail'
    )
  });

  theme.FormStatus.init();

  document.addEventListener(
    'touchstart',
    function() {
      theme.Helpers.setTouch();
    },
    { once: true }
  );

  if (document.fonts) {
    document.fonts.ready.then(function() {
      window.performance.mark('debut:fonts_loaded');
    });
  }
});


/*=============================================================================
 * LOGIN & REGISTER PAGE FUNCTIONALITY
 =============================================================================*/

$(document).ready(function() { 
  $('.show-login-form').on('click',function(){
    $(this).closest('.social-login-form').hide();
    $('.login-input-form').show();
  });

  var showPasswordCount = 0;
  $('.show-password').on('click',function(){
    if(showPasswordCount%2 == 0){
      $('[name="customer[password]"]').attr('type','text');
      $('.hide-password').hide();
      showPasswordCount += 1;
    }else{
      $('[name="customer[password]"]').attr('type','password');
      showPasswordCount += 1;
      $('.hide-password').show();
    }
  });
  
   $('.login-signup-form-wrapper input').on('keyup',function(){
    var $valLength = $(this).val().length;
    if($valLength>0){
      $(this).closest('.form-field').addClass('focus');
    }else{
      $(this).closest('.form-field').removeClass('focus');
    }
  });
  
});

  
/*=============================================================================
 * PRODUCT PAGE FUNCTIONALITY
 =============================================================================*/
$(document).ready(function() { 
  
  // PRODUCT PAGE QUANTITY UPDATE
  $(document).on('click', '.quantity-icon', function(e) {
    $target = $(e.target);
    let q = $(this).parent().find('.product-form__input').val(),
        symbol = $(this).data('symbol'),
        actualNumber,
		x = $(this).attr('data-quantity-limit'), 
        i = 1,
        p = parseInt(i);
    if(symbol == "+"){
      actualNumber = parseInt(q) + p
      if(x == 0 || x == undefined ){
        $(this).parent().find('.product-form__input').val(actualNumber);
      }
      else if(x == 1){
      	$(this).addClass('quantity__limited');
        $target.parents('.product-card').find('.quantity-limit-message').show();
        $('.quantity-limit-message-desktop').show();
        $('.quantity-limit-message-mobile').show().css("display","flex");
      }
      else if(x != 0){
        if(actualNumber <= x){
          $(this).parent().find('.product-form__input').val(actualNumber);
          if(actualNumber == x){
             $(this).addClass('quantity__limited');
             $target.parents('.product-card').find('.quantity-limit-message').show();
            $('.quantity-limit-message-desktop').show();
            $('.quantity-limit-message-mobile').show().css("display","flex");
          }
        }
      }
    }else if(symbol == "-" && q > 1){      
      actualNumber = parseInt(q) - p;
      var y = $(this).parent().find('.plus-icon').attr('data-quantity-limit');
      $(this).parent().find('.product-form__input').val(actualNumber);
      if(actualNumber < y){
        $(this).parent().find('.plus-icon').removeClass('quantity__limited');
        $target.parents('.product-card').find('.quantity-limit-message').hide();
        $('.quantity-limit-message-desktop').hide();
        $('.quantity-limit-message-mobile').hide();
      }
    }


    // HP Featured Product Price Change
    var productPrice = $(this).parents('.block-product-price-wrap').find('.mm_addToCart').attr('data-price');
    var inputValue = $(this).parents('.block-product-price-wrap').find('.product-form__input').val();
    
    var currentPrice = productPrice * inputValue;
    currentPrice = Shopify.formatMoney(currentPrice, theme.moneyFormat);
    
    $(this).parents('.block-product-price-wrap').find('.mm_addToCart span').text(currentPrice);
  });
  
  // PDP ACCODIAN TABS
  $(".accordion .acc-title").on("click", function() {
    $(this).parent(".acc-block").toggleClass("active").siblings().removeClass("active");
    $(this).parent(".acc-block").siblings().children(".acc-description").slideUp();
    $(this).siblings(".acc-description").slideToggle();
  });
  
  // PDP BUNDLE SECTION ACCODIAN MOBILE
  if($(window).width()<768){
    $('.product-list-bundle .h2-heading').on('click',function(){
      $(this).toggleClass('active');
      $('.product-list-bundle .product-container').slideToggle();
    });
  }
  
  // PDP DELIVERY COUNTDOWN
  if($('.template-product').length){
    var d = new Date();
    var newDay = new Date().getTime();
    var month = d.getMonth();
    var day = d.getDate();
    var year = d.getFullYear();
    var oldDay = new Date(year, month, day, 15, 00, 00, 0).getTime();
    if(oldDay>newDay){
      var x = setInterval(function() {
        newDay = new Date().getTime();
        var distance = oldDay - newDay;
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        hours<10?hours='0'+hours:hours=hours;
        minutes<10?minutes='0'+minutes:minutes=minutes;
        seconds<10?seconds='0'+seconds:seconds=seconds;

        $(".delivery-countdown-image .counter").html('<span>'+hours+'<small>hours</small></span>' + ":"+ '<span>'+minutes+'<small>minutes</small></span>' + ":" + '<span>'+seconds+'<small>seconds</small></span>');
        //$(".delivery-countdown-wrapper").show();
        
        if (distance < 0) { $(".delivery-countdown-wrapper").hide(); }
      }, 1000);
    } else {
      $(".delivery-countdown-wrapper").hide();
    }
  }
});
  

/*=============================================================================
 * AJAXCART HANDLERS
 =============================================================================*/
window.mmajaxcart = {  
  AjaxcartOpen: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.addClass('mm-no-scroll');
    ajaxCart.addClass('has--opened');      
    ajaxOverlay.addClass('has--active');
    // document.querySelector('#pop-club-quick-buy3').style.display = 'none';
    // cartEarnCall();
    // setTimeout(() => {
    //   cartEarnCall();
    // }, 1500);
    //theme.MobileNav.closeMobileNav();
  },
  AjaxcartClose: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),           	
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.removeClass('mm-no-scroll');
    ajaxCart.removeClass('has--opened');      
    ajaxOverlay.removeClass('has--active');  
    // document.querySelector('#pop-club-quick-buy3').style.display = 'block';
  },
  AjaxcartRender: function() {
    $.get('/cart?view=mm-ajax', function(cart){      
      $('.mm-ajaxcart').html(cart);
      
      mmajaxcart.FreeProducthandler();
      mmajaxcart.UpsellHandler();

      let cartJSON;
      if($('body').hasClass('spread-template')){
        $.getJSON('/cart.js', function(c) {
          var CartCount = c.item_count;          
          if(CartCount == 0){
            $('.mm__spread-header .site-header__cart').addClass('hide-cart');
            $('.mm__spread-header .site-header__cart').hide();
          }else{
            $('.mm__spread-header .site-header__cart').removeClass('hide-cart');
            $('.mm__spread-header .site-header__cart').show();
          }
        });
      }
      
      if(!sessionStorage.getItem('DepotCode')) { 
        $('.mm-checkout-button').addClass('disable').attr('disabled');
        $('.mm__pincode-edit-wrapper').hide();
        $('.mm-ajaxcart-items').css('max-height','calc(100vh - 175px)');
      } else {
        var currentPin = sessionStorage.getItem('UserPin');
        var deliveryMsg = sessionStorage.getItem('PincodeMsg');

        $('.mm__pincode-edit-wrapper').show();
        $('.mm__pincode-current').text(currentPin);
        $('.mm__pincode-delivery-date').text(deliveryMsg);        
        $('.mm-ajaxcart-items').css({"max-height": "100vh", "padding-bottom": "360px"});
      }
      
      // Free Shipping Threshold Bar
      
      var cartPrice = parseInt($('.shipping_progress_bar').attr('data-cart-price'));
      var thresholdPrice = parseInt($('.shipping_progress_bar').attr('data-shipping-threshold'));
      
      if (cartPrice < thresholdPrice){
        var shippingDiff = (thresholdPrice - cartPrice) * 100;
        var shippingPercentage = (cartPrice / thresholdPrice) * 100;
        
		$('#js-progress-bar').attr('value', shippingPercentage);
        $('#js-progress-bar-msg').text(theme.beforeFreeShipping);
        var shippingMessage = $('#js-progress-bar-msg').text().replace('[price]', Shopify.formatMoney(shippingDiff, theme.moneyFormat));
        $('#js-progress-bar-msg').text(shippingMessage);
      } 
      else{
        $('#js-progress-bar').attr('value', '100');
        $('#js-progress-bar-msg').text(theme.afterFreeShipping);
      }
      let ajaxquantity = document.querySelectorAll('.mm-ajaxcart-item-quantity')
      ajaxquantity.forEach(function(ele){
      let limitvalue = ele.querySelector('.quantity-plus').getAttribute('data-quantity-limit');
      let itemvalue = ele.querySelector('.quantity-input').getAttribute('value');
        if (limitvalue == 1 || limitvalue == itemvalue){
        ele.querySelector('.quantity-plus').classList.add("quantity__limited");
        }  
    }); 
      $(document).trigger('cart:refreshed');
    }); 
    
  },
  AjaxcartChangeHandler: function(data) {    
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success: function (cart) {
       
        mmajaxcart.AjaxcartRender();
        var CartCount = cart.item_count;        
        $('[data-cart-count-ajax]').html(CartCount);

        $(document).trigger('cart:refresh',cart);
        
        /*======================================================
          				DATA LAYER ON CART UPDATE 
         ======================================================*/
        $.getJSON('/cart?view=dataLayerJson', function(custom_cart) {
          var cart = custom_cart;
          var cartUpdateDataArray = [];

          for(var i=0; i < cart.items.length; i++) {
            var cartItemsData = {
              product_name: cart.items[i].product_title,            
              product_id: cart.items[i].product_id,
              price: cart.items[i].price / 100,
              category: cart.items[i].category,
              image: cart.items[i].image,
              size: cart.items[i].product_size
            }
            cartUpdateDataArray.push(cartItemsData);
          }
          dataLayer.push({ 
            'event': 'Cart Updated',
            'no_of_products': cart.item_count,
            'total_amount': cart.total_price / 100,
            'product_details': cartUpdateDataArray
          });
        });
      }
    });
  },
  AjaxcartQuantityHandler: function() {
    $(document).on('click', '.quantity-plus', function() {
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          x = $(this).attr('data-quantity-limit'), 
          u = parseInt(q) + p;
      if(x == 0){
        $(this).parent().find('.quantity-input').val(u).trigger('change');
      }
         else if(x != 0){
        if(u <= x){
          $(this).parent().find('.quantity-input').val(u).trigger('change');
          if(u == x){
             $(this).addClass('quantity__limited');
          }
        }
      }
    })
    $(document).on('click', '.quantity-minus', function() {
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          x = $(this).attr('data-quantity-limit'),
          u = parseInt(q) - p;
      if(q != 0){
      $(this).parent().find('.quantity-input').val(u).trigger('change');
         if(u < x){
        $(this).parent().find('.plus-icon').removeClass('quantity__limited');
      }
      }
     
      
    })
    $(document).on('change', '.quantity-input', function() {
      var UpdatedQuantity = parseInt($(this).val()),
          QuantityLine = parseInt($(this).attr('data-line')),
          params = { quantity: UpdatedQuantity, line: QuantityLine };

      mmajaxcart.AjaxcartChangeHandler(params);
    })
    $(document).on('click', '.mm-ajaxcart-remove-item', function() {
      var RemoveLine = parseInt($(this).attr('data-line')),
          params = { quantity: 0, line: RemoveLine };

      mmajaxcart.AjaxcartChangeHandler(params);
    })
  },
  
  UpsellHandler: function() {    
    if($('[data-upsell-details]').length) {
      
      if(sessionStorage.getItem('DepotCode') == 'Bangaloregheespreads' || 
         sessionStorage.getItem('DepotCode') == 'Delhigheespreads' ||
         sessionStorage.getItem('DepotCode') == 'Mumbaigheespreads' ) {
        var upsellDetails = $('.mm-ajaxcart-body').data('pan-upsell-details');
      } 
      else if(sessionStorage.getItem('DepotCode') == 'Ahmedabad' || sessionStorage.getItem('DepotCode') == 'Surat' ||
         sessionStorage.getItem('DepotCode') == 'Kolkata' || sessionStorage.getItem('DepotCode') == 'Pune' ||
         sessionStorage.getItem('DepotCode') == 'Indore' || sessionStorage.getItem('DepotCode') == 'Chandigarh' ||
         sessionStorage.getItem('DepotCode') == 'Kochi' || sessionStorage.getItem('DepotCode') == 'Lucknow'){
        var upsellDetails = $('.mm-ajaxcart-body').data('tier2-upsell-details');
      }
      else{
        var upsellDetails = $('.mm-ajaxcart-body').data('upsell-details');
      }
      
      var upsellEnabled = upsellDetails.UpsellOfferEnabled;
      var upsellProducts = upsellDetails.UpsellOfferProducts;
      upsellProducts = upsellProducts.split(',');
      
      if(!upsellEnabled) { return; }

      if(upsellProducts.length) {
        var asyncRequest = [];
        var addedUpsellCount = 0;
        var upsellHolder = $('#cartUpsellHolder');
        var depotCode = sessionStorage.getItem('DepotCode');
        
        $.getJSON('/cart.js', function(cart) {          
          for(var i=0; i<upsellProducts.length; i++) {
            var showProduct = true;            
            var upsellProduct = upsellProducts[i];
            
            if(depotCode) {
              depotCode = depotCode.toLowerCase();
              upsellProduct = upsellProduct.replace(new RegExp('epigamia' + '$'), depotCode);
            } 
            
            for(var j=0; j<cart.items.length; j++) {
              var cartItem = cart.items[j];
              
              if(upsellProduct == cartItem.handle) {
                showProduct = false;
                addedUpsellCount = addedUpsellCount + 1;
              }
            }
            
            if(showProduct) {
              var productUrl = '/products/' + upsellProduct + '.js';
              
              $.ajax({
                url: productUrl,
                type: 'GET',
                async: false,
                processData : false,
                contentType: false,
                dataType:'JSON',
                success: function(response) {
                  var html = '';
                  var product = response;  
                  var product_title = product.title;
                  var product_title_2 = '';

                  if(!product.available){ return; }

                  if(product.featured_image) {
                    let om = product.featured_image,
                        pi = om.split(".");
                    pi[pi.length-2] = pi[pi.length-2] + "_250x";
                    var product_image = pi.join('.');
                  } else {
                    var product_image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_180x.gif';
                  }

                  if(product_title.indexOf("-") != -1){
                    var lastIndex = product_title.lastIndexOf("-");
                    product_title = product_title.substring(0, lastIndex);
                    product_title_2 = product_title.substring(lastIndex + 1); 
                  }

                  html += '<li class="upsell-list-item" data-product="' + product.id + '">';
                  html += '<div class="upsell-product">';
                  
                  if(product.compare_at_price > product.price) {
                    var discountPrice = product.compare_at_price - product.price;
                    var discountPercentage = (discountPrice / product.compare_at_price) * 100;
                    discountPercentage = Math.round(discountPercentage);

                    if(discountPercentage >= 15){
                      html += '<span class="discount_badge">';
                      html += '<svg xmlns="http://www.w3.org/2000/svg" id="Group_12" data-name="Group 12" width="55.043" height="50.614" viewBox="0 0 55.043 50.614"><g id="Group_11" data-name="Group 11" transform="translate(0 0)"><path id="Path_6" data-name="Path 6" d="M825.927,58.6h5.979c.012-2.663-1.339-4.8-2.99-4.8S825.927,55.945,825.927,58.6Z" transform="translate(-825.927 -53.794)" fill="#890303"/><path id="Path_7" data-name="Path 7" d="M1103.367,58.6h5.98c.012-2.663-1.339-4.8-2.99-4.8S1103.367,55.945,1103.367,58.6Z" transform="translate(-1054.303 -53.794)" fill="#890303"/><path id="Path_8" data-name="Path 8" d="M891.895,53.794H842.831c1.651,0,3,2.141,2.99,4.8h0V90.611a3.215,3.215,0,0,0,1.608,2.785l18.327,10.581a3.215,3.215,0,0,0,3.215,0L887.3,93.4a3.216,3.216,0,0,0,1.608-2.785V58.6C888.905,55.945,890.244,53.794,891.895,53.794Z" transform="translate(-839.841 -53.794)" fill="#dd3838"/></g></svg>';
                      html += '<span>'+ discountPercentage +'%<br>Off</span>'
                      html += '</span>'; 
                    }
                  }
                  
                  html += '<div class="upsell-product--image">';
                  html += '<img class="lazyload" data-src="' + product_image + '" alt="' + product.title + '" />';
                  html += '</div>';
                  html += '<div class="upsell-product--info">';
                  html += '<h3>';
                  html += '<a class="mm-text-black" href="' + product.url + '">' + product_title.trim() + '</a>';

                  if(product_title_2 != '') {
                    html += '<span class="mm-text-normal">' + product_title_2.trim() + '</span>';
                  }            
                  html += '</h3>';

                  html += '<input type="hidden" name="mm-variant" value="' + product.variants[0].id + '" />';              
                  html += '</div>';
                  html += '<div class="mm-button-container">';
                  html += '<p><span class="money">₹ ' + product.price / 100 + '</span></p>';
                  html += '<button type="button" class="mm-upsell-button btn">';
                  html += '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">';
                  html += '<path d="M11.5743 5.63857C11.8858 5.63857 12.1399 5.74491 12.3366 5.9576C12.5497 6.15392 12.6562 6.40751 12.6562 6.71835C12.6562 7.0292 12.5497 7.29097 12.3366 7.50365C12.1399 7.69997 11.8858 7.79814 11.5743 7.79814H7.73822V11.6019C7.73822 11.9128 7.63166 12.1745 7.41855 12.3872C7.22182 12.5999 6.96772 12.7062 6.65625 12.7062C6.34477 12.7062 6.08248 12.5999 5.86936 12.3872C5.67264 12.1745 5.57428 11.9128 5.57428 11.6019V7.79814H1.73822C1.42674 7.79814 1.16445 7.69997 0.951332 7.50365C0.754611 7.29097 0.65625 7.0292 0.65625 6.71835C0.65625 6.40751 0.754611 6.15392 0.951332 5.9576C1.16445 5.74491 1.42674 5.63857 1.73822 5.63857H5.57428V1.81025C5.57428 1.49941 5.67264 1.24582 5.86936 1.0495C6.08248 0.836811 6.34477 0.730469 6.65625 0.730469C6.96772 0.730469 7.22182 0.836811 7.41855 1.0495C7.63166 1.24582 7.73822 1.49941 7.73822 1.81025V5.63857H11.5743Z" fill="#CA7077"/>';
                  html += '</svg>';
                  html += '</button>';
                  html += '</div>';
                  html += '</div>';
                  html += '</li>';

                  upsellHolder.append(html);
                },
                error: function() {
                  $('.mm_upsell-section').hide();
                }
              });
            }        
          }
          
          $.when.apply(null, asyncRequest).done( function() {
            if(upsellHolder.is(':empty')) {
              $('.mm_upsell-section').hide();
            } else {
              $('.mm_upsell-section').show();
            }
          }); 
          
          if(upsellProducts.length === addedUpsellCount) {
            $('.mm_upsell-section').hide();
          }
         // cartEarnCall();
         //    fetch('/cart.js')	
         //    .then((response) => response.json())	
         //    .then((cartData) => {	
         //      const isPopLogin = document.querySelector('#pop-club-login-flag').value;	
         //      const coinBal = parseInt(document.querySelector('#pop-club-data-coins').value);	
         //      const cartCoinContext = document.querySelector('.cart-drawer-pop');	
         //      const isCartOpened = document.querySelector('.mm-ajaxcart').classList.contains('has--opened');
         //      if (isPopLogin == 'true' &&  isCartOpened && coinBal > 0 && (cartData.items.length > 0) && (cartData.items_subtotal_price / 100) > 0) {	
         //          let cart_pop_checked = document.querySelector('.cart-drawer-pop #buy-with-pop-coins');	
         //          if (cart_pop_checked && cart_pop_checked.checked) {	
         //            let checkoutBtnElement = document.querySelector('.btn.mm-checkout-button-pop.totals__subtotal-value');	
         //            if(checkoutBtnElement) checkoutBtnElement.classList.add('desabled');
         //            if(cartCoinContext) cartCoinContext.style.display = 'flex';	
         //            let popCheckBox = document.querySelector("#buy-with-pop-coins");
         //            if (popCheckBox) popCheckBox.disabled = true;
         //            customCartCheckout();	
         //        } else {	
         //          discountClear();	
         //          if(cartCoinContext) cartCoinContext.style.display = 'none';	
         //        }	
         //      }	
         //    })
        })
      } 
    } 
  },  
    FreeProducthandler: function() {
    if(theme.freeProductEnabled && theme.freeProductHandle){ 
      
      var eligibleOfferPrice = theme.freeProductOffer;
      var freeProductHandle = theme.freeProductHandle;
      var currentDepot = sessionStorage.getItem('DepotCode');
      
      if(currentDepot) {
        currentDepot = currentDepot.toLowerCase();
        freeProductHandle = freeProductHandle.replace(new RegExp('epigamia' + '$'), currentDepot);
      } 
      
      var FreeproductUrl = '/products/' + freeProductHandle + '.js';
      
      $.getJSON(FreeproductUrl, function(product) {
        var freeProductVariantId = parseInt(product.variants[0].id);
        
        $.get('/cart?view=dataLayerJson', function(response) {
          var cart = JSON.parse(response);
          var cartTotal = cart.total_price / 100;
          
          if(!cart.NewSpreadsExist && !cart.offerProductExist && !cart.noOfferTagExist && cartTotal >= eligibleOfferPrice){
            //console.log('Add Product');

            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {
                quantity: 1,
                id: freeProductVariantId
              },
              success: function (data) {
                console.log('Product Added');
                setTimeout(function () {
                  mmajaxcart.AjaxcartRender();
                }, 500);
                
                
                //Call Cart JSON
                $.getJSON('/cart.js', function(custom_mm_cart) {
                  var CartCount = custom_mm_cart.item_count;          
                  $('[data-cart-count-ajax]').html(CartCount);
                });
              }
            });                     
          }

          if(cart.offerProductExist && (cartTotal < eligibleOfferPrice || cart.noOfferTagExist || cart.NewSpreadsExist)) {
            console.log('Remove Product');
            $.ajax({
              url: '/cart/change.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {
                quantity: 0,
                id: freeProductVariantId
              },
              success: function (data) {
                mmajaxcart.AjaxcartRender();
                //Call Cart JSON
                $.getJSON('/cart.js', function(cart) {
                  //console.log(cart)
                  var CartCount = cart.item_count;          
                  $('[data-cart-count-ajax]').html(CartCount);
                });
              }
            });
          }
        });
      });
    }
  }
}


/*=============================================================================
 * AJAXCART FUNCTIONS
 =============================================================================*/
    
$(document).ready(function() { 
  $(document).on('click', '.mm-ajaxcart-open', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartOpen();
    mmajaxcart.AjaxcartRender();
  })
  
  $(document).on('click', '.mm-ajaxcart-close, .mm__pincode-close, .mm-ajaxcart-overlay', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
    $('.mm__pincode').hide();
    // document.querySelector('#pop-club-quick-buy3').style.display = 'block';
  });
  
  mmajaxcart.AjaxcartRender();
  mmajaxcart.AjaxcartQuantityHandler();

  /*============================================================
   * AJAX ADD TO CART 
  (For PLP)
   ===========================================================*/
   $(document).on('click', '.mm-ajax-add', function(e) {
    e.preventDefault();
    $target= $(e.target);
    var productid = $target.parents('.product-card__detail').attr('data-id');

    fetch('/cart.js')
    .then(res=>res.json())
    .then(data=>{
      var cartdata = data.items;

      var x,y;
      var array_x = [];
      var array_y = [];
      cartdata.forEach(function (arrayItem) {
        x = arrayItem.id;
        array_x.push(x);
      });

      var limits = $target.parents('.quantity-wrapper').find('.plus-icon').attr('data-quantity-limit');
      var curvalue = $target.parents('.quantity-wrapper').find('.product-form__input').val();
      
      window.addObject = {};    
      window.addObjectBuy = {};
      window.addObjectAddCart = {};
      window.addObjectRepeatAddCart = {};
      window.ajaxAddPrice = $(this).attr('data-price');

      if(!sessionStorage.getItem('DepotCode')) {      
        $('#pincodeModalContent').show().addClass('show--pincheck');
        $('.mm__pincode-content').hide();
        $('.mm__pincode-content[data-pincode-check]').css('display', 'block');
        // document.querySelector('#pop-club-quick-buy3').style.display = 'none';
        $('.mm-ajaxcart-overlay').addClass('has--active');
        $('body').addClass('mm-no-scroll');

        if($(this).hasClass('mm-ajax-add-secondary')){
          addObjectAddCart.url = $(this).parents('form').attr('data-product-handle');
        }
        else{
          addObject.url = $(this).parents('form').attr('data-product-handle');
        }
      } 

      else {
        if(cartdata.length != 0)
        {
          if(limits == 0 || limits == undefined ){
            var formData = $(this).parents('form').serialize();
            var ajaxProductQuantity = $(this).parents('form').find('input[name="quantity"]').val();
            var ajaxProductPrice = $(this).attr('data-price');
            ajaxProductPrice = parseInt(( ajaxProductPrice / 100 ) * ajaxProductQuantity );

            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: formData,
              success: function (data) {
                mmajaxcart.AjaxcartRender();
                setTimeout(function () {
                  $('#add_message-price').text('₹ '+ ajaxProductPrice);
                  $('#addtocart_items-count').text(ajaxProductQuantity);
                  $('.addtocart_message').addClass('show-message');
                  ajaxAddToCartTimer();
                }, 200);

                setTimeout(function(){
                  $('.addtocart_message').removeClass('show-message');
                  $('.site-header__cart, .mobile-bottom-menu-cart').addClass('cart_item-added');

                  //Call Cart JSON
                  $.getJSON('/cart.js', function(cart) {
                    var CartCount = cart.item_count;          
                    $('[data-cart-count-ajax]').html(CartCount);
                  });
                }, 2000);

                setTimeout(function(){
                  $('.site-header__cart, .mobile-bottom-menu-cart').removeClass('cart_item-added')
                }, 2500);

                //Helper trigger to track add to cart dataLayer event
                $(document).trigger('product:added', data);
              }
            }); 
          }
          else if(limits > 0){
            var dataId = $('.mm-ajaxcart-item-info');
            var dataIds = [];
            for(var i=0; i<dataId.length; i++){
              dataIds.push(dataId[i].dataset.id);
            }

            if(!dataIds.includes(productid)){
                var formData = $(this).parents('form').serialize();
                var ajaxProductQuantity = $(this).parents('form').find('input[name="quantity"]').val();
                var ajaxProductPrice = $(this).attr('data-price');
                ajaxProductPrice = parseInt(( ajaxProductPrice / 100 ) * ajaxProductQuantity );

                $.ajax({
                  url: '/cart/add.js',
                  dataType: 'json',
                  cache: false,
                  type: 'post',
                  data: formData,
                  success: function (data) {
                    mmajaxcart.AjaxcartRender();
                    setTimeout(function () {
                      $('#add_message-price').text('₹ '+ ajaxProductPrice);
                      $('#addtocart_items-count').text(ajaxProductQuantity);
                      $('.addtocart_message').addClass('show-message');
                      ajaxAddToCartTimer();
                    }, 200);

                    setTimeout(function(){
                      $('.addtocart_message').removeClass('show-message');
                      $('.site-header__cart, .mobile-bottom-menu-cart').addClass('cart_item-added');

                      //Call Cart JSON
                      $.getJSON('/cart.js', function(cart) {
                        var CartCount = cart.item_count;          
                        $('[data-cart-count-ajax]').html(CartCount);
                      });
                    }, 2000);

                    setTimeout(function(){
                      $('.site-header__cart, .mobile-bottom-menu-cart').removeClass('cart_item-added')
                    }, 2500);

                    //Helper trigger to track add to cart dataLayer event
                    $(document).trigger('product:added', data);
                  }
                });
            }
            
            for(var i = 0; i < dataIds.length; i++){
              if(parseInt(productid) == dataIds[i]){

                var ajaxitemvalue = dataId[i].querySelector('.quantity-input').getAttribute('value'); 
                if(limits > ajaxitemvalue){
                  var morevalue = limits - ajaxitemvalue;
                  $target.parents('.button-wrapper').find('.more-value-message').html("You can add " + morevalue + " more");
                  setTimeout(function () {
                 	$target.parents('.button-wrapper').find('.more-value-message').html('');
                  }, 2000);
                  
                  if(curvalue <= morevalue ){
                    var formData = $(this).parents('form').serialize();
                    var ajaxProductQuantity = $(this).parents('form').find('input[name="quantity"]').val();
                    var ajaxProductPrice = $(this).attr('data-price');
                    ajaxProductPrice = parseInt(( ajaxProductPrice / 100 ) * ajaxProductQuantity );

                    $.ajax({
                      url: '/cart/add.js',
                      dataType: 'json',
                      cache: false,
                      type: 'post',
                      data: formData,
                      success: function (data) {
                        mmajaxcart.AjaxcartRender();
                        setTimeout(function () {
                          $('#add_message-price').text('₹ '+ ajaxProductPrice);
                          $('#addtocart_items-count').text(ajaxProductQuantity);
                          $('.addtocart_message').addClass('show-message');
                          ajaxAddToCartTimer();
                        }, 200);

                        setTimeout(function(){
                          $('.addtocart_message').removeClass('show-message');
                          $('.site-header__cart, .mobile-bottom-menu-cart').addClass('cart_item-added');

                          //Call Cart JSON
                          $.getJSON('/cart.js', function(cart) {
                            var CartCount = cart.item_count;          
                            $('[data-cart-count-ajax]').html(CartCount);
                          });
                        }, 2000);

                        setTimeout(function(){
                          $('.site-header__cart, .mobile-bottom-menu-cart').removeClass('cart_item-added')
                        }, 2500);

                        //Helper trigger to track add to cart dataLayer event
                        $(document).trigger('product:added', data);
                      }
                    }); 
                  }
                }
                else if(limits == ajaxitemvalue){
                  $target.parents('.button-wrapper').find('.more-value-message').html("Maximum items added");
                  setTimeout(function () {
                    $target.parents('.button-wrapper').find('.more-value-message').html('');
                  }, 2000);
                }
              }
            }
          }
        }
        else if(cartdata.length == 0){
          var formData = $(this).parents('form').serialize();
          var ajaxProductQuantity = $(this).parents('form').find('input[name="quantity"]').val();
          var ajaxProductPrice = $(this).attr('data-price');
          ajaxProductPrice = parseInt(( ajaxProductPrice / 100 ) * ajaxProductQuantity );

          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: formData,
            success: function (data) {
              mmajaxcart.AjaxcartRender();
              setTimeout(function () {
                $('#add_message-price').text('₹ '+ ajaxProductPrice);
                $('#addtocart_items-count').text(ajaxProductQuantity);
                $('.addtocart_message').addClass('show-message');
                ajaxAddToCartTimer();
              }, 200);

              setTimeout(function(){
                $('.addtocart_message').removeClass('show-message');
                $('.site-header__cart, .mobile-bottom-menu-cart').addClass('cart_item-added');

                //Call Cart JSON
                $.getJSON('/cart.js', function(cart) {
                  var CartCount = cart.item_count;          
                  $('[data-cart-count-ajax]').html(CartCount);
                });
              }, 2000);

              setTimeout(function(){
                $('.site-header__cart, .mobile-bottom-menu-cart').removeClass('cart_item-added')
              }, 2500);

              //Helper trigger to track add to cart dataLayer event
              $(document).trigger('product:added', data);
            }
          }); 
        }
      }
    })
  });
  
  // productpage with quantity capping
  $(document).on('click', '.product-form__cart-submit', function(e) {
    e.preventDefault();
    let $target = $(e.target);
    let VId= $('[name=id]').val();
    
    fetch('/cart.js')
    .then(res=>res.json())
    .then(data=>{
      var cartdata = data.items;

      let limits = $target.parents('.quantity-add-to-bag-btn').find('.plus-icon').attr('data-quantity-limit');
      let curval =$target.parents('.quantity-add-to-bag-btn').find('.product-form__input--quantity').val();

      var x,y;
      var array_x = [];
      var array_y = [];
      cartdata.forEach(function (arrayItem) {
        x = arrayItem.id;
        y = arrayItem.quantity;

        array_x.push(x);
        array_y.push(y);
      });  

      window.addObject = {};    
      window.addObjectBuy = {};
      window.addObjectAddCart = {};
      window.addObjectRepeatAddCart = {};
      window.ajaxAddPrice = $(this).attr('data-price');

      if(!sessionStorage.getItem('DepotCode')) {      
        $('#pincodeModalContent').show().addClass('show--pincheck');
        $('.mm__pincode-content').hide();
        $('.mm__pincode-content[data-pincode-check]').css('display', 'block');
         // document.querySelector('#pop-club-quick-buy3').style.display = 'none';
        
        $('.mm-ajaxcart-overlay').addClass('has--active');
        $('body').addClass('mm-no-scroll');

        if($(this).hasClass('mm-ajax-add-secondary')){
          addObjectAddCart.url = $(this).parents('form').attr('data-product-handle');
        }
        else{
          addObject.url = $(this).parents('form').attr('data-product-handle');
        }
      } 

      else {
        if(cartdata.length != 0)
        {
          if(limits == 0){
            var formData = $(this).parents('form').serialize();
            var ajaxProductQuantity = $(this).parents('form').find('input[name="quantity"]').val();
            var ajaxProductPrice = $(this).attr('data-price');
            ajaxProductPrice = parseInt(( ajaxProductPrice / 100 ) * ajaxProductQuantity );

            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: formData,
              success: function (data) {
                mmajaxcart.AjaxcartRender();
                setTimeout(function () {
                  $('#add_message-price').text('₹ '+ ajaxProductPrice);
                  $('#addtocart_items-count').text(ajaxProductQuantity);
                  $('.addtocart_message').addClass('show-message');
                  ajaxAddToCartTimer();
                }, 200);

                setTimeout(function(){
                  $('.addtocart_message').removeClass('show-message');
                  $('.site-header__cart, .mobile-bottom-menu-cart').addClass('cart_item-added');

                  //Call Cart JSON
                  $.getJSON('/cart.js', function(cart) {
                    var CartCount = cart.item_count;          
                    $('[data-cart-count-ajax]').html(CartCount);
                  });
                }, 2000);

                setTimeout(function(){
                  $('.site-header__cart, .mobile-bottom-menu-cart').removeClass('cart_item-added')
                }, 2500);

                //Helper trigger to track add to cart dataLayer event
                $(document).trigger('product:added', data);
              }
            }); 
          }
          else if(limits != 0){
            var dataId = $('.mm-ajaxcart-item-info');
            var dataIds = [];
            for(var i=0; i<dataId.length; i++){
              dataIds.push(dataId[i].dataset.id);
            }

              if(!dataIds.includes(VId)){
                var formData = $(this).parents('form').serialize();
                var ajaxProductQuantity = $(this).parents('form').find('input[name="quantity"]').val();
                var ajaxProductPrice = $(this).attr('data-price');
                ajaxProductPrice = parseInt(( ajaxProductPrice / 100 ) * ajaxProductQuantity );

                $.ajax({
                  url: '/cart/add.js',
                  dataType: 'json',
                  cache: false,
                  type: 'post',
                  data: formData,
                  success: function (data) {
                    mmajaxcart.AjaxcartRender();
                    setTimeout(function () {
                      $('#add_message-price').text('₹ '+ ajaxProductPrice);
                      $('#addtocart_items-count').text(ajaxProductQuantity);
                      $('.addtocart_message').addClass('show-message');
                      ajaxAddToCartTimer();
                    }, 200);

                    setTimeout(function(){
                      $('.addtocart_message').removeClass('show-message');
                      $('.site-header__cart, .mobile-bottom-menu-cart').addClass('cart_item-added');

                      //Call Cart JSON
                      $.getJSON('/cart.js', function(cart) {
                        var CartCount = cart.item_count;          
                        $('[data-cart-count-ajax]').html(CartCount);
                      });
                    }, 2000);

                    setTimeout(function(){
                      $('.site-header__cart, .mobile-bottom-menu-cart').removeClass('cart_item-added')
                    }, 2500);

                    //Helper trigger to track add to cart dataLayer event
                    $(document).trigger('product:added', data);
                  }
                });  
              }




            for(var i = 0; i < dataIds.length; i++){
              if(parseInt(VId) == dataIds[i]){

                var ajaxitemvalue = dataId[i].querySelector('.quantity-input').getAttribute('value'); 
                if(limits > ajaxitemvalue)
                {
                  var morevalue = limits - ajaxitemvalue;
                  
				  document.querySelector('.morevalueclass').innerHTML = 'you can add' + morevalue + 'more';
                  document.querySelector('.morevalueclass-mobile').innerHTML = 'you can add' + morevalue + 'more';
                  setTimeout(function () {
                  document.querySelector('.morevalueclass').innerHTML = '';
                  document.querySelector('.morevalueclass-mobile').innerHTML = '';
                  }, 2000);

                  
                  if(curval <= morevalue ){
                    var formData = $(this).parents('form').serialize();
                    var ajaxProductQuantity = $(this).parents('form').find('input[name="quantity"]').val();
                    var ajaxProductPrice = $(this).attr('data-price');
                    ajaxProductPrice = parseInt(( ajaxProductPrice / 100 ) * ajaxProductQuantity );

                    $.ajax({
                      url: '/cart/add.js',
                      dataType: 'json',
                      cache: false,
                      type: 'post',
                      data: formData,
                      success: function (data) {
                        mmajaxcart.AjaxcartRender();
                        setTimeout(function () {
                          $('#add_message-price').text('₹ '+ ajaxProductPrice);
                          $('#addtocart_items-count').text(ajaxProductQuantity);
                          $('.addtocart_message').addClass('show-message');
                          ajaxAddToCartTimer();
                        }, 200);

                        setTimeout(function(){
                          $('.addtocart_message').removeClass('show-message');
                          $('.site-header__cart, .mobile-bottom-menu-cart').addClass('cart_item-added');

                          //Call Cart JSON
                          $.getJSON('/cart.js', function(cart) {
                            var CartCount = cart.item_count;          
                            $('[data-cart-count-ajax]').html(CartCount);
                          });
                        }, 2000);

                        setTimeout(function(){
                          $('.site-header__cart, .mobile-bottom-menu-cart').removeClass('cart_item-added')
                        }, 2500);

                        //Helper trigger to track add to cart dataLayer event
                        $(document).trigger('product:added', data);
                      }
                    });
                  }
                }
                else if(limits == ajaxitemvalue)
                  {
                     document.querySelector('.morevalueclass').innerHTML = 'Maximum quantity added.';
                    document.querySelector('.morevalueclass-mobile').innerHTML = 'Maximum quantity added.';
                    setTimeout(function () {
                     document.querySelector('.morevalueclass').innerHTML = '';
                     document.querySelector('.morevalueclass-mobile').innerHTML = '';
                  }, 2000);
                  }
              }
            }

          }
        }
        else if(cartdata.length == 0)
        {
          var formData = $(this).parents('form').serialize();
          var ajaxProductQuantity = $(this).parents('form').find('input[name="quantity"]').val();
          var ajaxProductPrice = $(this).attr('data-price');
          ajaxProductPrice = parseInt(( ajaxProductPrice / 100 ) * ajaxProductQuantity );

          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: formData,
            success: function (data) {
              mmajaxcart.AjaxcartRender();
              setTimeout(function () {
                $('#add_message-price').text('₹ '+ ajaxProductPrice);
                $('#addtocart_items-count').text(ajaxProductQuantity);
                $('.addtocart_message').addClass('show-message');
                ajaxAddToCartTimer();
              }, 200);

              setTimeout(function(){
                $('.addtocart_message').removeClass('show-message');
                $('.site-header__cart, .mobile-bottom-menu-cart').addClass('cart_item-added');

                //Call Cart JSON
                $.getJSON('/cart.js', function(cart) {
                  var CartCount = cart.item_count;          
                  $('[data-cart-count-ajax]').html(CartCount);
                });
              }, 2000);

              setTimeout(function(){
                $('.site-header__cart, .mobile-bottom-menu-cart').removeClass('cart_item-added')
              }, 2500);

              //Helper trigger to track add to cart dataLayer event
              $(document).trigger('product:added', data);
            }
          }); 
        }
      }
    })
  });
  
  /*============================================================
   * AJAX BUY NOW  
  	(For PDP, Hocky Pocky, Spreads Landing)
   ===========================================================*/
  $(document).on('click', '.mm-ajax-buy', function(e) {
    e.preventDefault();
    window.addObject = {};
    window.addObjectAddCart = {};
    window.addObjectBuy = {};
    window.addObjectRepeatAddCart = {};

    if(!sessionStorage.getItem('DepotCode')) {      
      $('#pincodeModalContent').show().addClass('show--pincheck');
      $('.mm__pincode-content').hide();
      $('.mm__pincode-content[data-pincode-check]').css('display', 'block');
      // document.querySelector('#pop-club-quick-buy3').style.display = 'none';
      
      $('.mm-ajaxcart-overlay').addClass('has--active');
      $('body').addClass('mm-no-scroll');
      addObjectBuy.url = $(this).parents('form').attr('data-product-handle'); 
    } 
    else{
      addObjectBuy.url = $(this).parents('form').attr('data-product-handle'); 
      ajaxBuyNow();
    }
  });
  
  
  /*============================================================
   * AJAX ADD TO CART TO CREATE SET ( For Subscription )
   ===========================================================*/
  var sessionSetRepeatHandle = JSON.parse(sessionStorage.getItem('repeatIteam'));
  var sessionSetRepeatVariantId = JSON.parse(sessionStorage.getItem('repeatItemDetail'));
  
  $(document).on('click', '.mm-ajax-repeat-add', function(e) {
    e.preventDefault();

    window.addObject = {}; 
    window.addObjectBuy = {};
    window.addObjectAddCart = {};
    window.repeatConditionValue = false;
    if($(this).hasClass('repeat-condition-value')){
      window.repeatConditionValue = true;
      window.ajaxRepeatAddPrice = parseInt($(this).attr('data-price'));
    }
    window.addObjectRepeatAddCart = {};
       
    if(!sessionStorage.getItem('DepotCode')) {      
      $('#pincodeModalContent').show().addClass('show--pincheck');
      $('.mm__pincode-content').hide();
      $('.mm__pincode-content[data-pincode-check]').css('display', 'block');
      // document.querySelector('#pop-club-quick-buy3').style.display = 'none';
      
      $('.mm-ajaxcart-overlay').addClass('has--active');
      $('body').addClass('mm-no-scroll');
      
      addObjectRepeatAddCart.url = $(this).parents('form').attr('data-product-handle');
    } 
    
    else {
      var repeatProductsHandle = [];
      var repeatProductsVariantId = [];
      var repeatItemCount = 0;
      var setValidation = parseInt($('.js-choose-frequency').attr('data-validation'));
      var repeatItemHandle = $(this).attr('data-handle');
      var repeatItemVariantId = $(this).attr('data-variant-id');
      
      if(repeatConditionValue == true){
        var repeatValidation = parseInt(ajaxRepeatAddPrice);
        sessionStorage.setItem('repeatSetType', 'value');
      }else{
        var repeatValidation = 1;
      }
      
      var asyncRequest = [];
      var subscriptionItems = $('.js-subscription-selection-items');
      
      if(sessionStorage.getItem('repeatIteam')){
        if (!sessionSetRepeatHandle[repeatItemHandle]) {
          sessionSetRepeatHandle[repeatItemHandle] = repeatValidation;
        } else {
          sessionSetRepeatHandle[repeatItemHandle] += repeatValidation;
        }
      } 
      else {
        var inFakeCart = {};
        inFakeCart[repeatItemHandle] = repeatValidation;
        sessionStorage.setItem('repeatIteam', JSON.stringify(inFakeCart) );
        sessionStorage.setItem('repeatIteamFirst', repeatItemHandle);
        
        sessionSetRepeatHandle = JSON.parse(sessionStorage.getItem('repeatIteam'));

        if (!sessionSetRepeatHandle[repeatItemHandle]) {
          sessionSetRepeatHandle[repeatItemHandle] = repeatValidation;
        } 
      }
      
      if(sessionStorage.getItem('repeatItemDetail')){
        if (!sessionSetRepeatVariantId[repeatItemVariantId]) {
          sessionSetRepeatVariantId[repeatItemVariantId] = 1;
        } else {
          sessionSetRepeatVariantId[repeatItemVariantId] += 1;
        }
      } 
      else {
        var inFakeCartDetail = {};
        inFakeCartDetail[repeatItemVariantId] = 1;
        sessionStorage.setItem('repeatItemDetail', JSON.stringify(inFakeCartDetail) );
        
        sessionSetRepeatVariantId = JSON.parse(sessionStorage.getItem('repeatItemDetail'));

        if (!sessionSetRepeatVariantId[repeatItemVariantId]) {
          sessionSetRepeatVariantId[repeatItemVariantId] = 1;
        } 
      }
      
      $.each(sessionSetRepeatHandle, function(key,val) { 
        repeatItemCount = repeatItemCount + val; 
      });
      
      if(repeatItemCount >= setValidation){
        $('.js-choose-frequency').addClass('active-btn');
        $('.set-validation-count').addClass('validation-active');
      } else {
        $('.js-choose-frequency').removeClass('active-btn');
        $('.set-validation-count').removeClass('validation-active');
      }
      
      $('.js-set-item-count').text(repeatItemCount);
      
      var status = 'Not exist';

      for(var i=0; i<repeatProductsHandle.length; i++){
        var handle = repeatProductsHandle[i];
        if(handle == sessionSetRepeatHandle){
          status = 'Exist';
        }
      }
      
      if(status != 'Exist'){
        repeatProductsHandle.push(sessionSetRepeatHandle);
//         repeatItemCount = repeatItemCount + 1;
      } 
      
      $(this).parents('.quantity-wrapper').addClass('show-quantity-box');
    }
  });

  
  /*===============================================================
   * AJAX ADD/REMOVE TO CART ON QUANTITY BUTTON (For Subscription)
   ===============================================================*/
  $(document).on('click', '.repeat-quantity-icon', function() {
    let q = $(this).parent().find('.product-form__input').val(),
        symbol = $(this).data('symbol'),
        actualNumber,
        i = 1,
        p = parseInt(i);
    
    var repeatItemCount = 0;
    var repeatItemHandle = $(this).attr('data-symbol-handle');
    var repeatItemVariantId = $(this).attr('data-symbol-vid');
    var setValidation = parseInt($('.js-choose-frequency').attr('data-validation'));
    
    window.repeatConditionValue = false;
    if($(this).hasClass('repeat-condition-value')){
      window.repeatConditionValue = true;
      window.ajaxRepeatAddPrice = parseInt($(this).attr('data-price'));
    }
    if(repeatConditionValue == true){
      var repeatValidation = parseInt(ajaxRepeatAddPrice);
    }else{
      var repeatValidation = 1;
    }

    var asyncRequest = [];
    var subscriptionItems = $('.js-subscription-selection-items');
    
    if(symbol == "+"){
      actualNumber = parseInt(q) + p;
      $(this).parent().find('.product-form__input').val(actualNumber);
      if (!sessionSetRepeatHandle[repeatItemHandle]) {
        sessionSetRepeatHandle[repeatItemHandle] = repeatValidation;
      } else {
        sessionSetRepeatHandle[repeatItemHandle] += repeatValidation;
      }
      
      if (!sessionSetRepeatVariantId[repeatItemVariantId]) {
        sessionSetRepeatVariantId[repeatItemVariantId] = 1;
      } else {
        sessionSetRepeatVariantId[repeatItemVariantId] += 1;
      }
    }
    else if(symbol == "-" && q > 1){      
      actualNumber = parseInt(q) - p;
      $(this).parent().find('.product-form__input').val(actualNumber);
      
      if (!sessionSetRepeatHandle[repeatItemHandle]) {
        sessionSetRepeatHandle[repeatItemHandle] = repeatValidation;
      } else {
        sessionSetRepeatHandle[repeatItemHandle] -= repeatValidation;
      }
      
      if (!sessionSetRepeatVariantId[repeatItemVariantId]) {
        sessionSetRepeatVariantId[repeatItemVariantId] = 1;
      } else {
        sessionSetRepeatVariantId[repeatItemVariantId] -= 1;
      }
      
      if(q == 1){
        $(this).parents('.quantity-wrapper').removeClass('show-quantity-box');
      }      
    }     
    else if(symbol == "-" && q == 1){      
      if (!sessionSetRepeatHandle[repeatItemHandle]) {
        sessionSetRepeatHandle[repeatItemHandle] = repeatValidation;
      } else {
        sessionSetRepeatHandle[repeatItemHandle] -= repeatValidation;
      }
      
      if (!sessionSetRepeatVariantId[repeatItemVariantId]) {
        sessionSetRepeatVariantId[repeatItemVariantId] = 1;
      } else {
        sessionSetRepeatVariantId[repeatItemVariantId] += 1;
      }
      
      $(this).parents('.quantity-wrapper').removeClass('show-quantity-box');
    }
    
    $.each(sessionSetRepeatHandle, function(key,val) { 
      repeatItemCount = repeatItemCount + val; 
    });

    $('.js-set-item-count').text(repeatItemCount);
    
    if(repeatItemCount == 0){
      sessionStorage.removeItem('repeatIteam');	
      sessionStorage.removeItem('repeatIteamFirst');
      sessionStorage.removeItem('repeatItemDetail');
    }
    
    if(repeatItemCount >= setValidation){
      $('.js-choose-frequency').addClass('active-btn');
      $('.set-validation-count').addClass('validation-active');
    } else {
      $('.js-choose-frequency').removeClass('active-btn');
      $('.set-validation-count').removeClass('validation-active');
    }
  });

  
  /*===============================================================
   * SUBSCRIPTION SET REVIEW SELECTION ITEMS (For Subscription)
   ===============================================================*/
  function renderRepeatProducts(product, quantity) {
    var productHtml = '';

    if(product.featured_image) {
      let om = product.featured_image,
          pi = om.split(".");
      pi[pi.length-2] = pi[pi.length-2] + "_400x";
      var product_image = pi.join('.');
    } else {
      var product_image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_180x.gif';
    }

    var product_title = product.title,
        product_title_2 = '';

    if(product.title.indexOf('-') > 0){
      var lastIndex = product.title.lastIndexOf("-");
      product_title = product.title.substring(0, lastIndex).trim();
      product_title_2 = product.title.substring(lastIndex + 1).trim();
    }
      
    <!-- popcoins code -->
    let popPrice = product.price;
    let priceLength = popPrice.toString().length;
    let poplistingPrice = popPrice.toString().slice(0,priceLength-2);
    
    productHtml += '<div class="subscription-sets-product">';
    productHtml += '<div class="product-card">';
    productHtml += '<div class="product-top">';

    productHtml += '<div class="product-card__image-with-placeholder-wrapper test">';
    productHtml += '<div class="grid-view-item__image-wrapper product-card__image-wrapper">';
    productHtml += '<a class="no-opac">';
    productHtml += '<img class="lazyload" data-src="'+ product_image +'" alt="'+ product.title +'" />';
    productHtml += '</a>';          
    productHtml += '</div>';
    
    if(product.compare_at_price > product.price) {
      var discountPrice = product.compare_at_price - product.price;
      var discountPercentage = (discountPrice / product.compare_at_price) * 100;
      discountPercentage = Math.round(discountPercentage);

      if(discountPercentage >= 15){
        productHtml += '<span class="discount_badge">';
        productHtml += '<svg xmlns="http://www.w3.org/2000/svg" id="Group_12" data-name="Group 12" width="55.043" height="50.614" viewBox="0 0 55.043 50.614"><g id="Group_11" data-name="Group 11" transform="translate(0 0)"><path id="Path_6" data-name="Path 6" d="M825.927,58.6h5.979c.012-2.663-1.339-4.8-2.99-4.8S825.927,55.945,825.927,58.6Z" transform="translate(-825.927 -53.794)" fill="#890303"/><path id="Path_7" data-name="Path 7" d="M1103.367,58.6h5.98c.012-2.663-1.339-4.8-2.99-4.8S1103.367,55.945,1103.367,58.6Z" transform="translate(-1054.303 -53.794)" fill="#890303"/><path id="Path_8" data-name="Path 8" d="M891.895,53.794H842.831c1.651,0,3,2.141,2.99,4.8h0V90.611a3.215,3.215,0,0,0,1.608,2.785l18.327,10.581a3.215,3.215,0,0,0,3.215,0L887.3,93.4a3.216,3.216,0,0,0,1.608-2.785V58.6C888.905,55.945,890.244,53.794,891.895,53.794Z" transform="translate(-839.841 -53.794)" fill="#dd3838"/></g></svg>';
        productHtml += '<span>'+ discountPercentage +'%<br>Off</span>'
        productHtml += '</span>'; 
      }
    }
    
    productHtml += '</div>';

    productHtml += '<div class="product-card__detail">';     
    productHtml += '<div class="h4 grid-view-item__title product-card__title">';          
    productHtml += '<a class="no-opac product-title">';          
    productHtml += '<span class="product-title--p1">'+ quantity +' x '+ product_title +'</span>';

    productHtml += '</a>';
    productHtml += '</div>';

    productHtml += '<div class="price--button-wrapper">';

    productHtml += '<dl class="price price--listing price--on-sale ">';            
    productHtml += '<div class="price__sale">';
    productHtml += '<dd>';            
    productHtml += '<span class="price-item price-item--sale">' + Shopify.formatMoney(product.price, theme.moneyFormat) + '</span>';
    productHtml += '</dd>';

    productHtml += '</div>';

    productHtml += '<span class="product-weight">';
    productHtml += '<span>'+ product_title_2 +'</span>'
    productHtml += '</span>';            
    productHtml += '</dl>'; 

    productHtml += '</div>';
    
    productHtml += '<div class="pop-club-listing" price="'+ poplistingPrice +'"></div>';
    
    productHtml += '</div>';
    productHtml += '</div>';
    productHtml += '</div>';
    productHtml += '</div>';

    return productHtml;
  }
    
  $('.js-review-selections').on('click', function(){
    var asyncRequest = [];
    var subscriptionItems = $('.js-subscription-selection-items');
    
    $(subscriptionItems).empty();
    
    if ($(subscriptionItems).is(':empty')){
      $.each(sessionSetRepeatHandle, function(key,val) {
        if(val > 0){
          var productUrl = '/products/' + key + '.js';

          asyncRequest.push(
            $.getJSON(productUrl, function(response) {
              var html = '';
              var product = response;  
              var productVarId = product.variants[0].id;
              
			  var productQty = sessionSetRepeatVariantId[productVarId];
              
              subscriptionItems.append(
                renderRepeatProducts(product, productQty)
              );
            })
          );
        }
      });
    }
    $('.subscription-review-selection-modal .subscription-frequency-options').empty();
    var getHTML = $('#data-frequency-options').find('input[name="repeat-frequency"]:checked').parents('.subscription-frequency-options').find('.data-frequency-set').html();
    $('.subscription-review-selection-modal .subscription-frequency-options').html(getHTML);
  });
  
  
  /*===============================================================
   * SUBSCRIPTION SET AJAX ADD TO CART (For Subscription)
   ===============================================================*/
  $('.mm_repeat_addToCart').on('click', function(){
    var addParam = [];    
    var subscriptionSetTitle = $(this).attr('data-repeat-title');
    var addedTime = new Date().getTime();
    var selectedInterval = $('#data-frequency-options').find('input[name="repeat-frequency"]:checked').attr('data-plan-interval');
    var selectedDiscount = $('#data-frequency-options').find('input[name="repeat-frequency"]:checked').parent().find('[data-discounted-price]').attr('data-discount');
    var selectedTotalPrice = $('#data-frequency-options').find('input[name="repeat-frequency"]:checked').parent().find('[data-discounted-price]').attr('data-discounted-price');
    $.each(sessionSetRepeatVariantId, function(key, val) {
      if(val >= 1){
        var selectedPlan = $('[data-variant-id="' + key + '"]').parents('.subscription-sets-product').find('.recurpay-collection-widget').find('[name="recurpay-bulk-input"][data-plan-interval="'+selectedInterval+'"]').first();

        if(selectedPlan.length){
          var selectedPlanId = $(selectedPlan).attr('data-plan');
          var selectedPlanName = $(selectedPlan).attr('data-plan-name');
          addParam.push({
            id: key,
            quantity: val,
            "properties" : {
              _subscription: "true",
              _repeatTitle: subscriptionSetTitle,
              _time: addedTime,
              Subscription:selectedPlanName,
              _PlanId:selectedPlanId,
              _Discount:selectedDiscount,
              _TotalPrice:selectedTotalPrice
            }
          });
        }
        else{
          addParam.push({
            id: key,
            quantity: val,
            "properties" : {
              _subscription: "true",
              _repeatTitle: subscriptionSetTitle,
              _time: addedTime,
              _Discount:selectedDiscount,
              _TotalPrice:selectedTotalPrice
            }
          });
        }
      }
    });
    
    console.log(addParam);
    
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data : {
        items: addParam
      },
      success: function (data) {
        mmajaxcart.AjaxcartRender();
        sessionStorage.removeItem('repeatIteam');	
        sessionStorage.removeItem('repeatIteamFirst');	
		sessionStorage.removeItem('repeatItemDetail');
        
        $('.js-set-item-count').text('0');
        $('.quantity-wrapper').removeClass('show-quantity-box');
        $('input[name="quantity"]').val('1');
        
        setTimeout(function(){
          $('.subscription-frequency-modal').removeClass('show-modal');
          $('.subscription-review-selection-modal').removeClass('show-review-modal');
          mmajaxcart.AjaxcartOpen();

          //Call Cart JSON
          $.getJSON('/cart.js', function(cart) {
            var CartCount = cart.item_count;          
            $('[data-cart-count-ajax]').html(CartCount);
          });
        }, 500);
      }
    });
  });
  
  
  /*===============================================================
   * REMOVE SUBSCRIPTION ITEMS FROM REVIEW SELECTION (For Subscription)
   ===============================================================*/
  $('.js-remove-set-item').on('click', function(){
    $('mm_repeat_addToCart').attr('disable','disabled') 
    $('.subscription-review-selection-modal').removeClass('show-review-modal');
    $('.subscription-frequency-modal').removeClass('show-modal');     
    sessionStorage.removeItem('repeatIteam');	
    sessionStorage.removeItem('repeatIteamFirst');	
    setTimeout(function () {
      location.reload();
    }, 100);
  });
  
  /*===============================================================
   * REMOVE SUBSCRIPTION REMOVE FROM AJAX CART
   ===============================================================*/
  $(document).on("click", ".js-ajax-repeat-remove", function(){
    var data = { updates: {} }; 
    
    $(this).parents('.subscription-items-wrapper').find('.subscription-item').each(function(){
      var varId = parseInt($(this).attr('data-variant-id'));
      data.updates[varId] = 0;
    });
    
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',      
      data: data,      
      success: function (data) {
        mmajaxcart.AjaxcartRender();	
        setTimeout(function(){
          $.getJSON('/cart.js', function(cart) {
            var CartCount = cart.item_count;          
            $('[data-cart-count-ajax]').html(CartCount);
          });
        }, 100);
      }
    });
    
  });
  
  
  /*============================================================
   * CART UPSELL ITEM FUNCTION  
  	(For Ajax cart)
  ===========================================================*/
  $(document).on('click', '.mm-upsell-button', function() {
    var $self = $(this);
    var Vaiant = $self.parents('.upsell-product').find('[name="mm-variant"]').val();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data : {
        id: parseInt(Vaiant),
        quantity: 1,
        properties: {
          'Upsell Item': 'true'
        }
      },
      dataType: 'json',
      success: function(data) {
        mmajaxcart.AjaxcartRender();
        
        //Helper trigger to track add to cart dataLayer event
        $(document).trigger('product:added', data);
      }
    })
  });
  
  
  /*============================================================
   * EDIT PINCODE FUNCTIONALITY(For PDP & Ajax cart)
   ===========================================================*/
  $(document).on('click', '.js-edit-pincode', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
    
    $('#pincodeModalContent').show().addClass('show--pincheck');
    $('.mm__pincode-content').hide();
    $('.mm__pincode-content[data-pincode-check]').css('display', 'block');   
    // document.querySelector('#pop-club-quick-buy3').style.display = 'none';
    
    $('.js-pincode-proceed').addClass('mm-page-load');    
    $('.cart-adding-text').text('');
    $('.mm-ajaxcart-overlay').addClass('has--active');
    $('body').addClass('mm-no-scroll');
    window.addObject = {};
  });
});
 
//Redirect to homepage from cart 
if(theme.templateName == 'cart') {
  document.location.href = '/?return=cart';
}

if(location.href.indexOf('return=cart') != -1) {
  mmajaxcart.AjaxcartRender();
  setTimeout(function () {
    mmajaxcart.AjaxcartOpen();
  }, 500);

  var currentPageUrl = window.location.href.replace('?return=cart','');

  window.history.replaceState({}, document.title, currentPageUrl);
}


/*=============================================================================
 * DOM READY FUNCTIONS
 =============================================================================*/
$(document).ready(function(){
  
  var activePageUrl = window.location.href;
  $('.site-nav__link').each(function(){
    var menuLink = $(this).attr('href');
    if(activePageUrl == menuLink){
     $(this).parents('li').addClass('current-page-link');
    }
  });
  
  $('.js-mm-toggle-submenu').on(
    'click', 
    function(evt) {
      var self = $(this);    
      self.toggleClass('open-submenu')
      self.parents('.mobile-nav__item')
      	  .find('ul.mobile-nav__dropdown')
      	  .slideToggle();
  	}
  );
  
  $('.icon-hamburger').on(
    'click', 
    function(evt) {
      $('body').toggleClass('prevent-scrolling');
    }
  );
  $('.icon-close').on(
    'click', 
    function(evt) {
      $('body').toggleClass('prevent-scrolling');
    }
  );
  
  if(sessionStorage.getItem('DepotCode')) {
   $('.delivery-countdown-wrapper , .countdown-timer').addClass('show-time-counter');
  }
  
  var pageUrl = window.location.pathname;

  $('.mobile-bottom-menu-block').each(function(){
    var mobileMenuUrl = $(this).find('a').attr('href');

    if(mobileMenuUrl == pageUrl){
      $(this).addClass('active');
    }
  });
  
  /*=============================================================================
 	* SUBSCRIPTION RESTRICTION FOR TIRE-2 AND PANINDIA CUSTOMERS
  =============================================================================*/
  if(theme.templateName == 'subscription'){
    if(sessionStorage.getItem('DepotCode')){
      if(sessionStorage.getItem('DepotCode') == 'Bangaloregheespreads' || 
         sessionStorage.getItem('DepotCode') == 'Delhigheespreads' ||
         sessionStorage.getItem('DepotCode') == 'Mumbaigheespreads' ) {
        $('.mm__pincode-content[data-pincode-check]').hide();
        $('.mm-subscription-pincode-overlay').addClass('active');
        $('.mm__pincode-content[data-subscription-pincode-failure]').show();
        $('.js-product-subscribe-btn').hide();
        // document.querySelector('#pop-club-quick-buy3').style.display = 'none';
      }
      else{
        $('.mm__pincode-content[data-pincode-check]').hide();
        $('.mm__pincode-content[data-subscription-pincode-failure]').hide(); 
        $('.mm-subscription-pincode-overlay').removeClass('active');
        $('.subscription_template #PageContainer').show();
        $('.js-product-subscribe-btn').show();
      }
    }else{
      $('.mm__pincode-content[data-pincode-check]').show();
      $('.mm-subscription-pincode-overlay').addClass('active');
    }

    $('.js-collection-redirection').on('click', function(){
      if(sessionStorage.getItem('DepotCode') == 'Bangaloregheespreads' || 
         sessionStorage.getItem('DepotCode') == 'Delhigheespreads' ||
         sessionStorage.getItem('DepotCode') == 'Mumbaigheespreads' ) {
        window.location.href = "https://epigamiastore.com/collections/pan-india-collection";
      } else{
        window.location.href = "https://epigamiastore.com/collections/all-products";
      }
    });

    $('.js-pincode-check').on('click', function(){
      $('.mm__pincode-content[data-pincode-check]').show();
      $('.mm__pincode-content[data-subscription-pincode-failure]').hide(); 
      $('.mm__pincode-content[data-pincode-check] .button_wrapper-btn').show();
    });
  }
  
  /*=============================================================================
 	* SHOW JIO MART & BIGBASKET OPTIONS FOR PANINDIA CUATOMERS
  =============================================================================*/  
  if(sessionStorage.getItem('DepotCode') == 'Bangaloregheespreads' || 
     sessionStorage.getItem('DepotCode') == 'Delhigheespreads' ||
     sessionStorage.getItem('DepotCode') == 'Mumbaigheespreads' ) {
    $('.mm__hp-featured-product, .mm__hp-product-list').hide();
    $('.mm__hp-featured-product.hp_panindia_section').show();
    $('.mm__hp-epigamia-panindia, .js-panindia-message').show();
    $('.panindia_message').addClass('panindia_message-active');
    $('.panindia_message').addClass('show-message');
    
    if(sessionStorage.getItem('HaveOtherSeller1') == '' && sessionStorage.getItem('HaveOtherSeller2') == '' 
       && sessionStorage.getItem('HaveOtherSeller3') == '' && sessionStorage.getItem('HaveOtherSeller4') == ''
       && sessionStorage.getItem('HaveOtherSeller5') == '' ){
      $('.pan_india_block').hide();
      $('.pan_india_success_msg').show();               
    }
    
    if(sessionStorage.getItem('HaveOtherSeller1') == 'Yes'){
      $('.js-jiomart-detail').show();
    }else{
      $('.js-jiomart-detail').hide();
    }
    
    if(sessionStorage.getItem('HaveOtherSeller2') == 'Yes'){
      $('.js-bigbasket-detail').show();
    }else{
      $('.js-bigbasket-detail').hide();
    }
    
    if(sessionStorage.getItem('HaveOtherSeller3') == 'Yes'){
      $('.js-seller3-detail').show();
    }else{
      $('.js-seller3-detail').hide();
    }
    
    if(sessionStorage.getItem('HaveOtherSeller4') == 'Yes'){
      $('.js-seller4-detail').show();
    }else{
      $('.js-seller4-detail').hide();
    }
    
    if(sessionStorage.getItem('HaveOtherSeller5') == 'Yes'){
      $('.js-seller5-detail').show();
    }else{
      $('.js-seller5-detail').hide();
    }
  }
  
  if($(window).width() < 750){
    if(theme.templateName == 'product'){
      if(sessionStorage.getItem('DepotCode')) {
        $('body').css('padding-bottom', '120px');
      }
    }
  }
  
});


/*=============================================================================
 * SCROLL FUNCTIONS FOR HEADER
 =============================================================================*/
$(window).scroll(function() {
  if( $(window).scrollTop() >= 100 ){
    $('.header__section').addClass('add-background');
  } else{
    $('.header__section').removeClass('add-background');
  }
});

/*=============================================================================
 * Hokey pokey page instagram slider
 * Hokey pokey main image slider
 * login sign-up label coding
 =============================================================================*/  

$(document).ready(function(){ 
  $('.hkpk-instgram-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.hkpk-banner-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 2000,
    autoplaySpeed: 2000,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '50px', 
    responsive: [
      {
        breakpoint: 749,
        settings: {
          speed: 800,
          vertical: false,
          verticalSwiping: false,
          autoplay: false
        }
      }
    ]
  });

  if($(window).width()<750){
    $('.banner-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.banner-slider').removeClass('onLoadActive');
    })
    $('.banner-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      $('.banner-slider').removeClass('onLoadActive');
      var previousSlide = currentSlide - 1;
      var nextSlide = currentSlide + 1;
      $('.banner-slide').removeClass('slick-active-first slick-active-last');
      $('.banner-slide[data-slick-index="'+previousSlide+'"]').addClass('slick-active-first');
      $('.banner-slide[data-slick-index="'+nextSlide+'"]').addClass('slick-active-last');
    })
  }
  
  $('.hkpk-brand-manifesto-quote').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 6000,
    autoplaySpeed: 3000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  $('.testimonial_slider-section').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.recommended-articles-slider').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: true,
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
  });
  
  $('.related-articles-slider').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: true,
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
  });
  
});

    
/*=============================================================================
 * SPRAEDS LANDING PAGE JS
 =============================================================================*/ 
    
$(window).scroll(function() {
  if( $(window).scrollTop() >= 50 ){
    $('.mm__spread-header  .header-wrapper').addClass('add-background');
  } else{
    $('.mm__spread-header .header-wrapper').removeClass('add-background');
  }
});

$(document).ready(function(){
  if($(window).scrollTop() >= 50 ) {
    $('.mm__spread-header  .header-wrapper').addClass('add-background');
  } else {
    $('.mm__spread-header .header-wrapper').removeClass('add-background');
  } 

  $('.spreads-header-logo').on("click",function(){
    $('html, body').animate({
      scrollTop: $('.mm__spreads-products').offset().top
    }, 1000);
  });

  $('.mm_spread_header-hamburger').on('click', function(){
    $('#SpreadDrawer').addClass('open_mobile_menu');
    $('.site-header__cart.mm-ajaxcart-open').hide();
    $(".mm_spread_header-hamburger-close").show();
  });

  $('.mm_spread_header-hamburger-close').on('click', function(){
    $('#SpreadDrawer').removeClass('open_mobile_menu');
    $('body').removeClass('prevent-scrolling');
    $('.site-header__cart.mm-ajaxcart-open').show();
    $(".mm_spread_header-hamburger-close").hide();
  });

  var currentLocation = window.location.href.replace('https://epigamiastore.com','');
  $('.mm__spread-header .site-nav__item a , .spread-mobile-nav__link').removeClass('active__link');
  $('.mm__spread-header .site-nav__item a , .spread-mobile-nav__link').each(function(){
    var link = $(this).attr('href').replace('https://epigamiastore.com','');
    if(link == currentLocation){
      $(this).addClass('active__link');
      return true;
    }
  });

  $('.mm__spread-header .site-nav__item a , .spread-mobile-nav__link').on('click', function(){
    $('.mm__spread-header .site-nav__item a , .spread-mobile-nav__link').removeClass('active__link');
    $(this).addClass('active__link');
    $('.mm_spread_header-hamburger-close').click();
  });
});
  
    
/*=============================================================================
 * ABOUT US PAGE
 =============================================================================*/         
$(document).ready(function(){ 
 if($(window).width()<750){ 
  $('.leader__section-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1
  });
   $('.glimpse__section-slider').slick({
     dots: true,
     arrows: false,
     infinite: true,
     speed: 2000,
     slidesToShow: 1,
     slidesToScroll: 1
   });
 } 
});
    

/*=============================================================================
 * ACCOUNT PAGE
 =============================================================================*/     
$(document).ready(function() {
  var accountPage = {
    feedbackPopup: function() {
      // Popup enable code      
      $('.share-feedback-btn').on('click',function(e){
        e.preventDefault();
        var $this = $(this).closest('tr');
        var orderId = $this.find('[data-label="Order"] .account_orderId').text();
        var itemsList = $this.find('[data-label="items"]').html();
        var orderValue = $this.find('[data-label="Total"] .total-money').text();
        var orderDate = $this.find('[data-label="Date"] .time').text();
        var orderStatus = $this.find('[data-label="Fulfillment Status"] .status-label').text();
        var orderPhone = $this.find('.order-contact').text();

        $(".feedback-id-order span:last-child").text(orderId);
        $(".feedback-id-item span:last-child").html(itemsList);
        $(".feedback-id-total").text(orderValue);
        $(".feedback-id-status span:last-child").text(orderStatus);
        $(".feedback-id-date span:last-child").text(orderDate);
        $(".js-post-feedback").attr('data-customer-phone', orderPhone);

        $("body").css("overflow","hidden");
        $('#feedback-wrapper').css({'visibility':'visible','opacity':1,});
        $('#feedback-wrapper').addClass('show-feedback-popup');
      });

      $("#feedback-wrapper .close-popup, #feedback-submit-wrapper .close-popup").click(function(e){
        $(this).closest('.overlay').css({"visibility":"hidden","opacity":"0"});
        $("body").css("overflow","unset");
        $('#feedback-wrapper, #feedback-submit-wrapper').removeClass('show-feedback-popup');
      });

      //Floating label script
      $('.form-field').each(function() {
        var field = $(this);
        var input = field.find('.input-field');
        var label = field.find('label');
        function checkInput() {
          var valueLength = input.val().length;
          if (valueLength > 0 ) {
            label.addClass('float')
            $('.feedback-wrapper [type="submit"]').removeClass('disable');
          } else {
            label.removeClass('float')
            $('.feedback-wrapper [type="submit"]').addClass('disable');
          }
        }
        input.keyup(function() {
          checkInput()
        })
      });


      //Post feedback button click
      $('.js-post-feedback').on(
        'click',
        function(evt) {
          evt.preventDefault();
          $(this).addClass('disable');

          var parentEl = $(this).parents('#feedback-wrapper');          
          var oderId = parentEl.find('.js-order-id').text();
          var oderDate = parentEl.find('.js-order-date').text();
          var oderAmount = parentEl.find('.js-order-total').text();
          var oderStatus = parentEl.find('.js-order-status').text();
          var oderFeedback = parentEl.find('.js-order-feedback textarea').val();
          var customerEmail = $(this).data('customer-email');
          var customerName = $(this).data('customer-name');
          var customerPhone = $(this).data('customer-phone');
          var oderItems = [];

          $('#feedback-wrapper .js-order-items p').each(function() {
            oderItems.push($(this).text());
          })         
          oderItems = oderItems.toString();

          var d = new Date();
          var currentDate = d.getDate() + "-" + (d.getMonth()+1) + "-" + d.getFullYear();
          
          var data = {
            'Date': currentDate,
            'Order Number': oderId,
            'Customer Email': customerEmail,
            'Customer Name': customerName,
            'Customer Phone': customerPhone,
            'Order Items': oderItems,
            'Feedback': oderFeedback
          }

          var sheetUrl = 'https://script.google.com/macros/s/AKfycbxG4e5HUkqMts9iRJkXYGJ_FI_O1zEmo5iKTAILlNJP-kgazmc/exec';
          request = $.ajax({
            url: sheetUrl,
            type: "post",
            data: data
          });
          request.done(function (response, textStatus, jqXHR){
            $("body").css("overflow","unset");
            $('#feedback-wrapper').css({'visibility':'hidden','opacity':0});
            $('#feedback-wrapper').removeClass('show-feedback-popup');

            //Show thank you popup
            $("body").css("overflow","hidden");
            $('#feedback-submit-wrapper').css({'visibility':'visible','opacity':1});
            $('#feedback-submit-wrapper').addClass('show-feedback-submit');
          });
        }
      );
    }
  }
  accountPage.feedbackPopup();
  
    if(theme.templateName == 'april-fool'){
    var aprilFool = {
      customerGuess: function() {
        var input = $('#comment-box');

        function checkInput() {
          $('#comment_blank_error').html('');
          var valueLength = input.val().length;
          if (valueLength > 0 ) {
          } else {
            $('#comment_blank_error').html('Comment can not be blank');
          }
        }

        input.keyup(function() {
          checkInput();
        })

        //Post feedback button click
        $('.js-april-launch').on('click', function(evt) {
          evt.preventDefault();

          $('#comment_blank_error').html('');
          
          var launchCustomerGuess = $('#comment-box').val();

          var date = new Date();
          var currentDate = date.getDate() + "-" + (date.getMonth()+1) + "-" + date.getFullYear();

          
          var valueLength = input.val().length;
          if (valueLength > 0 ) {
            var data = {
              'Date': currentDate,
              'Customer Guess': launchCustomerGuess
            }

            var sheetSubmitUrl = 'https://script.google.com/macros/s/AKfycbzPm-nfoQWBT25P5zyIBc_ZNu6Ix5JXD73iBtLJ-mlYId4ZO_0/exec';
            request = $.ajax({
              url: sheetSubmitUrl,
              type: "post",
              data: data
            });

            request.done(function (response, textStatus, jqXHR){
              $('#comment-box').val('');
              $('#comment_submit_message').show();

              setTimeout(function() {
                $("#comment_submit_message").hide();
              }, 3000);
            });
          } else {
            $('#comment_blank_error').html('Comment can not be blank');
          }

        });
      }
    }

    aprilFool.customerGuess();
  }
  
});

    
/*=============================================================================
 * SUBSCRIPTION JS ON DOM CONTENT LOAD
 =============================================================================*/   
    $(document).ready(function(){
      function updatePrice(){
        var totalPrice = 0;
        $('.show-quantity-box').find("input[name='quantity']").each(function() {
          var qty = $(this).val();
          totalPrice = totalPrice + qty*(parseInt($(this).attr('data-product-price')));
        });
        $('#data-frequency-options .subscription-frequency-options').each(function() {
          var discountPercent = $(this).find('[name="repeat-frequency"]').attr('data-discount');
          var discounted_price = totalPrice - (totalPrice * discountPercent / 100);
          $(this).find('[data-original-price]').html('₹ '+ totalPrice);
          $(this).find('[data-discounted-price]').html(' ₹ '+ discounted_price).attr('data-discounted-price',discounted_price).attr('data-discount',discountPercent);
        });
      }

      if(sessionStorage.getItem('repeatIteamFirst')) { 
        if(sessionStorage.getItem('repeatSetType') == 'value'){
          //debugger;
          var repeatProduct = sessionStorage.getItem('repeatIteamFirst');
          var repeatProductUrl = '/products/' + repeatProduct + '.js';
          $.getJSON(repeatProductUrl, function(response) {
            var repeatProductPrice = parseInt(response.price) / 100;
            $('.js-set-item-count').text(repeatProductPrice);
          });
        }else{
          $('.js-set-item-count').text('1');
        }
      }
      
      $('.js-choose-frequency').on('click', function(){
        updatePrice();
        $('.subscription-frequency-modal').addClass('show-modal');
        $('body').addClass('mm-no-scroll');
        $('.mm-ajaxcart-overlay').addClass('has--active'); 
      });

      $('.js-review-selections').on('click', function(){
        $('.subscription-review-selection-modal').addClass('show-review-modal');
        $('.subscription-frequency-modal').removeClass('show-modal');
        $('body').addClass('mm-no-scroll');
        $('.mm-ajaxcart-overlay').addClass('has--active');
        setTimeout(() => {
          getBrandInfo();
        }, 1000);
      });

      $('.mm-ajaxcart-overlay, .js-edit-selections ').on('click', function(){
        $('.subscription-frequency-modal').removeClass('show-modal');
        $('.subscription-review-selection-modal').removeClass('show-review-modal');
      });

      $('.js-edit-selections ').on('click', function(){
        $('.mm-ajaxcart-overlay').click();
        $('.subscription-frequency-modal').removeClass('show-modal');
        $('.subscription-review-selection-modal').removeClass('show-review-modal');
      });

      $('.repeat-banner-button').click(function() {
        $('html,body').animate({
          scrollTop: $('#subscriptionRepeatsSet').offset().top - 120},'slow');
      });
      
      if($(window).width() < 750){ 
//         debugger;
        $('.section__details-slider-dp').slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
      
    });
    
    $('#js-repeat-remove').on('click', function(){
    });
    
    // mobile infinite scroll more products shown on mobile
    $(document).ready(function(){

      if ($(window).innerWidth() < 749 ){
        var element_position = $('#mm-pagination-holder').offset().top;
        var screen_height = $(window).height();
        var activation_offset = 0.5;//determines how far up the the page the element needs to be before triggering the function
        var activation_point = element_position - (screen_height * activation_offset);
        var max_scroll_height = $('body').height() - screen_height - 5;//-5 for a little bit of buffer

        //Does something when user scrolls to it OR
        //Does it when user has reached the bottom of the page and hasn't triggered the function yet
        $(window).on('scroll', function() {
          var y_scroll_pos = window.pageYOffset;

          var element_in_view = y_scroll_pos > activation_point;
          var has_reached_bottom_of_page = max_scroll_height <= y_scroll_pos && !element_in_view;

          if(element_in_view || has_reached_bottom_of_page) {
            //Do something
            $("#mm-pagination-holder .pageNext").click();
          }
        });

      }
    });
    
    
    
/* video section */    
    
$(document).ready(function(){
  
   $(".mm-hp-video video").trigger('pause');
  
   $('.mm-video-close').on('click', function(event) {
      $('.mm-video-modal').hide();
      $(".mm-video-modal-content video").trigger('pause');
      document.body.classList.remove('overflowHidden');
    })

    $('.mm-hp-video').on('click', function(event) {
      let videoToPlay = $(this).find('source').attr('src');
      $( ".mm-video-modal-content video" ).hide();
      $( ".mm-video-modal-content video" ).each(function() {
        let modelVideo = $(this).find('source').attr('src');
        if(videoToPlay == modelVideo){
          $(this).show();
          $(this).attr("controls","controls") 
          $(this).trigger('play');
          return false;
        }   
      });
      $('.mm-video-modal').show();
      document.body.classList.add('overflowHidden');

    })

    if (screen.width < 750) {
      $('.mm-hp-videos-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }

});

// sale timer code goes here
$(document).ready(function(){
      function makeTimer() {

        var saleStartTime = new Date(''+ startdate +' GMT+0530');	
        saleStartTime = (Date.parse(saleStartTime) / 1000);
        
        var saleEndTime = new Date(''+ enddate +' GMT+0530');			
        saleEndTime = (Date.parse(saleEndTime) / 1000);

        var now = new Date();
        now = (Date.parse(now) / 1000);

        if(now > saleStartTime){
          var timeLeft = saleEndTime - now;

          var days = Math.floor(timeLeft / 86400); 
          var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
          var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
          var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

          if (days < "10") { days = "0" + days; }
          if (hours < "10") { hours = "0" + hours; }
          if (minutes < "10") { minutes = "0" + minutes; }
          if (seconds < "10") { seconds = "0" + seconds; }

          $(".js-sale-end-days").html(days);
          $(".js-sale-end-hours").html(hours);
          $(".js-sale-end-minutes").html(minutes);
          $(".js-sale-end-secs").html(seconds);
          
          $('.before-sale-container').hide();
          $('.during-sale-container').show();
        }
        
        if(now < saleStartTime){
          var timeLeft = saleStartTime - now;

          var days = Math.floor(timeLeft / 86400); 
          var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
          var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
          var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

          if (hours < "10") { hours = "0" + hours; }
          if (minutes < "10") { minutes = "0" + minutes; }
          if (seconds < "10") { seconds = "0" + seconds; }

          $(".js-sale-start-days").html(days);
          $(".js-sale-start-hours").html(hours);
          $(".js-sale-start-minutes").html(minutes);
          $(".js-sale-start-secs").html(seconds);
          
          $('.before-sale-container').show();
          $('.during-sale-container').hide();
        }

      }

      setInterval(function() { makeTimer(); }, 1000);
    });


// Career Page Sticky Navigation
if((window.location.href).includes("/career-page")){
  
class StickyNavigation {

  constructor() {
      this.currentId = null;
      this.currentTab = null;
      this.tabContainerHeight = 70;
      this.lastScroll = 0;
      let self = this;
      this.isIntersecting();
      $('.sticky-nav-tab').click(function() { 
          self.onTabClick(event, $(this)); 
      });
      $(window).scroll(() => { this.onScroll(); });
      $(window).resize(() => { this.onResize(); });
  }
  
  onTabClick(event, element) {
      event.preventDefault();
      let scrollTop = $(element.attr('href')).offset().top - this.tabContainerHeight + 1;
      $('html, body').animate({ scrollTop: scrollTop }, 600);
  }
  
  onScroll() {
    this.checkHeaderPosition();
    this.lastScroll = $(window).scrollTop();
  }
  
  onResize() {
      if(this.currentId) {
          this.setSliderCss();
      }
  }
  
  checkHeaderPosition() {
      const headerHeight = 75;
      if($(window).scrollTop() > headerHeight) {
          $('.spa-header').addClass('spa-header--scrolled');
      } else {
          $('.spa-header').removeClass('spa-header--scrolled');
      }
      let offset = ($('.sticky-nav-tabs').offset().top + $('.sticky-nav-tabs').height() - this.tabContainerHeight) - headerHeight;
      if($(window).scrollTop() > this.lastScroll && $(window).scrollTop() > offset) {
          $('.spa-header').addClass('spa-header--move-up');
          $('.sticky-nav-tabs-container').removeClass('sticky-nav-tabs-container--top-first');
          $('.sticky-nav-tabs-container').addClass('sticky-nav-tabs-container--top-second');
      } 
      else if($(window).scrollTop() < this.lastScroll && $(window).scrollTop() > offset) {
          $('.spa-header').removeClass('spa-header--move-up');
          $('.sticky-nav-tabs-container').removeClass('sticky-nav-tabs-container--top-second');
          $('.sticky-nav-tabs-container').addClass('sticky-nav-tabs-container--top-first');
      }
      else {
          $('.spa-header').removeClass('spa-header--move-up');
          $('.sticky-nav-tabs-container').removeClass('sticky-nav-tabs-container--top-first');
          $('.sticky-nav-tabs-container').removeClass('sticky-nav-tabs-container--top-second');
      }
  }

  isIntersecting(){
    document.querySelectorAll('.sticky-nav-tab').forEach(function(navElem) {
      let targetClass = $(navElem).attr("href").replace("#", ".")
      console.log(targetClass, 'targetClass');
      const intersectionObserver = new IntersectionObserver((entries) => {
        // If intersectionRatio is 0, the target is out of view
        // and we do not need to do anything.
        if (entries[0].intersectionRatio <= 0){
          // document.querySelectorAll('.sticky-nav-tab').forEach(function(navElem) { navElem.classList.remove("nav-active")})
          return
        }
        document.querySelectorAll('.sticky-nav-tab').forEach(function(navElem) { navElem.classList.remove("nav-active") })
        navElem.classList.add("nav-active")
      });
      // start observing
      document.querySelectorAll(targetClass).forEach( elem => intersectionObserver.observe(elem))
    });
  }
  
}

new StickyNavigation();
}


// custom video


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".video-block").forEach(block => {
    const thumbnail = block.querySelector(".video-thumbnail");
    const video = block.querySelector(".video-player");

    if (!video) return;

    // play on click
    thumbnail?.addEventListener("click", () => {
      thumbnail.style.display = "none";
      video.play();
    });

    // show thumbnail again on pause or end
    video.addEventListener("pause", () => {
      thumbnail.style.display = "flex";
    });

    video.addEventListener("ended", () => {
      thumbnail.style.display = "flex";
    });

    // redirect if URL is set
    const redirectUrl = block.getAttribute("data-redirect");
    if (redirectUrl) {
      video.addEventListener("click", () => {
        window.location.href = redirectUrl;
      });
    }
  });
});

/*js for pincode */
$(document).on('click', '.js-open-pincode', function(e) {
e.preventDefault();

$('#pincodeModalContent').show().addClass('show--pincheck');

$('.mm__pincode-content').hide();
$('.mm__pincode-content[data-pincode-check]').css('display', 'block');

$('.mm-ajaxcart-overlay').addClass('has--active');
$('body').addClass('mm-no-scroll');
});